import React from 'react';

export const IconSpinner = ({ size, fillColor, marginSvg = '' }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={{ margin: marginSvg ? marginSvg : 'auto', background: 'none', display: 'block', shapeRendering: 'auto' }}
      width={size}
      height={size}
      viewBox='0 0 100 100'
      preserveAspectRatio='xMidYMid'
    >
      <circle
        cx='50'
        cy='50'
        fill='none'
        stroke={fillColor}
        strokeWidth='8'
        r='35'
        strokeDasharray='164.93361431346415 56.97787143782138'
        transform='rotate(358.835 49.9991 49.9991)'
      >
        <animateTransform attributeName='transform' type='rotate' repeatCount='indefinite' dur='0.7142857142857142s' values='0 50 50;360 50 50' keyTimes='0;1' />
      </circle>
    </svg>
  );
};

export const IconSpinnerDefault = ({ fillColor, marginSvg = '' }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={{ margin: marginSvg ? marginSvg : 'auto', background: 'none', display: 'block', shapeRendering: 'auto' }}
      width='24px'
      height='24px'
      viewBox='0 0 100 100'
      preserveAspectRatio='xMidYMid'
    >
      <circle cx='50' cy='50' fill='none' stroke={fillColor} strokeWidth='12' r='35' strokeDasharray='164.93361431346415 56.97787143782138' transform='rotate(22.5164 50 50)'>
        <animateTransform attributeName='transform' type='rotate' repeatCount='indefinite' dur='0.6666666666666666s' values='0 50 50;360 50 50' keyTimes='0;1' />
      </circle>
    </svg>
  );
};

export const IconCloseSVG = ({ isActive = false }) => {
  return (
    <svg height='12' viewBox='0 0 512 512' width='12' xmlns='http://www.w3.org/2000/svg'>
      <path fill={isActive ? '#000' : '#9EA1A8'} d='m25 512a25 25 0 0 1 -17.68-42.68l462-462a25 25 0 0 1 35.36 35.36l-462 462a24.93 24.93 0 0 1 -17.68 7.32z' />
      <path fill={isActive ? '#000' : '#9EA1A8'} d='m487 512a24.93 24.93 0 0 1 -17.68-7.32l-462-462a25 25 0 0 1 35.36-35.36l462 462a25 25 0 0 1 -17.68 42.68z' />
    </svg>
  );
};

export const IconArrowUp = () => {
  return (
    <svg width='8' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 448 490'>
      <path d='M34.9 289.5l-22.2-22.2c-9.4-9.4-9.4-24.6 0-33.9L207 39c9.4-9.4 24.6-9.4 33.9 0l194.3 194.3c9.4 9.4 9.4 24.6 0 33.9L413 289.4c-9.5 9.5-25 9.3-34.3-.4L264 168.6V456c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24V168.6L69.2 289.1c-9.3 9.8-24.8 10-34.3.4z' />
    </svg>
  );
};

export const IconFriendlySVG = () => {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M10 16H7C4.79086 16 3 14.2091 3 12V12C3 9.79086 4.79086 8 7 8H10'
        stroke='#5c5c5c'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        transform='rotate(135, 12, 12)'
      />
      <path d='M16 12H8' stroke='#5c5c5c' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' transform='rotate(135, 12, 12)' />
      <path
        d='M14 16H17C19.2091 16 21 14.2091 21 12V12C21 9.79086 19.2091 8 17 8H14'
        stroke='#5c5c5c'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        transform='rotate(135, 12, 12)'
      />
    </svg>
  );
};

export const IconAudienceSVG = ({ size = 30, isActive = false }) => {
  return (
    <svg width={size} height={size} viewBox='0 0 1080 1080' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M515.742 602.201C566.975 619.847 614.466 659.644 645.402 724.278C653.183 740.533 651.215 748.749 649.241 753.286C646.44 759.725 638.582 769.469 619.869 779.862C581.902 800.948 518.455 813.882 449.78 813.896C381.068 813.91 317.912 800.989 280.418 780.008C261.966 769.683 254.455 760.092 251.849 753.899C250.025 749.564 248.066 741.3 256.201 724.769C287.865 660.427 335.5 620.649 386.549 602.717C369.288 594.272 353.558 582.517 339.969 568.152C288.316 594.11 242.481 638.95 211.114 702.689C105.21 917.891 793.618 917.65 690.728 702.689C659.912 638.308 614.033 593.188 562.033 567.348C548.546 581.787 532.913 593.636 515.742 602.201Z'
        fill={isActive ? '#000' : '#9EA1A8'}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M450.364 567.75C506.426 567.75 563.182 513.336 563.182 431.313C563.182 349.29 506.426 294.876 450.364 294.876C394.301 294.876 337.545 349.29 337.545 431.313C337.545 513.336 394.301 567.75 450.364 567.75ZM613.409 431.313C613.409 534.337 540.411 617.854 450.364 617.854C360.316 617.854 287.318 534.337 287.318 431.313C287.318 328.289 360.316 244.771 450.364 244.771C540.411 244.771 613.409 328.289 613.409 431.313Z'
        fill={isActive ? '#000' : '#9EA1A8'}
      />
      <path
        d='M745.924 394.774C745.924 470.904 694.178 521.485 642.529 523.389C640.524 523.463 638.524 523.662 636.562 524.082C635.9 524.225 635.246 524.364 634.603 524.501C627.238 526.063 620.944 531.07 617.227 537.601C608.778 552.444 614.892 572.422 631.978 573.346C634.474 573.481 636.986 573.549 639.512 573.549C726.022 573.549 796.152 493.509 796.152 394.774C796.152 296.04 726.022 216 639.512 216C616.756 216 595.133 221.538 575.621 231.499C562.096 238.403 562.611 256.666 573.444 267.294C581.829 275.52 594.959 277.484 605.824 272.994C616.739 268.483 628.152 266.104 639.512 266.104C692.144 266.104 745.924 317.163 745.924 394.774Z'
        fill={isActive ? '#000' : '#9EA1A8'}
      />
      <path
        d='M726.787 764.763C723.562 780.205 735.302 801.485 750.725 798.002C841.851 777.424 905.656 729.864 869.907 655.353C834.945 582.485 779.776 535.391 718.584 514.104C713.627 512.38 708.183 513.001 703.615 515.581C686.615 525.188 693.087 557.516 711.181 564.873C756.056 583.119 797.155 619.779 824.601 676.984C831.842 692.075 829.841 699.25 828.252 702.895C825.824 708.462 818.717 717.5 800.97 727.332C785.246 736.045 764.854 743.31 741.399 748.732C733.776 750.494 728.383 757.122 726.787 764.763Z'
        fill={isActive ? '#000' : '#9EA1A8'}
      />
    </svg>
  );
};

export const IconAccountSettingsSVG = ({ size = 24, color = '#9EA1A8', isActive = false, width = 30, height = 30 }) => {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='12' cy='12' r='3' stroke={color} strokeWidth='1.5' />
      <path
        d='M13.7654 2.15224C13.3978 2 12.9319 2 12 2C11.0681 2 10.6022 2 10.2346 2.15224C9.74457 2.35523 9.35522 2.74458 9.15223 3.23463C9.05957 3.45834 9.0233 3.7185 9.00911 4.09799C8.98826 4.65568 8.70226 5.17189 8.21894 5.45093C7.73564 5.72996 7.14559 5.71954 6.65219 5.45876C6.31645 5.2813 6.07301 5.18262 5.83294 5.15102C5.30704 5.08178 4.77518 5.22429 4.35436 5.5472C4.03874 5.78938 3.80577 6.1929 3.33983 6.99993C2.87389 7.80697 2.64092 8.21048 2.58899 8.60491C2.51976 9.1308 2.66227 9.66266 2.98518 10.0835C3.13256 10.2756 3.3397 10.437 3.66119 10.639C4.1338 10.936 4.43789 11.4419 4.43786 12C4.43783 12.5581 4.13375 13.0639 3.66118 13.3608C3.33965 13.5629 3.13248 13.7244 2.98508 13.9165C2.66217 14.3373 2.51966 14.8691 2.5889 15.395C2.64082 15.7894 2.87379 16.193 3.33973 17C3.80568 17.807 4.03865 18.2106 4.35426 18.4527C4.77508 18.7756 5.30694 18.9181 5.83284 18.8489C6.07289 18.8173 6.31632 18.7186 6.65204 18.5412C7.14547 18.2804 7.73556 18.27 8.2189 18.549C8.70224 18.8281 8.98826 19.3443 9.00911 19.9021C9.02331 20.2815 9.05957 20.5417 9.15223 20.7654C9.35522 21.2554 9.74457 21.6448 10.2346 21.8478C10.6022 22 11.0681 22 12 22C12.9319 22 13.3978 22 13.7654 21.8478C14.2554 21.6448 14.6448 21.2554 14.8477 20.7654C14.9404 20.5417 14.9767 20.2815 14.9909 19.902C15.0117 19.3443 15.2977 18.8281 15.781 18.549C16.2643 18.2699 16.8544 18.2804 17.3479 18.5412C17.6836 18.7186 17.927 18.8172 18.167 18.8488C18.6929 18.9181 19.2248 18.7756 19.6456 18.4527C19.9612 18.2105 20.1942 17.807 20.6601 16.9999C21.1261 16.1929 21.3591 15.7894 21.411 15.395C21.4802 14.8691 21.3377 14.3372 21.0148 13.9164C20.8674 13.7243 20.6602 13.5628 20.3387 13.3608C19.8662 13.0639 19.5621 12.558 19.5621 11.9999C19.5621 11.4418 19.8662 10.9361 20.3387 10.6392C20.6603 10.4371 20.8675 10.2757 21.0149 10.0835C21.3378 9.66273 21.4803 9.13087 21.4111 8.60497C21.3592 8.21055 21.1262 7.80703 20.6602 7C20.1943 6.19297 19.9613 5.78945 19.6457 5.54727C19.2249 5.22436 18.693 5.08185 18.1671 5.15109C17.9271 5.18269 17.6837 5.28136 17.3479 5.4588C16.8545 5.71959 16.2644 5.73002 15.7811 5.45096C15.2977 5.17191 15.0117 4.65566 14.9909 4.09794C14.9767 3.71848 14.9404 3.45833 14.8477 3.23463C14.6448 2.74458 14.2554 2.35523 13.7654 2.15224Z'
        stroke={color}
        strokeWidth='1.5'
      />
    </svg>
  );
};

export const IconSettingsSVG = ({ isActive = false, width = 30, height = 30 }) => {
  return (
    <svg width={width} height={height} viewBox='0 0 1080 1080' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M509.305 202.087C509.978 202.029 510.653 202 511.328 202H568.759C569.433 202 570.107 202.029 570.779 202.087C579.113 202.808 592.178 205.1 603.7 213.213C616.633 222.321 625.193 237.095 625.193 256.871V280.249L625.194 280.252C625.261 280.381 625.458 280.732 626.038 281.222C626.614 281.709 628.001 282.697 630.867 283.613C631.875 283.929 633.884 284.57 636.173 285.685C644.784 288.911 653.378 292.559 661.851 296.785C662.059 296.876 662.266 296.971 662.472 297.069L684.686 274.876C684.779 274.778 684.874 274.682 684.969 274.586L686.329 273.219C686.557 272.99 686.79 272.766 687.027 272.547C690.521 269.314 698.933 262.413 711.136 260.186C725.173 257.625 739.972 261.992 752.581 274.595L806.43 328.447C806.716 328.733 806.996 329.028 807.267 329.329C810.94 333.404 817.804 342.273 819.636 354.907C821.704 369.164 816.76 383.712 804.295 396.187L788.624 411.87C788.383 412.121 788.135 412.368 787.882 412.61L787.201 413.281C786.734 413.786 785.74 415.028 785.193 416.612C784.937 417.353 784.78 418.158 784.797 419.097C784.813 420.003 784.995 421.471 785.875 423.588C786.039 423.979 786.192 424.373 786.334 424.768C789.992 432.594 793.326 440.638 796.254 448.919C796.742 450.017 797.151 451.163 797.471 452.352C797.482 452.383 797.494 452.416 797.507 452.451L797.531 452.518C797.562 452.602 797.598 452.7 797.638 452.809C797.71 452.893 797.821 453 797.988 453.119L797.989 453.12C798.235 453.296 800.364 454.815 806.615 454.815H832.977C833.659 454.815 834.34 454.845 835.02 454.904C841.75 455.493 853.115 457.938 862.852 467.398C873.019 477.277 878 491.448 878 508.586V569.947C878 590.594 870.314 606.013 857.629 615.429C846.276 623.854 834.121 625.028 829.027 625.192C828.774 625.201 828.521 625.205 828.269 625.205H805.648C805.631 625.205 805.615 625.205 805.598 625.205C805.478 625.21 805.185 625.228 804.766 625.279C803.805 625.394 802.512 625.642 801.216 626.111C798.849 626.966 797.505 628.05 796.638 630.144C796.494 630.517 796.347 630.871 796.2 631.205C793.383 639.132 790.205 646.85 786.719 654.384C786.204 655.862 785.54 657.292 784.731 658.653C784.272 659.61 783.796 660.592 783.302 661.59C783.305 661.619 783.309 661.643 783.313 661.664C783.327 661.74 783.39 662.049 783.701 662.618C784.02 663.203 784.7 664.24 786.104 665.643L810.314 689.845C811.177 690.708 811.972 691.637 812.691 692.624C816.934 698.449 821.711 707.844 821.092 719.979C820.46 732.362 814.423 743.592 804.744 753.266L799.914 748.433C799.913 748.437 799.912 748.442 799.911 748.447L804.731 753.265L752.658 805.354C752.55 805.464 752.439 805.574 752.328 805.684C752.147 805.86 751.967 806.03 751.788 806.194C744.381 813.375 735.746 817.85 726.415 819.312C717.092 820.773 708.872 818.951 702.693 816.531C696.575 814.136 691.769 810.897 688.629 808.459C687.01 807.202 685.698 806.051 684.734 805.156C684.248 804.705 683.843 804.311 683.521 803.99C683.512 803.981 683.503 803.972 683.494 803.963C683.425 803.896 683.356 803.828 683.288 803.76L666.618 787.104C666.032 786.769 665.173 786.344 664.127 785.995C661.917 785.258 659.038 784.852 655.251 786.438L655.212 786.454C654.56 786.725 653.967 786.944 653.474 787.113C646.154 790.489 638.662 793.56 630.981 796.275C630.719 796.391 630.454 796.503 630.186 796.611C628.383 797.374 627.361 798.11 626.811 798.585C626.246 799.073 625.947 799.486 625.765 799.794C625.451 800.322 625.276 800.916 625.193 801.432L625.193 831.767L625.193 831.805V831.821C625.193 831.858 625.192 831.896 625.192 831.937C625.192 832.017 625.191 832.103 625.19 832.196C625.187 832.382 625.183 832.594 625.175 832.83C625.159 833.3 625.131 833.871 625.082 834.529C624.985 835.836 624.8 837.532 624.447 839.498C623.76 843.329 622.337 848.747 619.247 854.409C616.084 860.206 611.087 866.392 603.455 871.033C595.778 875.701 586.758 878 576.835 878H494.149C492.62 878 491.096 877.851 489.596 877.554C474.746 874.616 465.253 865.652 460.166 856.08C455.605 847.495 454.9 839.186 454.819 835.35C454.816 835.186 454.814 835.023 454.814 834.859V801.931C454.814 800.129 454.566 799.129 454.43 798.705C454.359 798.482 454.298 798.353 454.267 798.294C454.237 798.235 454.218 798.21 454.213 798.204C454.213 798.204 454.21 798.199 454.205 798.193C454.189 798.175 454.148 798.131 454.054 798.062C454.025 798.04 453.993 798.018 453.958 797.994C453.171 797.723 452.377 797.445 451.671 797.198C451.587 797.168 451.503 797.139 451.422 797.11C449.929 796.734 448.49 796.216 447.123 795.57C440.985 793.36 435.037 790.919 429.289 788.365C426.709 787.503 424.486 786.414 422.808 785.511C422.777 785.494 422.745 785.477 422.713 785.459L422.646 785.423C420.805 784.413 419.579 784.097 418.937 783.989C418.308 783.883 417.904 783.919 417.622 783.971C417.089 784.069 416.377 784.357 415.559 784.914L394.51 805.961L394.479 805.993C381.784 818.639 367.431 822.812 354.394 820.922C348.528 820.071 343.834 818.115 340.577 816.367C338.927 815.482 337.569 814.609 336.52 813.872C336.138 813.603 335.793 813.349 335.485 813.116C334.552 812.426 333.666 811.665 332.836 810.835L269.283 747.279C269.128 747.125 268.976 746.968 268.826 746.81C259.569 737.3 255.744 725.561 257.433 713.851C258.92 703.542 264.295 695.983 267.617 692.026C268.056 691.504 268.517 691.001 268.999 690.519L292.08 667.446C292.18 667.344 292.285 667.239 292.393 667.132C294.363 665.139 295.36 663.624 295.857 662.695C296.298 661.871 296.421 661.371 296.457 661.185C296.441 661.153 296.426 661.122 296.411 661.09C295.889 660.175 295.433 659.231 295.043 658.266C290.03 647.9 285.674 637.202 282.014 626.204C281.903 626.146 281.75 626.073 281.547 625.99C280.894 625.725 280.048 625.5 279.111 625.35C278.316 625.224 277.679 625.188 277.373 625.178H249.677C234.574 625.178 221.714 620.347 212.839 610.5C204.598 601.357 202.578 590.922 202.082 584.978C202.027 584.328 202 583.676 202 583.024V494.602C202 479.834 209.081 468.537 219.319 461.963C227.962 456.413 237.261 455.203 242.347 454.867C242.862 454.832 243.379 454.815 243.895 454.815H277.778C277.99 454.806 278.408 454.775 278.928 454.676C279.563 454.555 280.142 454.371 280.612 454.147C281.041 453.941 281.346 453.719 281.603 453.454C281.821 453.227 282.31 452.659 282.826 451.373C282.919 451.126 283.014 450.89 283.108 450.663C286.208 441.711 289.776 433.015 293.742 424.554C293.995 423.859 294.281 423.175 294.602 422.501C294.649 422.39 294.767 422.102 294.911 421.68C295.225 420.764 295.543 419.571 295.68 418.368C295.82 417.149 295.715 416.455 295.649 416.202C295.646 416.191 295.645 416.183 295.644 416.175C295.641 416.154 295.639 416.139 295.598 416.091C295.556 416.05 295.515 416.009 295.474 415.968L272.127 392.629C271.88 392.382 271.639 392.13 271.404 391.873C259.082 379.086 257.075 363.848 260.533 351.122C263.539 340.061 270.24 332.058 273.405 328.626C273.62 328.393 273.839 328.165 274.063 327.941L328.987 273.007C329.494 272.5 330.024 272.016 330.576 271.558C335.718 267.281 345.235 260.983 358.254 260.238C372.123 259.445 385.449 265.168 397.019 276.564C397.184 276.72 397.333 276.866 397.466 276.999C397.516 277.05 397.566 277.1 397.616 277.15L413.642 293.176C414.119 293.612 415.298 294.542 416.766 295.047C417.444 295.28 418.152 295.413 418.958 295.398C419.732 295.383 421.037 295.227 422.96 294.415C422.961 294.414 422.962 294.413 422.964 294.413C423.394 294.231 423.805 294.07 424.193 293.929C432.978 289.795 442.07 286.021 451.509 282.791C451.69 282.718 451.873 282.646 452.057 282.576C453.309 282.086 454.202 281.634 454.814 281.276V259.791C454.814 259.472 454.821 259.153 454.834 258.835C454.847 258.496 454.859 258.235 454.868 258.026C454.893 257.421 454.901 257.249 454.901 256.871C454.901 237.092 463.464 222.319 476.395 213.213C487.916 205.101 500.978 202.808 509.305 202.087ZM456.026 280.42C456.026 280.42 456.024 280.422 456.018 280.429C456.023 280.423 456.026 280.42 456.026 280.42ZM448.83 284.081C448.824 284.084 448.822 284.085 448.826 284.083L448.828 284.082L448.83 284.081ZM426.273 293.266C426.29 293.261 426.3 293.258 426.286 293.262L426.273 293.266ZM268.499 387.944C268.349 387.685 268.154 387.338 268.066 387.181C268.093 387.23 268.133 387.302 268.189 387.401C268.256 387.523 268.361 387.709 268.499 387.944ZM338.206 439.811C337.886 440.801 337.498 441.775 337.044 442.725C333.258 450.637 329.938 458.682 327.133 466.898C327.105 466.98 327.077 467.062 327.048 467.143C327.025 467.208 327.002 467.272 326.979 467.337C326.776 467.895 326.568 468.403 326.367 468.856C326.34 468.918 326.313 468.979 326.286 469.038C314.153 499.042 285.863 501.6 278.46 501.724C278.329 501.727 278.198 501.728 278.066 501.728H248.912V578.254C249.15 578.261 249.405 578.266 249.677 578.266H277.62C277.739 578.266 277.859 578.267 277.979 578.268C281.55 578.323 290.027 578.805 299.181 582.518C308.636 586.354 319.98 594.224 325.703 609.073C325.722 609.12 325.741 609.166 325.76 609.214C325.943 609.671 326.111 610.134 326.265 610.603C329.483 620.393 333.371 629.906 337.896 639.113C337.958 639.24 338.019 639.366 338.079 639.493C338.106 639.55 338.133 639.606 338.161 639.663C338.548 640.475 338.86 641.116 339.154 641.69C339.461 642.29 339.742 642.902 339.996 643.526C342.265 649.098 344.505 657.87 342.785 668.575C341.038 679.445 335.53 690.274 325.614 700.256C325.486 700.387 325.356 700.517 325.226 700.644L307.105 718.758L361.236 772.89C361.276 772.851 361.316 772.811 361.357 772.771C361.362 772.766 361.366 772.761 361.371 772.756L383.48 750.649C384.044 750.085 384.637 749.549 385.256 749.046C390.359 744.891 398.417 739.797 409.164 737.827C420.25 735.795 432.438 737.427 444.703 744.018C445.52 744.282 446.323 744.592 447.108 744.945C453.095 747.638 459.011 750.055 464.918 752.103C465.29 752.233 465.658 752.371 466.021 752.517C466.675 752.744 467.231 752.94 467.743 753.119C468.685 753.45 469.476 753.728 470.449 754.052C471.201 754.303 471.941 754.592 472.664 754.917C478.26 757.437 485.712 761.995 491.776 770.099C498.055 778.492 501.726 789.209 501.726 801.931V831.088H576.835C577.432 831.088 577.909 831.058 578.28 831.019V800.311C578.28 799.782 578.298 799.254 578.334 798.726C579.105 787.328 584.908 765.089 611.366 753.638C612.275 753.183 613.213 752.788 614.174 752.455C621.204 750.018 628.128 747.182 634.974 743.981C635.664 743.658 636.369 743.37 637.086 743.116C637.438 742.991 637.752 742.888 638.005 742.807C654.11 736.338 668.659 738.053 678.972 741.493C684.117 743.209 688.245 745.352 691.17 747.123C692.645 748.016 693.855 748.84 694.779 749.507C695.242 749.842 695.636 750.141 695.96 750.393C696.122 750.519 696.267 750.634 696.394 750.736C696.458 750.787 696.517 750.835 696.572 750.88L696.65 750.945L696.687 750.975L696.705 750.99C696.714 750.998 696.723 751.005 681.729 769.043L696.723 751.005C697.273 751.462 697.802 751.944 698.308 752.45L716.118 770.245C716.3 770.42 716.479 770.598 716.655 770.779C716.657 770.78 716.658 770.781 716.659 770.782C716.766 770.882 717.025 771.114 717.399 771.404C717.983 771.857 718.581 772.246 719.116 772.53C719.16 772.487 719.206 772.442 719.254 772.394L719.26 772.388C719.456 772.192 719.652 772.003 719.847 771.821L771.554 720.098C771.676 719.976 771.799 719.856 771.924 719.736C772.278 719.37 772.585 719.034 772.85 718.727L752.94 698.824C744.247 690.136 739.106 680.408 737.211 670.351C735.358 660.512 736.905 651.96 738.995 645.783C739.366 644.687 739.817 643.621 740.345 642.591C741.169 640.986 741.983 639.312 742.84 637.511C742.97 637.201 743.108 636.893 743.252 636.588C746.681 629.341 749.723 622.001 752.339 614.526C752.382 614.402 752.426 614.279 752.472 614.156C752.519 614.027 752.568 613.899 752.617 613.771C752.795 613.315 752.974 612.895 753.147 612.51C753.202 612.39 753.255 612.275 753.307 612.166C760.612 594.532 774.436 585.908 785.268 581.992C790.679 580.036 795.589 579.133 799.155 578.703C800.964 578.485 802.502 578.38 803.682 578.331C804.274 578.307 804.782 578.296 805.195 578.293C805.401 578.291 805.585 578.291 805.744 578.292L805.77 578.292H827.712C827.968 578.271 828.376 578.219 828.815 578.101C829.39 577.947 829.635 577.784 829.67 577.758C829.673 577.755 829.674 577.755 829.678 577.751C829.681 577.748 829.685 577.744 829.691 577.736C829.705 577.719 829.822 577.577 829.988 577.218C830.309 576.522 831.088 574.407 831.088 569.947V508.586C831.088 504.948 830.632 502.808 830.295 501.728H806.615C791.955 501.728 779.977 497.9 770.733 491.303C761.655 484.823 756.866 476.854 754.418 471.162C754.137 470.51 753.886 469.845 753.666 469.17C753.67 469.183 753.659 469.148 753.619 469.035C753.576 468.913 753.525 468.773 753.435 468.527L753.406 468.446C753.285 468.116 753.086 467.57 752.873 466.947C752.766 466.672 752.664 466.393 752.567 466.112C749.904 458.379 746.756 450.773 743.187 443.256C743.016 442.896 742.854 442.531 742.701 442.163C742.413 441.467 742.167 440.779 741.957 440.104C729.752 408.72 747.798 386.493 753.701 380.438C753.806 380.33 753.912 380.224 754.019 380.118L754.894 379.255C755.003 379.145 755.093 379.056 755.156 378.994L771.11 363.028C771.901 362.236 772.421 361.603 772.756 361.14C772.727 361.103 772.698 361.067 772.669 361.031L719.417 307.776C719.174 307.533 718.952 307.324 718.752 307.145L718.504 307.394C718.382 307.521 718.258 307.648 718.133 307.773L694.27 331.613C694.273 331.61 694.281 331.602 694.293 331.591C694.265 331.619 694.237 331.647 694.209 331.675L694.194 331.69C694.191 331.693 694.189 331.696 694.186 331.698C694.184 331.7 694.181 331.703 694.179 331.705C694.176 331.708 694.172 331.712 694.169 331.715C682.273 343.596 667.988 345.048 658.427 343.994C653.73 343.476 649.795 342.352 647.049 341.386C645.715 340.916 644.587 340.457 643.703 340.07C643.065 339.816 642.436 339.532 641.817 339.219C634.352 335.445 626.546 332.132 618.407 329.13C617.633 328.844 616.874 328.518 616.135 328.153C599.322 322.658 589.059 312.465 583.557 301.864C580.937 296.817 579.627 292.132 578.967 288.546C578.636 286.743 578.461 285.175 578.371 283.917C578.325 283.286 578.301 282.727 578.289 282.249C578.286 282.108 578.283 281.974 578.282 281.848C578.281 281.758 578.28 281.672 578.28 281.59C578.28 281.526 578.28 281.463 578.28 281.403V256.871C578.28 253.964 577.717 252.768 577.581 252.504C577.451 252.252 577.265 251.975 576.689 251.569C576 251.084 574.797 250.464 572.91 249.914C571.297 249.444 569.495 249.115 567.633 248.912H512.455C510.596 249.115 508.797 249.443 507.186 249.913C505.299 250.464 504.096 251.084 503.406 251.569C502.829 251.976 502.642 252.253 502.512 252.506C502.376 252.77 501.813 253.965 501.813 256.871C501.813 258.289 501.76 259.539 501.726 260.302V286.138C501.726 287.24 501.649 288.342 501.494 289.434C500.636 295.476 498.19 302.857 492.496 309.923C486.999 316.745 479.374 322.16 469.773 326.016C469.062 326.338 468.335 326.623 467.595 326.873C459.308 329.662 451.14 333.05 443.007 336.926C442.417 337.207 441.816 337.464 441.205 337.695C440.855 337.827 440.526 337.942 440.222 338.044C440.203 338.05 440.183 338.056 440.164 338.063C409.15 350.555 386.913 332.568 381.006 326.878C380.9 326.776 380.796 326.674 380.692 326.57L364.596 310.475C364.482 310.366 364.369 310.255 364.257 310.143C362.731 308.616 361.607 307.812 360.933 307.406L307.652 360.695C307.489 360.881 307.318 361.085 307.146 361.303L328.267 382.417C328.396 382.54 328.524 382.665 328.652 382.793C328.728 382.869 328.803 382.946 328.878 383.022C342.262 396.571 343.512 413.014 342.288 423.704C341.669 429.112 340.387 433.689 339.29 436.888C338.911 437.995 338.541 438.975 338.206 439.811ZM363.624 309.474C363.64 309.491 363.666 309.519 363.701 309.557C363.584 309.431 363.538 309.38 363.624 309.474ZM787.382 413.073C787.365 413.088 787.348 413.104 787.331 413.119L787.331 413.118L787.333 413.117L787.336 413.115L787.352 413.099L787.375 413.079L787.382 413.073ZM772.539 396.586L774.575 398.862C773.929 398.14 773.251 397.382 772.539 396.586ZM742.586 441.666C742.607 441.716 742.627 441.765 742.648 441.815C742.631 441.774 742.614 441.733 742.596 441.691C742.593 441.683 742.589 441.674 742.586 441.666ZM741.087 436.209C741.085 436.197 741.084 436.188 741.083 436.184L741.087 436.209ZM805.168 625.2L805.188 625.2L805.226 625.201L805.238 625.201C805.214 625.201 805.191 625.2 805.168 625.2ZM788.173 736.712L788.163 736.675C788.166 736.687 788.17 736.7 788.173 736.712ZM718.274 773.227C718.274 773.227 718.283 773.221 718.301 773.212C718.283 773.223 718.274 773.227 718.274 773.227ZM722.959 769.37C723.162 769.235 723.302 769.147 723.355 769.114L723.364 769.108C723.327 769.131 723.242 769.185 723.134 769.255C723.082 769.289 723.024 769.327 722.959 769.37ZM716.888 771.02C716.891 771.023 716.894 771.026 716.897 771.03L716.891 771.023L716.888 771.02ZM716.932 771.067C716.93 771.065 716.928 771.063 716.926 771.06L716.932 771.067ZM699.874 787.167C716.947 771.082 716.94 771.075 716.932 771.067C716.937 771.072 716.942 771.077 716.947 771.082L699.874 787.167ZM609.437 754.711C609.424 754.719 609.435 754.712 609.461 754.696L609.437 754.711ZM578.28 831.168C578.278 831.183 578.275 831.2 578.272 831.217C578.241 831.387 578.197 831.569 578.144 831.732C578.09 831.897 578.054 831.961 578.066 831.939C578.091 831.893 578.162 831.782 578.28 831.64V831.797L578.28 831.706C578.281 831.683 578.281 831.661 578.281 831.639M579.304 830.828C579.35 830.807 579.376 830.8 579.376 830.8C579.376 830.8 579.354 830.811 579.304 830.828ZM327.645 697.876C327.64 697.882 327.631 697.896 327.617 697.915C327.644 697.878 327.686 697.821 327.645 697.876ZM290.326 669.455C290.22 669.59 290.137 669.7 290.078 669.778C290.115 669.73 290.167 669.661 290.227 669.582C290.255 669.546 290.288 669.503 290.326 669.455ZM243.702 501.936C243.702 501.936 243.713 501.932 243.736 501.925C243.714 501.933 243.702 501.936 243.702 501.936ZM285.869 730.687L285.875 730.687L296.955 719.608L285.869 730.687ZM748.428 808.764C748.368 808.802 748.346 808.816 748.426 808.765L748.428 808.764ZM795.262 633.121C795.251 633.142 795.242 633.159 795.238 633.166L795.237 633.168C795.235 633.171 795.236 633.17 795.238 633.166L795.24 633.162L795.248 633.148L795.262 633.121ZM625.19 281.838C625.19 281.843 625.19 281.848 625.19 281.854L625.19 281.841L625.19 281.838ZM539.93 423.962C476.005 423.962 423.935 476.031 423.935 539.993C423.935 603.972 476.008 656.045 539.93 656.045C603.965 656.045 656.065 603.953 656.072 539.993M377.023 539.993C377.023 450.132 450.086 377.05 539.93 377.05C629.845 377.05 702.984 450.11 702.984 539.993V539.995C702.976 629.886 629.85 702.957 539.93 702.957C450.083 702.957 377.023 629.866 377.023 539.993ZM539.93 423.962C603.97 423.962 656.071 476.051 656.072 539.991Z'
        fill={isActive ? '#000' : '#9EA1A8'}
      />
    </svg>
  );
};

export const IconUpdatesSettingsSVG = ({ size = 24, color = '#9EA1A8', margin = 0 }) => {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M18.7491 9.70957V9.00497C18.7491 5.13623 15.7274 2 12 2C8.27256 2 5.25087 5.13623 5.25087 9.00497V9.70957C5.25087 10.5552 5.00972 11.3818 4.5578 12.0854L3.45036 13.8095C2.43882 15.3843 3.21105 17.5249 4.97036 18.0229C9.57274 19.3257 14.4273 19.3257 19.0296 18.0229C20.789 17.5249 21.5612 15.3843 20.5496 13.8095L19.4422 12.0854C18.9903 11.3818 18.7491 10.5552 18.7491 9.70957Z'
        stroke={color}
        strokeWidth='1.5'
      />
      <path d='M7.5 19C8.15503 20.7478 9.92246 22 12 22C14.0775 22 15.845 20.7478 16.5 19' stroke={color} strokeWidth='1.5' strokeLinecap='round' />
    </svg>
  );
};

export const IconUpdatesSVG = ({ margin = 0 }) => {
  return (
    <svg style={{ margin: margin }} width='24px' height='24px' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M12.02 2.90991C8.70997 2.90991 6.01997 5.59991 6.01997 8.90991V11.7999C6.01997 12.4099 5.75997 13.3399 5.44997 13.8599L4.29997 15.7699C3.58997 16.9499 4.07997 18.2599 5.37997 18.6999C9.68997 20.1399 14.34 20.1399 18.65 18.6999C19.86 18.2999 20.39 16.8699 19.73 15.7699L18.58 13.8599C18.28 13.3399 18.02 12.4099 18.02 11.7999V8.90991C18.02 5.60991 15.32 2.90991 12.02 2.90991Z'
        stroke='#9EA1A8'
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
      />
      <path
        d='M13.87 3.19994C13.56 3.10994 13.24 3.03994 12.91 2.99994C11.95 2.87994 11.03 2.94994 10.17 3.19994C10.46 2.45994 11.18 1.93994 12.02 1.93994C12.86 1.93994 13.58 2.45994 13.87 3.19994Z'
        stroke='#9EA1A8'
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M15.02 19.0601C15.02 20.7101 13.67 22.0601 12.02 22.0601C11.2 22.0601 10.44 21.7201 9.90002 21.1801C9.36002 20.6401 9.02002 19.8801 9.02002 19.0601'
        stroke='#9EA1A8'
        strokeWidth='1.5'
        strokeMiterlimit='10'
      />
    </svg>
  );
};

export const IconAddSiteSVG = ({ margin = 0, color = '#9EA1A8', size = '20' }) => {
  return (
    <svg style={{ margin: margin }} id='Capa_1' enableBackground='new 0 0 24 24' width={size} height={size} viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
      <g id='_x33_'>
        <path
          fill={color}
          d='m18 2c2.206 0 4 1.794 4 4v12c0 2.206-1.794 4-4 4h-12c-2.206 0-4-1.794-4-4v-12c0-2.206 1.794-4 4-4zm0-2h-12c-3.314 0-6 2.686-6 6v12c0 3.314 2.686 6 6 6h12c3.314 0 6-2.686 6-6v-12c0-3.314-2.686-6-6-6z'
        />
      </g>
      <g id='_x32_'>
        <path fill={color} d='m12 18c-.552 0-1-.447-1-1v-10c0-.552.448-1 1-1s1 .448 1 1v10c0 .553-.448 1-1 1z' />
      </g>
      <g id='_x31_'>
        <path fill={color} d='m6 12c0-.552.447-1 1-1h10c.552 0 1 .448 1 1s-.448 1-1 1h-10c-.553 0-1-.448-1-1z' />
      </g>
    </svg>
  );
};

export const IconManageProfilesSVG = ({ size = '24', color = '#9EA1A8', margin }) => {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M19.5617 7C19.7904 5.69523 18.7863 4.5 17.4617 4.5H6.53788C5.21323 4.5 4.20922 5.69523 4.43784 7' stroke={color} strokeWidth='1.5' />
      <path
        d='M17.4999 4.5C17.5283 4.24092 17.5425 4.11135 17.5427 4.00435C17.545 2.98072 16.7739 2.12064 15.7561 2.01142C15.6497 2 15.5194 2 15.2588 2H8.74099C8.48035 2 8.35002 2 8.24362 2.01142C7.22584 2.12064 6.45481 2.98072 6.45704 4.00434C6.45727 4.11135 6.47146 4.2409 6.49983 4.5'
        stroke={color}
        strokeWidth='1.5'
      />
      <path d='M15 18H9' stroke={color} strokeWidth='1.5' strokeLinecap='round' />
      <path
        d='M2.38351 13.793C1.93748 10.6294 1.71447 9.04765 2.66232 8.02383C3.61017 7 5.29758 7 8.67239 7H15.3276C18.7024 7 20.3898 7 21.3377 8.02383C22.2855 9.04765 22.0625 10.6294 21.6165 13.793L21.1935 16.793C20.8437 19.2739 20.6689 20.5143 19.7717 21.2572C18.8745 22 17.5512 22 14.9046 22H9.09536C6.44881 22 5.12553 22 4.22834 21.2572C3.33115 20.5143 3.15626 19.2739 2.80648 16.793L2.38351 13.793Z'
        stroke={color}
        strokeWidth='1.5'
      />
    </svg>
  );
};

export const IconManageSVG = ({ margin }) => {
  return (
    <svg style={{ margin: margin }} fill='#9EA1A8' version='1.1' id='Capa_1' xmlns='http://www.w3.org/2000/svg' width='20px' height='20px' viewBox='0 0 593.842 593.842'>
      <g>
        <g>
          <g>
            <path
              d='M58.64,587.356h396.985c32.059,0,58.141-26.082,58.141-58.141v-23.883h21.436c32.059,0,58.141-26.082,58.141-58.141
  V64.625c0-32.059-26.082-58.14-58.141-58.14H138.217c-32.059,0-58.14,26.082-58.14,58.14v23.884H58.64
  c-32.058,0-58.14,26.082-58.14,58.14v382.567C0.5,561.274,26.582,587.356,58.64,587.356z M470.926,505.333v23.883
  c0,8.451-6.852,15.301-15.301,15.301H58.64c-8.45,0-15.3-6.85-15.3-15.301V239.248h36.736h42.84h348.009v223.245V505.333z
  M455.625,131.349c8.449,0,15.301,6.85,15.301,15.3v49.759H122.917h-42.84H43.34v-49.759c0-8.45,6.85-15.3,15.3-15.3h21.437
  h42.84H455.625L455.625,131.349z M122.917,64.625c0-8.45,6.85-15.3,15.3-15.3h396.984c8.449,0,15.299,6.85,15.299,15.3v382.568
  c0,8.449-6.85,15.299-15.299,15.299h-21.436V146.649c0-32.058-26.082-58.14-58.141-58.14H122.917V64.625z'
            />
            <path
              d='M455.625,587.856H58.64C26.306,587.856,0,561.551,0,529.216V146.649c0-32.334,26.306-58.64,58.64-58.64h20.937V64.625
  c0-32.334,26.306-58.64,58.64-58.64h396.984c32.335,0,58.641,26.306,58.641,58.64v382.567c0,32.335-26.306,58.641-58.641,58.641
  h-20.936v23.383C514.266,561.551,487.96,587.856,455.625,587.856z M58.64,89.009C26.857,89.009,1,114.866,1,146.649v382.567
  c0,31.783,25.857,57.641,57.64,57.641h396.985c31.783,0,57.641-25.857,57.641-57.641v-24.383h21.936
  c31.783,0,57.641-25.857,57.641-57.641V64.625c0-31.783-25.857-57.64-57.641-57.64H138.217c-31.783,0-57.64,25.857-57.64,57.64
  v24.384H58.64z M455.625,545.017H58.64c-8.712,0-15.8-7.088-15.8-15.801V238.748h428.585v290.468
  C471.426,537.929,464.338,545.017,455.625,545.017z M43.84,239.748v289.468c0,8.161,6.639,14.801,14.8,14.801h396.985
  c8.161,0,14.801-6.64,14.801-14.801V239.748H43.84z M535.201,462.991h-21.936V146.649c0-31.783-25.857-57.64-57.641-57.64
  H122.417V64.625c0-8.712,7.088-15.8,15.8-15.8h396.984c8.712,0,15.799,7.088,15.799,15.8v382.568
  C551,455.904,543.913,462.991,535.201,462.991z M514.266,461.991h20.936c8.16,0,14.799-6.639,14.799-14.799V64.625
  c0-8.161-6.639-14.8-14.799-14.8H138.217c-8.161,0-14.8,6.639-14.8,14.8v23.385h332.208c32.335,0,58.641,26.306,58.641,58.64
  V461.991z M471.426,196.908H42.84v-50.259c0-8.712,7.088-15.8,15.8-15.8h396.985c8.713,0,15.801,7.088,15.801,15.8V196.908z
  M43.84,195.908h426.585v-49.259c0-8.161-6.64-14.8-14.801-14.8H58.64c-8.161,0-14.8,6.639-14.8,14.8V195.908z'
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const IconSchedulerSVG = ({ isActive = false, width = 28, height = 28 }) => {
  return (
    <svg width={width} height={height} viewBox='0 0 100 100' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <mask id='path-1-inside-1_1415_513' fill='white'>
        <path d='M10 26C10 20.4772 14.4772 16 20 16H80C85.5228 16 90 20.4772 90 26V40C90 40.5523 89.5523 41 89 41H11C10.4477 41 10 40.5523 10 40V26Z' />
      </mask>
      <path
        d='M10 26C10 20.4772 14.4772 16 20 16H80C85.5228 16 90 20.4772 90 26V40C90 40.5523 89.5523 41 89 41H11C10.4477 41 10 40.5523 10 40V26Z'
        stroke={isActive ? '#000' : '#9EA1A8'}
        strokeWidth='10'
        strokeLinejoin='round'
        mask='url(#path-1-inside-1_1415_513)'
      />
      <path d='M30 13V27' stroke={isActive ? '#000' : '#9EA1A8'} strokeWidth='5' strokeLinecap='round' />
      <path d='M12.5 38.5H87.5V80C87.5 84.1421 84.1421 87.5 80 87.5H20C15.8579 87.5 12.5 84.1421 12.5 80V38.5Z' stroke={isActive ? '#000' : '#9EA1A8'} strokeWidth='5' />
      <path d='M34 55L24 55' stroke={isActive ? '#000' : '#9EA1A8'} strokeWidth='5' strokeLinecap='round' />
      <path d='M34 71L24 71' stroke={isActive ? '#000' : '#9EA1A8'} strokeWidth='5' strokeLinecap='round' />
      <path d='M55 55L45 55' stroke={isActive ? '#000' : '#9EA1A8'} strokeWidth='5' strokeLinecap='round' />
      <path d='M55 71L45 71' stroke={isActive ? '#000' : '#9EA1A8'} strokeWidth='5' strokeLinecap='round' />
      <path d='M76 55L66 55' stroke={isActive ? '#000' : '#9EA1A8'} strokeWidth='5' strokeLinecap='round' />
      <path d='M76 71L66 71' stroke={isActive ? '#000' : '#9EA1A8'} strokeWidth='5' strokeLinecap='round' />
      <path d='M70 13V27' stroke={isActive ? '#000' : '#9EA1A8'} strokeWidth='5' strokeLinecap='round' />
    </svg>
  );
};

export const IconPostsSVG = ({ isActive = false, width = 28, height = 28 }) => {
  return (
    <svg width={width} height={height} viewBox='0 0 512 512' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M67 162.41C67 120.21 101.21 86 143.41 86H368.59C410.79 86 445 120.21 445 162.41V262V350V361.59C445 403.79 410.79 438 368.59 438H143.41C101.21 438 67 403.79 67 361.59V162.41Z'
        stroke={isActive ? '#000' : '#9EA1A8'}
        strokeWidth='25'
        strokeLinejoin='round'
      />
      <path d='M144 262H369' stroke={isActive ? '#000' : '#9EA1A8'} strokeWidth='25' strokeLinecap='round' />
      <path d='M144 184H369' stroke={isActive ? '#000' : '#9EA1A8'} strokeWidth='25' strokeLinecap='round' />
      <path d='M144 340H243' stroke={isActive ? '#000' : '#9EA1A8'} strokeWidth='25' strokeLinecap='round' />
    </svg>
  );
};

// export const IconAudienceSVG = ({ isActive = false, width = 28, height = 28 }) => {
//   return (
//     <svg width='590' height='590' viewBox='0 0 590 590' fill='none' xmlns='http://www.w3.org/2000/svg'>
//       <g clipPath='url(#clip0_515_586)'>
//         <ellipse cx='249.597' cy='208.986' rx='77.2417' ry='77.7532' fill='white' stroke='black' strokeWidth='16' />
//         <path
//           d='M380.268 452.475C385.791 452.475 390.298 447.994 389.982 442.48C389 425.343 385.499 408.48 379.599 392.574C372.555 373.583 362.231 356.327 349.216 341.792C336.201 327.257 320.75 315.727 303.745 307.86C286.74 299.994 268.514 295.945 250.108 295.945C231.702 295.945 213.476 299.994 196.471 307.86C179.466 315.727 164.014 327.257 150.999 341.792C137.984 356.327 127.66 373.583 120.616 392.574C114.717 408.48 111.215 425.343 110.233 442.48C109.917 447.994 114.424 452.475 119.947 452.475L250.108 452.475H380.268Z'
//           fill='white'
//           stroke='black'
//           strokeWidth='16'
//         />
//         <path
//           fill-rule='evenodd'
//           clip-rule='evenodd'
//           d='M366.002 180.381C362.511 180.381 359.098 180.698 355.789 181.304C351.444 182.101 346.909 179.908 345.501 175.72V175.72C344.093 171.532 346.342 166.949 350.66 166.015C355.611 164.944 360.744 164.381 366.002 164.381C406.248 164.381 438.762 197.259 438.762 237.677C438.762 275.383 410.464 306.528 373.989 310.536C369.597 311.019 366.002 307.391 366.002 302.972V302.972C366.002 298.554 369.604 295.032 373.978 294.41C401.505 290.499 422.762 266.639 422.762 237.677C422.762 205.971 397.288 180.381 366.002 180.381Z'
//           fill='black'
//         />
//         <path
//           fill-rule='evenodd'
//           clip-rule='evenodd'
//           d='M366 302.973C366 298.554 369.586 294.942 373.993 295.263C387.403 296.24 400.579 299.667 412.986 305.409C427.847 312.287 441.29 322.34 452.571 334.946C463.852 347.551 472.759 362.468 478.823 378.826C483.677 391.919 486.639 405.747 487.629 419.799C488.369 430.311 479.779 438.353 470 438.353H421.269C416.851 438.353 413.269 434.771 413.269 430.353V430.353C413.269 425.935 416.851 422.353 421.269 422.353H470C470.575 422.353 471.033 422.124 471.323 421.828C471.59 421.555 471.692 421.262 471.668 420.923C470.784 408.364 468.138 396.032 463.821 384.387C458.427 369.837 450.54 356.669 440.649 345.617C430.759 334.566 419.067 325.854 406.266 319.929C395.946 315.153 385.052 312.255 373.99 311.313C369.588 310.937 366 307.391 366 302.973V302.973Z'
//           fill='black'
//         />
//       </g>
//       <defs>
//         <clipPath id='clip0_515_586'>
//           <rect width='590' height='590' fill='white' />
//         </clipPath>
//       </defs>
//     </svg>
//   );
// };

export const IconSignOutSVG = ({ size = 24, color = '#9EA1A8' }) => {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M9.00195 7C9.01406 4.82497 9.11051 3.64706 9.87889 2.87868C10.7576 2 12.1718 2 15.0002 2L16.0002 2C18.8286 2 20.2429 2 21.1215 2.87868C22.0002 3.75736 22.0002 5.17157 22.0002 8L22.0002 16C22.0002 18.8284 22.0002 20.2426 21.1215 21.1213C20.2429 22 18.8286 22 16.0002 22H15.0002C12.1718 22 10.7576 22 9.87889 21.1213C9.11051 20.3529 9.01406 19.175 9.00195 17'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
      />
      <path d='M15 12L2 12M2 12L5.5 9M2 12L5.5 15' stroke={color} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
};

export const IconLogOutSVG = () => {
  return (
    <svg width='30' height='30' viewBox='0 0 1080 1080' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M525.462 832H321.94C304.717 832 288.199 825.158 276.02 812.98C263.842 800.801 257 784.283 257 767.06V312.483C257 295.26 263.842 278.743 276.02 266.564C288.199 254.386 304.717 247.544 321.94 247.544H525.462'
        stroke='#9EA1A8'
        strokeWidth='50'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M660.648 702.121L822.997 539.772L660.648 377.423' stroke='#9EA1A8' strokeWidth='50' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M822.999 539.772H412.32' stroke='#9EA1A8' strokeWidth='50' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
};

export const IconLiveSupportSVG = ({ size = 24, color = '#9EA1A8' }) => {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M8 12H8.009M11.991 12H12M15.991 12H16' stroke={color} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
      <path
        d='M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 13.5997 2.37562 15.1116 3.04346 16.4525C3.22094 16.8088 3.28001 17.2161 3.17712 17.6006L2.58151 19.8267C2.32295 20.793 3.20701 21.677 4.17335 21.4185L6.39939 20.8229C6.78393 20.72 7.19121 20.7791 7.54753 20.9565C8.88837 21.6244 10.4003 22 12 22Z'
        stroke={color}
        strokeWidth='1.5'
      />
    </svg>
  );
};

export const IconSupportSVG = () => {
  return (
    <svg width='30' height='30' viewBox='0 0 1080 1080' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M863 473C863 651.388 718.388 796 540 796C535.488 796.61 528.99 800.047 526.986 802.061C526.016 803.332 524.725 805.535 524.329 806.407C523.697 807.908 523.432 809.165 523.363 809.492L523.361 809.502C523.177 810.371 523.103 811.074 523.084 811.25L523.083 811.261C523.031 811.754 523.008 812.17 523.001 812.31C522.98 812.688 522.968 813.088 522.959 813.408C522.94 814.097 522.923 815.035 522.907 816.142C522.874 818.382 522.842 821.586 522.811 825.501C522.747 833.343 522.684 844.173 522.621 856.144C522.58 863.77 522.54 871.859 522.5 879.944C522.437 892.698 522.373 905.441 522.31 916.335C354.705 807.202 217 653.497 217 473C217 294.612 361.612 150 540 150C718.388 150 863 294.612 863 473Z'
        stroke='#9EA1A8'
        strokeWidth='34'
        strokeLinejoin='round'
      />
      <path
        d='M538.426 303C483.276 303 438.426 347.85 438.426 403C438.426 406.315 439.743 409.494 442.087 411.839C444.431 414.183 447.611 415.5 450.926 415.5C454.241 415.5 457.42 414.183 459.765 411.839C462.109 409.494 463.426 406.315 463.426 403C463.426 361.65 497.076 328 538.426 328C579.775 328 613.425 361.65 613.425 403C613.425 434.225 596.125 449.575 574.05 468.5L573.25 469.175C551.776 487.6 525.926 509.749 525.926 552.999V565.499C525.926 568.815 527.243 571.994 529.587 574.338C531.931 576.682 535.11 577.999 538.426 577.999C541.741 577.999 544.92 576.682 547.264 574.338C549.609 571.994 550.926 568.815 550.926 565.499V552.999C550.926 521.774 568.225 506.425 590.3 487.5L591.1 486.825C612.575 468.375 638.425 446.275 638.425 403C638.425 347.85 593.575 303 538.426 303Z'
        fill='#9EA1A8'
        stroke='#9EA1A8'
        strokeWidth='8'
      />
      <path
        d='M538.426 653C543.399 653 548.168 651.024 551.684 647.508C555.2 643.992 557.176 639.223 557.176 634.25C557.176 629.277 555.2 624.508 551.684 620.992C548.168 617.475 543.399 615.5 538.426 615.5C533.453 615.5 528.684 617.475 525.168 620.992C521.651 624.508 519.676 629.277 519.676 634.25C519.676 639.223 521.651 643.992 525.168 647.508C528.684 651.024 533.453 653 538.426 653Z'
        fill='#9EA1A8'
        stroke='#9EA1A8'
        strokeWidth='8'
      />
    </svg>
  );
};

export const IconDashboardSVG = ({ isActive = false }) => {
  return (
    <svg width='28' height='28' viewBox='0 0 1080 1080' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M399.117 154H680.884V154.242H702.5C750.825 154.242 790 193.434 790 241.779V838.463C790 886.808 750.825 926 702.5 926H377.5C329.175 926 290 886.808 290 838.463V241.779C290 193.434 329.175 154.242 377.5 154.242H399.117V154ZM399.117 204.263H377.5C356.789 204.263 340 221.06 340 241.779V838.463C340 859.182 356.789 875.979 377.5 875.979H702.5C723.211 875.979 740 859.182 740 838.463V241.779C740 221.06 723.211 204.263 702.5 204.263H680.884V232.824C680.884 265.055 654.767 291.183 622.55 291.183H457.45C425.233 291.183 399.117 265.055 399.117 232.824V204.263ZM449.117 204.263H630.884V232.824C630.884 237.429 627.153 241.161 622.55 241.161H457.45C452.848 241.161 449.117 237.429 449.117 232.824V204.263ZM420.714 813.941C420.714 800.128 431.907 788.93 445.714 788.93H633.214C647.021 788.93 658.214 800.128 658.214 813.941C658.214 827.754 647.021 838.951 633.214 838.951H445.714C431.907 838.951 420.714 827.754 420.714 813.941Z'
        fill={isActive ? '#000' : '#9EA1A8'}
      />
    </svg>
  );
};
export const IconProductsSVG = ({ isActive = false }) => {
  return (
    <svg width='28' height='28' viewBox='0 0 100 100' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M39.9249 85.3614C41.7754 85.3614 43.2755 83.8613 43.2755 82.0108C43.2755 80.1603 41.7754 78.6602 39.9249 78.6602C38.0743 78.6602 36.5742 80.1603 36.5742 82.0108C36.5742 83.8613 38.0743 85.3614 39.9249 85.3614Z'
        stroke={isActive ? '#000' : '#9EA1A8'}
        strokeWidth='5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M76.7959 85.3614C78.6465 85.3614 80.1466 83.8613 80.1466 82.0108C80.1466 80.1603 78.6465 78.6602 76.7959 78.6602C74.9454 78.6602 73.4453 80.1603 73.4453 82.0108C73.4453 83.8613 74.9454 85.3614 76.7959 85.3614Z'
        stroke={isActive ? '#000' : '#9EA1A8'}
        strokeWidth='5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M13.1445 15H26.5471L35.5268 59.865C35.8332 61.4076 36.6724 62.7933 37.8975 63.7796C39.1226 64.7658 40.6556 65.2897 42.2281 65.2595H74.7962C76.3687 65.2897 77.9017 64.7658 79.1268 63.7796C80.3519 62.7933 81.1911 61.4076 81.4975 59.865L86.8585 31.7532H29.8977'
        stroke={isActive ? '#000' : '#9EA1A8'}
        strokeWidth='5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export const IconMenuAudienceSVG = ({ size = 28, isActive = false }) => {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='9' cy='6' r='4' stroke={isActive ? '#000' : '#9EA1A8'} strokeWidth='1.5' />
      <path d='M15 9C16.6569 9 18 7.65685 18 6C18 4.34315 16.6569 3 15 3' stroke={isActive ? '#000' : '#9EA1A8'} strokeWidth='1.5' strokeLinecap='round' />
      <ellipse cx='9' cy='17' rx='7' ry='4' stroke={isActive ? '#000' : '#9EA1A8'} strokeWidth='1.5' />
      <path d='M18 14C19.7542 14.3847 21 15.3589 21 16.5C21 17.5293 19.9863 18.4229 18.5 18.8704' stroke={isActive ? '#000' : '#9EA1A8'} strokeWidth='1.5' strokeLinecap='round' />
    </svg>
  );
};

export const IconMenuPostsSVG = ({ size = 28, isActive = false }) => {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M16.3939 2.02121L16.4604 2.03904C17.5598 2.33361 18.431 2.56704 19.1162 2.81458C19.8172 3.06779 20.3888 3.35744 20.8597 3.79847C21.5453 4.44068 22.0252 5.27179 22.2385 6.18671C22.385 6.81503 22.3501 7.45486 22.2189 8.18849C22.0906 8.90573 21.8572 9.77697 21.5626 10.8764L21.0271 12.8747C20.7326 13.974 20.4991 14.8452 20.2516 15.5305C19.9984 16.2314 19.7087 16.803 19.2677 17.2739C18.6459 17.9377 17.8471 18.4087 16.9665 18.6316C16.7093 19.2213 16.3336 19.7554 15.8597 20.1993C15.3888 20.6403 14.8172 20.9299 14.1162 21.1832C13.431 21.4307 12.5598 21.6641 11.4605 21.9587L11.394 21.9765C10.2946 22.2711 9.42337 22.5045 8.70613 22.6328C7.9725 22.764 7.33266 22.7989 6.70435 22.6524C5.78943 22.4391 4.95832 21.9592 4.31611 21.2736C3.87508 20.8027 3.58542 20.2311 3.33222 19.5302C3.08468 18.8449 2.85124 17.9737 2.55667 16.8743L2.02122 14.876C1.72664 13.7766 1.4932 12.9054 1.36495 12.1882C1.23376 11.4546 1.19881 10.8147 1.34531 10.1864C1.55864 9.27149 2.03849 8.44038 2.72417 7.79817C3.19505 7.35714 3.76664 7.06749 4.46758 6.81428C5.15283 6.56674 6.02404 6.3333 7.12341 6.03873L7.15665 6.02983C7.42112 5.95896 7.67134 5.89203 7.90825 5.82944C8.29986 4.43031 8.64448 3.44126 9.31611 2.72417C9.95831 2.03849 10.7894 1.55864 11.7043 1.34531C12.3327 1.19881 12.9725 1.23376 13.7061 1.36495C14.4233 1.49319 15.2945 1.72664 16.3939 2.02121ZM7.45502 7.5028C6.36214 7.79571 5.57905 8.00764 4.9772 8.22505C4.36778 8.4452 4.00995 8.64907 3.74955 8.89296C3.2804 9.33237 2.95209 9.90103 2.80613 10.527C2.72511 10.8745 2.72747 11.2863 2.84152 11.9242C2.95723 12.5712 3.17355 13.381 3.47902 14.521L3.99666 16.4529C4.30212 17.5929 4.51967 18.4023 4.74299 19.0205C4.96314 19.63 5.16701 19.9878 5.4109 20.2482C5.85031 20.7173 6.41897 21.0456 7.04496 21.1916C7.39242 21.2726 7.80425 21.2703 8.4421 21.1562C9.08915 21.0405 9.89893 20.8242 11.0389 20.5187C12.1789 20.2132 12.9884 19.9957 13.6066 19.7724C14.216 19.5522 14.5739 19.3484 14.8343 19.1045C14.9719 18.9756 15.0973 18.8357 15.2096 18.6865C15.0306 18.6612 14.8463 18.629 14.6557 18.5911C13.9839 18.4575 13.1769 18.2413 12.1808 17.9744L12.1234 17.959C11.024 17.6644 10.1528 17.431 9.46758 17.1835C8.76664 16.9302 8.19505 16.6406 7.72416 16.1996C7.03849 15.5574 6.55864 14.7262 6.34531 13.8113C6.19881 13.183 6.23376 12.5432 6.36494 11.8095C6.4932 11.0923 6.72664 10.2211 7.02122 9.12174L7.45502 7.5028ZM13.4421 2.84152C12.8042 2.72747 12.3924 2.72511 12.045 2.80613C11.419 2.95209 10.8503 3.2804 10.4109 3.74955C9.97479 4.21518 9.70642 4.93452 9.2397 6.64323C9.16384 6.92093 9.08365 7.22023 8.99665 7.54488L8.47902 9.47673C8.17355 10.6167 7.95723 11.4265 7.84152 12.0736C7.72747 12.7114 7.72511 13.1232 7.80613 13.4707C7.95209 14.0967 8.2804 14.6654 8.74955 15.1048C9.00995 15.3487 9.36778 15.5525 9.9772 15.7727C10.5954 15.996 11.4049 16.2136 12.5449 16.519C13.5703 16.7938 14.3303 16.997 14.9482 17.1199C15.5635 17.2422 15.981 17.2723 16.3232 17.23C16.3976 17.2209 16.4691 17.2082 16.5389 17.1919C17.1649 17.0459 17.7335 16.7176 18.1729 16.2485C18.4168 15.9881 18.6207 15.6303 18.8408 15.0208C19.0642 14.4026 19.2817 13.5932 19.5872 12.4532L20.1048 10.5213C20.4103 9.38129 20.6266 8.57151 20.7423 7.92446C20.8564 7.28661 20.8587 6.87479 20.7777 6.52733C20.6317 5.90133 20.3034 5.33267 19.8343 4.89327C19.5739 4.64937 19.216 4.4455 18.6066 4.22535C17.9884 4.00203 17.1789 3.78448 16.0389 3.47902C14.8989 3.17355 14.0892 2.95723 13.4421 2.84152ZM11.0524 9.80588C11.1596 9.40578 11.5709 9.16834 11.971 9.27555L16.8006 10.5696C17.2007 10.6768 17.4381 11.0881 17.3309 11.4882C17.2237 11.8883 16.8125 12.1257 16.4124 12.0185L11.5827 10.7244C11.1826 10.6172 10.9452 10.206 11.0524 9.80588ZM10.2755 12.7036C10.3828 12.3035 10.794 12.066 11.1941 12.1733L14.0919 12.9497C14.492 13.0569 14.7294 13.4682 14.6222 13.8683C14.515 14.2684 14.1038 14.5058 13.7037 14.3986L10.8059 13.6221C10.4058 13.5149 10.1683 13.1037 10.2755 12.7036Z'
        fill={isActive ? '#000' : '#9EA1A8'}
      />
    </svg>
  );
};

export const IconMenuBlogSVG = ({ size = 28, isActive = false }) => {
  return (
    <svg width={size} height={size} viewBox='0 0 800 800' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M441.333 250C441.333 236.193 452.526 225 466.333 225H633C646.807 225 658 236.193 658 250C658 263.807 646.807 275 633 275H466.333C452.526 275 441.333 263.807 441.333 250ZM374.667 416.667C374.667 402.86 385.86 391.667 399.667 391.667H633C646.807 391.667 658 402.86 658 416.667C658 430.473 646.807 441.667 633 441.667H399.667C385.86 441.667 374.667 430.473 374.667 416.667ZM240 583.333C240 569.527 251.193 558.333 265 558.333H633C646.807 558.333 658 569.527 658 583.333C658 597.14 646.807 608.333 633 608.333H265C251.193 608.333 240 597.14 240 583.333Z'
        fill={isActive ? '#000' : '#9EA1A8'}
      />
      <path
        d='M166 191C152.193 191 141 202.193 141 216C141 229.807 152.193 241 166 241H241V416C241 429.807 252.193 441 266 441C279.807 441 291 429.807 291 416V241H366C379.807 241 391 229.807 391 216C391 202.193 379.807 191 366 191H166Z'
        fill={isActive ? '#000' : '#9EA1A8'}
      />
    </svg>
  );
};

export const IconMenuSocialPlannerSVG = ({ size = 28, isActive = false }) => {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M2 12C2 8.22876 2 6.34315 3.17157 5.17157C4.34315 4 6.22876 4 10 4H14C17.7712 4 19.6569 4 20.8284 5.17157C22 6.34315 22 8.22876 22 12V14C22 17.7712 22 19.6569 20.8284 20.8284C19.6569 22 17.7712 22 14 22H10C6.22876 22 4.34315 22 3.17157 20.8284C2 19.6569 2 17.7712 2 14V12Z'
        stroke={isActive ? '#000' : '#9EA1A8'}
        strokeWidth='1.5'
      />
      <path d='M7 4V2.5' stroke={isActive ? '#000' : '#9EA1A8'} strokeWidth='1.5' strokeLinecap='round' />
      <path d='M17 4V2.5' stroke={isActive ? '#000' : '#9EA1A8'} strokeWidth='1.5' strokeLinecap='round' />
      <path d='M2.5 9H21.5' stroke={isActive ? '#000' : '#9EA1A8'} strokeWidth='1.5' strokeLinecap='round' />
      <path d='M18 17C18 17.5523 17.5523 18 17 18C16.4477 18 16 17.5523 16 17C16 16.4477 16.4477 16 17 16C17.5523 16 18 16.4477 18 17Z' fill={isActive ? '#000' : '#9EA1A8'} />
      <path d='M18 13C18 13.5523 17.5523 14 17 14C16.4477 14 16 13.5523 16 13C16 12.4477 16.4477 12 17 12C17.5523 12 18 12.4477 18 13Z' fill={isActive ? '#000' : '#9EA1A8'} />
      <path d='M13 17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17C11 16.4477 11.4477 16 12 16C12.5523 16 13 16.4477 13 17Z' fill={isActive ? '#000' : '#9EA1A8'} />
      <path d='M13 13C13 13.5523 12.5523 14 12 14C11.4477 14 11 13.5523 11 13C11 12.4477 11.4477 12 12 12C12.5523 12 13 12.4477 13 13Z' fill={isActive ? '#000' : '#9EA1A8'} />
      <path d='M8 17C8 17.5523 7.55228 18 7 18C6.44772 18 6 17.5523 6 17C6 16.4477 6.44772 16 7 16C7.55228 16 8 16.4477 8 17Z' fill={isActive ? '#000' : '#9EA1A8'} />
      <path d='M8 13C8 13.5523 7.55228 14 7 14C6.44772 14 6 13.5523 6 13C6 12.4477 6.44772 12 7 12C7.55228 12 8 12.4477 8 13Z' fill={isActive ? '#000' : '#9EA1A8'} />
    </svg>
  );
};

export const IconMenuSmartReplySVG = ({ size = 28, isActive = false }) => {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.4606 1.25L13.5 1.25C13.9142 1.25 14.25 1.58579 14.25 2C14.25 2.41421 13.9142 2.75 13.5 2.75H10.5C8.84876 2.75 7.663 2.75079 6.73809 2.83873C5.82434 2.92561 5.24291 3.09223 4.77938 3.37628C4.20752 3.72672 3.72672 4.20752 3.37628 4.77938C3.09223 5.24291 2.92561 5.82434 2.83873 6.73809C2.75079 7.663 2.75 8.84876 2.75 10.5V11.5C2.75 12.6751 2.75041 13.5189 2.79584 14.1847C2.84081 14.8438 2.92737 15.2736 3.07351 15.6264C3.50486 16.6678 4.33223 17.4951 5.3736 17.9265C5.88923 18.1401 6.54706 18.2199 7.8025 18.2416L7.83432 18.2421C8.23232 18.249 8.58109 18.2549 8.87097 18.287C9.18246 18.3215 9.4871 18.3912 9.77986 18.5615C10.0702 18.7304 10.2795 18.9559 10.4621 19.2063C10.6307 19.4378 10.804 19.7306 11.0004 20.0623L11.5587 21.0057C11.7515 21.3313 12.2485 21.3313 12.4412 21.0057L12.9996 20.0623C13.1959 19.7306 13.3692 19.4378 13.5379 19.2063C13.7204 18.9559 13.9298 18.7304 14.2201 18.5615C14.5129 18.3912 14.8175 18.3215 15.129 18.287C15.4189 18.2549 15.7676 18.249 16.1656 18.2421L16.1975 18.2416C17.4529 18.2199 18.1108 18.1401 18.6264 17.9265C19.6678 17.4951 20.4951 16.6678 20.9265 15.6264C21.0726 15.2736 21.1592 14.8438 21.2042 14.1847C21.2496 13.5189 21.25 12.6751 21.25 11.5V10.5C21.25 10.0858 21.5858 9.75 22 9.75C22.4142 9.75 22.75 10.0858 22.75 10.5V11.5278C22.75 12.6691 22.75 13.564 22.7007 14.2868C22.6505 15.0223 22.5468 15.6344 22.3123 16.2004C21.7287 17.6093 20.6093 18.7287 19.2004 19.3123C18.3955 19.6457 17.4786 19.7197 16.2233 19.7413C15.7842 19.7489 15.5061 19.7545 15.2941 19.7779C15.096 19.7999 15.0192 19.832 14.9742 19.8582C14.9268 19.8857 14.8622 19.936 14.7501 20.0898C14.6287 20.2564 14.4916 20.4865 14.2742 20.8539L13.7321 21.7697C12.9585 23.0767 11.0415 23.0767 10.2679 21.7697L9.72579 20.8539C9.50835 20.4865 9.37122 20.2564 9.24985 20.0898C9.13772 19.936 9.07313 19.8857 9.02572 19.8582C8.98078 19.832 8.90399 19.7999 8.70588 19.7779C8.49387 19.7545 8.21575 19.7489 7.77666 19.7413C6.52138 19.7197 5.60454 19.6457 4.79957 19.3123C3.39066 18.7287 2.27128 17.6093 1.68769 16.2004C1.45323 15.6344 1.3495 15.0223 1.29932 14.2868C1.24999 13.564 1.25 12.6691 1.25 11.5278L1.25 10.4606C1.24999 8.85726 1.24999 7.60029 1.34547 6.59611C1.44279 5.57256 1.64457 4.73445 2.09732 3.99563C2.57144 3.22194 3.22194 2.57144 3.99563 2.09732C4.73445 1.64457 5.57256 1.44279 6.59611 1.34547C7.60029 1.24999 8.85726 1.24999 10.4606 1.25ZM19 2.75C17.7574 2.75 16.75 3.75736 16.75 5C16.75 6.24264 17.7574 7.25 19 7.25C20.2426 7.25 21.25 6.24264 21.25 5C21.25 3.75736 20.2426 2.75 19 2.75ZM15.25 5C15.25 2.92893 16.9289 1.25 19 1.25C21.0711 1.25 22.75 2.92893 22.75 5C22.75 7.07107 21.0711 8.75 19 8.75C16.9289 8.75 15.25 7.07107 15.25 5Z'
        fill={isActive ? '#000' : '#9EA1A8'}
      />
    </svg>
  );
};

export const IconMenuShortLinkSVG = ({ size = 28, isActive = false }) => {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M14.1625 18.4876L13.4417 19.2084C11.053 21.5971 7.18019 21.5971 4.79151 19.2084C2.40283 16.8198 2.40283 12.9469 4.79151 10.5583L5.51236 9.8374'
        stroke={isActive ? '#000' : '#9EA1A8'}
        strokeWidth='1.5'
        strokeLinecap='round'
      />
      <path d='M9.8374 14.1625L14.1625 9.8374' stroke={isActive ? '#000' : '#9EA1A8'} strokeWidth='1.5' strokeLinecap='round' />
      <path
        d='M9.8374 5.51236L10.5583 4.79151C12.9469 2.40283 16.8198 2.40283 19.2084 4.79151C21.5971 7.18019 21.5971 11.053 19.2084 13.4417L18.4876 14.1625'
        stroke={isActive ? '#000' : '#9EA1A8'}
        strokeWidth='1.5'
        strokeLinecap='round'
      />
    </svg>
  );
};

export const IconMenuCreatorHubSVG = ({ size = 28, isActive = false }) => {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6.85929 1.25001C6.88904 1.25001 6.91919 1.25002 6.94976 1.25002L6.98675 1.25001C7.33818 1.24999 7.56433 1.24998 7.78542 1.27065C8.68728 1.35499 9.54516 1.69531 10.2586 2.25002H16.5C16.5196 2.25002 16.5389 2.25001 16.5579 2.25001C16.9666 2.24994 17.2449 2.2499 17.4895 2.2821C19.1722 2.50364 20.4964 3.82779 20.7179 5.51054C20.7263 5.57397 20.7325 5.63966 20.737 5.70931C21.0145 5.83579 21.2715 5.99934 21.5077 6.21185C21.6061 6.30032 21.6997 6.39394 21.7882 6.49231C22.3165 7.07965 22.5422 7.79459 22.648 8.63601C22.75 9.4479 22.75 10.4741 22.75 11.747V14.0564C22.75 15.8942 22.75 17.3498 22.5969 18.489C22.4393 19.6615 22.1071 20.6104 21.3588 21.3588C20.6104 22.1071 19.6615 22.4393 18.489 22.5969C17.3498 22.75 15.8942 22.75 14.0564 22.75H9.94361C8.10584 22.75 6.65021 22.75 5.51099 22.5969C4.33857 22.4393 3.38962 22.1071 2.64126 21.3588C1.8929 20.6104 1.56078 19.6615 1.40315 18.489C1.24999 17.3498 1.25 15.8942 1.25002 14.0564L1.25002 6.94976C1.25002 6.91919 1.25001 6.88904 1.25001 6.85929C1.2499 6.06338 1.24982 5.55685 1.33237 5.11935C1.6949 3.19788 3.19788 1.6949 5.11935 1.33237C5.55685 1.24982 6.06338 1.2499 6.85929 1.25001ZM19.1474 5.32768C18.8895 4.5029 18.1732 3.88506 17.2937 3.76927C17.1598 3.75163 16.9883 3.75002 16.5 3.75002H11.8113C12.4542 4.38908 12.7459 4.65598 13.0768 4.84005C13.2948 4.96134 13.526 5.05713 13.766 5.12552C14.1793 5.24333 14.6324 5.25002 15.8284 5.25002L16.253 5.25002C17.4153 5.25 18.3718 5.24999 19.1474 5.32768ZM6.94976 2.75002C6.03312 2.75002 5.67873 2.75329 5.39746 2.80636C4.08277 3.05441 3.05441 4.08277 2.80636 5.39746C2.75329 5.67873 2.75002 6.03312 2.75002 6.94976V14C2.75002 15.9068 2.75161 17.2615 2.88978 18.2892C3.02504 19.2953 3.27871 19.8749 3.70192 20.2981C4.12513 20.7213 4.70478 20.975 5.71087 21.1103C6.73853 21.2484 8.0932 21.25 10 21.25H14C15.9068 21.25 17.2615 21.2484 18.2892 21.1103C19.2953 20.975 19.8749 20.7213 20.2981 20.2981C20.7213 19.8749 20.975 19.2953 21.1103 18.2892C21.2484 17.2615 21.25 15.9068 21.25 14V11.7979C21.25 10.4621 21.2486 9.5305 21.1597 8.82312C21.0731 8.13448 20.9141 7.76356 20.6729 7.49539C20.6198 7.43637 20.5637 7.3802 20.5046 7.32712C20.2365 7.08592 19.8656 6.92692 19.1769 6.84034C18.4695 6.75141 17.538 6.75002 16.2021 6.75002H15.8284C15.7912 6.75002 15.7545 6.75002 15.7182 6.75003C14.6702 6.75025 13.9944 6.75038 13.3548 6.56806C13.0041 6.46811 12.6661 6.32811 12.3475 6.15083C11.7663 5.82747 11.2885 5.3495 10.5476 4.60833C10.522 4.58265 10.496 4.55666 10.4697 4.53035L9.91943 3.98009C9.63616 3.69682 9.52778 3.58951 9.41731 3.49793C8.91403 3.08073 8.29664 2.825 7.64576 2.76413C7.50289 2.75077 7.35038 2.75002 6.94976 2.75002ZM12.25 10C12.25 9.5858 12.5858 9.25002 13 9.25002H18C18.4142 9.25002 18.75 9.5858 18.75 10C18.75 10.4142 18.4142 10.75 18 10.75H13C12.5858 10.75 12.25 10.4142 12.25 10Z'
        fill={isActive ? '#000' : '#9EA1A8'}
      />
    </svg>
  );
};

export const IconMenuStudioSVG = ({ size = 28, isActive = false }) => {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.25 18C8.25 17.5858 8.58579 17.25 9 17.25H15C15.4142 17.25 15.75 17.5858 15.75 18C15.75 18.4142 15.4142 18.75 15 18.75H9C8.58579 18.75 8.25 18.4142 8.25 18Z'
        fill={isActive ? '#000' : '#9EA1A8'}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.69935 1.25001H15.3004C15.5203 1.24995 15.6888 1.2499 15.8362 1.26571C17.1903 1.41104 18.2268 2.52307 18.2897 3.87013C19.4805 4.22571 20.3289 5.3275 20.3443 6.59118C20.9453 6.77151 21.4637 7.05595 21.888 7.51432C22.54 8.21857 22.7421 9.08649 22.7498 10.1003C22.7572 11.075 22.5835 12.3067 22.3678 13.8363L21.9288 16.9499C21.7602 18.146 21.6232 19.1176 21.4101 19.879C21.1871 20.6756 20.8585 21.331 20.25 21.8349C19.6463 22.3347 18.9301 22.5502 18.0835 22.6518C17.265 22.75 16.2353 22.75 14.9532 22.75H9.04687C7.76478 22.75 6.73501 22.75 5.91647 22.6518C5.06993 22.5502 4.35372 22.3347 3.75003 21.8349C3.14152 21.331 2.81286 20.6756 2.58989 19.879C2.37676 19.1176 2.23979 18.146 2.07118 16.9499L1.63219 13.8363C1.41651 12.3067 1.24283 11.075 1.25023 10.1003C1.25792 9.08649 1.45997 8.21857 2.11196 7.51432C2.53621 7.05606 3.05445 6.77164 3.65528 6.5913C3.67058 5.3275 4.51917 4.22559 5.71005 3.87007C5.77295 2.52304 6.80943 1.41104 8.16359 1.26571C8.31094 1.2499 8.4795 1.24995 8.69935 1.25001ZM5.18902 6.32785C6.11481 6.24999 7.24973 6.25 8.61594 6.25001H15.384C16.75 6.25 17.8848 6.24999 18.8105 6.32781C18.6734 5.72018 18.1306 5.25001 17.4617 5.25001H6.53787C5.86896 5.25001 5.32618 5.72019 5.18902 6.32785ZM15.6761 2.75715C16.2263 2.8162 16.6611 3.22633 16.7677 3.75001H7.2321C7.33862 3.22633 7.77344 2.8162 8.32365 2.75715C8.37993 2.75111 8.46013 2.75001 8.74099 2.75001H15.2588C15.5396 2.75001 15.6198 2.75111 15.6761 2.75715ZM3.21267 8.53336C3.51557 8.20618 3.97106 7.98917 4.85612 7.87145C5.75726 7.75159 6.96357 7.75001 8.67239 7.75001H15.3276C17.0364 7.75001 18.2427 7.75159 19.1439 7.87145C20.0289 7.98917 20.4844 8.20618 20.7873 8.53336C21.0832 8.85293 21.2436 9.28782 21.2498 10.1117C21.2563 10.9618 21.1002 12.0828 20.8738 13.6883L20.4509 16.6883C20.2731 17.9491 20.1486 18.821 19.9656 19.4747C19.7894 20.1042 19.582 20.4405 19.2934 20.6795C18.9999 20.9225 18.6058 21.0784 17.9048 21.1625C17.1861 21.2488 16.2465 21.25 14.9046 21.25H9.09536C7.75347 21.25 6.81393 21.2488 6.09519 21.1625C5.39417 21.0784 5.00014 20.9225 4.70664 20.6795C4.41795 20.4405 4.21058 20.1042 4.03437 19.4747C3.8514 18.821 3.7269 17.9491 3.54913 16.6883L3.12616 13.6883C2.89981 12.0828 2.74373 10.9618 2.75018 10.1117C2.75644 9.28782 2.91681 8.85293 3.21267 8.53336Z'
        fill={isActive ? '#000' : '#9EA1A8'}
      />
    </svg>
  );
};

export const IconMenuLinkInBioSVG = ({ size = 28, isActive = false }) => {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M4 10C4 6.22876 4 4.34315 5.17157 3.17157C6.34315 2 8.22876 2 12 2C15.7712 2 17.6569 2 18.8284 3.17157C20 4.34315 20 6.22876 20 10V14C20 17.7712 20 19.6569 18.8284 20.8284C17.6569 22 15.7712 22 12 22C8.22876 22 6.34315 22 5.17157 20.8284C4 19.6569 4 17.7712 4 14V10Z'
        stroke={isActive ? '#000' : '#9EA1A8'}
        strokeWidth='1.5'
      />
      <path d='M15 19H9' stroke={isActive ? '#000' : '#9EA1A8'} strokeWidth='1.5' strokeLinecap='round' />
      <path
        d='M16.7484 2.37793L16.6643 2.5041C15.9082 3.63818 15.5302 4.20525 14.978 4.54836C14.8682 4.61658 14.7541 4.67764 14.6365 4.73115C14.0447 5.00025 13.3632 5.00025 12.0002 5.00025C10.6371 5.00025 9.95564 5.00025 9.36387 4.73115C9.2462 4.67764 9.13211 4.61658 9.02232 4.54836C8.47016 4.20524 8.09213 3.6382 7.33606 2.5041L7.25195 2.37793'
        stroke={isActive ? '#000' : '#9EA1A8'}
        strokeWidth='1.5'
        strokeLinecap='round'
      />
    </svg>
  );
};

export const IconMenuOrdersSVG = ({ size = 28, isActive = false }) => {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M7.5 18C8.32843 18 9 18.6716 9 19.5C9 20.3284 8.32843 21 7.5 21C6.67157 21 6 20.3284 6 19.5C6 18.6716 6.67157 18 7.5 18Z'
        stroke={isActive ? '#000' : '#9EA1A8'}
        strokeWidth='1.5'
      />
      <path
        d='M16.5 18.0001C17.3284 18.0001 18 18.6716 18 19.5001C18 20.3285 17.3284 21.0001 16.5 21.0001C15.6716 21.0001 15 20.3285 15 19.5001C15 18.6716 15.6716 18.0001 16.5 18.0001Z'
        stroke={isActive ? '#000' : '#9EA1A8'}
        strokeWidth='1.5'
      />
      <path
        d='M2.26121 3.09184L2.50997 2.38429H2.50997L2.26121 3.09184ZM2.24876 2.29246C1.85799 2.15507 1.42984 2.36048 1.29246 2.75124C1.15507 3.14201 1.36048 3.57016 1.75124 3.70754L2.24876 2.29246ZM4.58584 4.32298L5.20507 3.89983V3.89983L4.58584 4.32298ZM5.88772 14.5862L5.34345 15.1022H5.34345L5.88772 14.5862ZM20.6578 9.88275L21.3923 10.0342L21.3933 10.0296L20.6578 9.88275ZM20.158 12.3075L20.8926 12.4589L20.158 12.3075ZM20.7345 6.69708L20.1401 7.15439L20.7345 6.69708ZM19.1336 15.0504L18.6598 14.469L19.1336 15.0504ZM5.70808 9.76V7.03836H4.20808V9.76H5.70808ZM2.50997 2.38429L2.24876 2.29246L1.75124 3.70754L2.01245 3.79938L2.50997 2.38429ZM10.9375 16.25H16.2404V14.75H10.9375V16.25ZM5.70808 7.03836C5.70808 6.3312 5.7091 5.7411 5.65719 5.26157C5.60346 4.76519 5.48705 4.31247 5.20507 3.89983L3.96661 4.74613C4.05687 4.87822 4.12657 5.05964 4.1659 5.42299C4.20706 5.8032 4.20808 6.29841 4.20808 7.03836H5.70808ZM2.01245 3.79938C2.68006 4.0341 3.11881 4.18965 3.44166 4.34806C3.74488 4.49684 3.87855 4.61727 3.96661 4.74613L5.20507 3.89983C4.92089 3.48397 4.54304 3.21763 4.10241 3.00143C3.68139 2.79485 3.14395 2.60719 2.50997 2.38429L2.01245 3.79938ZM4.20808 9.76C4.20808 11.2125 4.22171 12.2599 4.35876 13.0601C4.50508 13.9144 4.79722 14.5261 5.34345 15.1022L6.43198 14.0702C6.11182 13.7325 5.93913 13.4018 5.83723 12.8069C5.72607 12.1578 5.70808 11.249 5.70808 9.76H4.20808ZM10.9375 14.75C9.52069 14.75 8.53763 14.7482 7.79696 14.6432C7.08215 14.5418 6.70452 14.3576 6.43198 14.0702L5.34345 15.1022C5.93731 15.7286 6.69012 16.0013 7.58636 16.1283C8.45674 16.2518 9.56535 16.25 10.9375 16.25V14.75ZM4.95808 6.87H17.0888V5.37H4.95808V6.87ZM19.9232 9.73135L19.4235 12.1561L20.8926 12.4589L21.3923 10.0342L19.9232 9.73135ZM17.0888 6.87C17.9452 6.87 18.6989 6.871 19.2937 6.93749C19.5893 6.97053 19.8105 7.01643 19.9659 7.07105C20.1273 7.12776 20.153 7.17127 20.1401 7.15439L21.329 6.23978C21.094 5.93436 20.7636 5.76145 20.4632 5.65587C20.1567 5.54818 19.8101 5.48587 19.4604 5.44678C18.7646 5.369 17.9174 5.37 17.0888 5.37V6.87ZM21.3933 10.0296C21.5625 9.18167 21.7062 8.47024 21.7414 7.90038C21.7775 7.31418 21.7108 6.73617 21.329 6.23978L20.1401 7.15439C20.2021 7.23508 20.2706 7.38037 20.2442 7.80797C20.2168 8.25191 20.1002 8.84478 19.9223 9.73595L21.3933 10.0296ZM16.2404 16.25C17.0021 16.25 17.6413 16.2513 18.1566 16.1882C18.6923 16.1227 19.1809 15.9794 19.6074 15.6318L18.6598 14.469C18.5346 14.571 18.3571 14.6525 17.9744 14.6994C17.5712 14.7487 17.0397 14.75 16.2404 14.75V16.25ZM19.4235 12.1561C19.2621 12.9389 19.1535 13.4593 19.0238 13.8442C18.9007 14.2095 18.785 14.367 18.6598 14.469L19.6074 15.6318C20.0339 15.2842 20.2729 14.8346 20.4453 14.3232C20.6111 13.8312 20.7388 13.2049 20.8926 12.4589L19.4235 12.1561Z'
        fill={isActive ? '#000' : '#9EA1A8'}
      />
    </svg>
  );
};

export const IconMenuPublishSVG = ({ size = 28, isActive = false }) => {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.9426 1.25L13.5 1.25C13.9142 1.25 14.25 1.58579 14.25 2C14.25 2.41421 13.9142 2.75 13.5 2.75H12C9.62178 2.75 7.91356 2.75159 6.61358 2.92637C5.33517 3.09825 4.56445 3.42514 3.9948 3.9948C3.42514 4.56445 3.09825 5.33517 2.92637 6.61358C2.75159 7.91356 2.75 9.62178 2.75 12C2.75 14.3782 2.75159 16.0864 2.92637 17.3864C3.09825 18.6648 3.42514 19.4355 3.9948 20.0052C4.56445 20.5749 5.33517 20.9018 6.61358 21.0736C7.91356 21.2484 9.62178 21.25 12 21.25C14.3782 21.25 16.0864 21.2484 17.3864 21.0736C18.6648 20.9018 19.4355 20.5749 20.0052 20.0052C20.5749 19.4355 20.9018 18.6648 21.0736 17.3864C21.2484 16.0864 21.25 14.3782 21.25 12V10.5C21.25 10.0858 21.5858 9.75 22 9.75C22.4142 9.75 22.75 10.0858 22.75 10.5V12.0574C22.75 14.3658 22.75 16.1748 22.5603 17.5863C22.366 19.031 21.9607 20.1711 21.0659 21.0659C20.1711 21.9607 19.031 22.366 17.5863 22.5603C16.1748 22.75 14.3658 22.75 12.0574 22.75H11.9426C9.63423 22.75 7.82519 22.75 6.41371 22.5603C4.96897 22.366 3.82895 21.9607 2.93414 21.0659C2.03933 20.1711 1.63399 19.031 1.43975 17.5863C1.24998 16.1748 1.24999 14.3658 1.25 12.0574V11.9426C1.24999 9.63423 1.24998 7.82519 1.43975 6.41371C1.63399 4.96897 2.03933 3.82895 2.93414 2.93414C3.82895 2.03933 4.96897 1.63399 6.41371 1.43975C7.82519 1.24998 9.63423 1.24999 11.9426 1.25ZM16.7705 2.27592C18.1384 0.908029 20.3562 0.908029 21.7241 2.27592C23.092 3.6438 23.092 5.86158 21.7241 7.22947L15.076 13.8776C14.7047 14.2489 14.4721 14.4815 14.2126 14.684C13.9069 14.9224 13.5761 15.1268 13.2261 15.2936C12.929 15.4352 12.6169 15.5392 12.1188 15.7052L9.21426 16.6734C8.67801 16.8521 8.0868 16.7126 7.68711 16.3129C7.28742 15.9132 7.14785 15.322 7.3266 14.7857L8.29477 11.8812C8.46079 11.3831 8.56479 11.071 8.7064 10.7739C8.87319 10.4239 9.07761 10.0931 9.31605 9.78742C9.51849 9.52787 9.7511 9.29529 10.1224 8.924L16.7705 2.27592ZM20.6634 3.33658C19.8813 2.55448 18.6133 2.55448 17.8312 3.33658L17.4546 3.7132C17.4773 3.80906 17.509 3.92327 17.5532 4.05066C17.6965 4.46372 17.9677 5.00771 18.48 5.51999C18.9923 6.03227 19.5363 6.30346 19.9493 6.44677C20.0767 6.49097 20.1909 6.52273 20.2868 6.54543L20.6634 6.16881C21.4455 5.38671 21.4455 4.11867 20.6634 3.33658ZM19.1051 7.72709C18.5892 7.50519 17.9882 7.14946 17.4193 6.58065C16.8505 6.01185 16.4948 5.41082 16.2729 4.89486L11.2175 9.95026C10.801 10.3668 10.6376 10.532 10.4988 10.7099C10.3274 10.9297 10.1804 11.1676 10.0605 11.4192C9.96337 11.623 9.88868 11.8429 9.7024 12.4017L9.27051 13.6974L10.3026 14.7295L11.5983 14.2976C12.1571 14.1113 12.377 14.0366 12.5808 13.9395C12.8324 13.8196 13.0703 13.6726 13.2901 13.5012C13.468 13.3624 13.6332 13.199 14.0497 12.7825L19.1051 7.72709Z'
        fill={isActive ? '#000' : '#9EA1A8'}
      />
    </svg>
  );
};

export const IconMenuShopSVG = ({ size = 28, isActive = false }) => {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75ZM1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12ZM12 5.25C12.4142 5.25 12.75 5.58579 12.75 6V6.31673C14.3804 6.60867 15.75 7.83361 15.75 9.5C15.75 9.91421 15.4142 10.25 15 10.25C14.5858 10.25 14.25 9.91421 14.25 9.5C14.25 8.82154 13.6859 8.10339 12.75 7.84748V11.3167C14.3804 11.6087 15.75 12.8336 15.75 14.5C15.75 16.1664 14.3804 17.3913 12.75 17.6833V18C12.75 18.4142 12.4142 18.75 12 18.75C11.5858 18.75 11.25 18.4142 11.25 18V17.6833C9.61957 17.3913 8.25 16.1664 8.25 14.5C8.25 14.0858 8.58579 13.75 9 13.75C9.41421 13.75 9.75 14.0858 9.75 14.5C9.75 15.1785 10.3141 15.8966 11.25 16.1525V12.6833C9.61957 12.3913 8.25 11.1664 8.25 9.5C8.25 7.83361 9.61957 6.60867 11.25 6.31673V6C11.25 5.58579 11.5858 5.25 12 5.25ZM11.25 7.84748C10.3141 8.10339 9.75 8.82154 9.75 9.5C9.75 10.1785 10.3141 10.8966 11.25 11.1525V7.84748ZM12.75 12.8475V16.1525C13.6859 15.8966 14.25 15.1785 14.25 14.5C14.25 13.8215 13.6859 13.1034 12.75 12.8475Z'
        fill={isActive ? '#000' : '#9EA1A8'}
      />
    </svg>
  );
};
// export const IconMenuBlogArticlesSVG = ({ size = 28, isActive = false }) => {
//   return (
//     <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
//       <path
//         fillRule='evenodd'
//         clipRule='evenodd'
//         d='M10.9436 1.25H13.0564C14.8942 1.24998 16.3498 1.24997 17.489 1.40314C18.6614 1.56076 19.6104 1.89288 20.3588 2.64124C21.1071 3.38961 21.4392 4.33856 21.5969 5.51098C21.75 6.65019 21.75 8.10583 21.75 9.94359V14.0564C21.75 15.8942 21.75 17.3498 21.5969 18.489C21.4392 19.6614 21.1071 20.6104 20.3588 21.3588C19.6104 22.1071 18.6614 22.4392 17.489 22.5969C16.3498 22.75 14.8942 22.75 13.0564 22.75H10.9436C9.10583 22.75 7.65019 22.75 6.51098 22.5969C5.33856 22.4392 4.38961 22.1071 3.64124 21.3588C2.89288 20.6104 2.56076 19.6614 2.40314 18.489C2.24997 17.3498 2.24998 15.8942 2.25 14.0564V9.94358C2.24998 8.10582 2.24997 6.65019 2.40314 5.51098C2.56076 4.33856 2.89288 3.38961 3.64124 2.64124C4.38961 1.89288 5.33856 1.56076 6.51098 1.40314C7.65019 1.24997 9.10582 1.24998 10.9436 1.25ZM6.71085 2.88976C5.70476 3.02502 5.12511 3.27869 4.7019 3.7019C4.27869 4.12511 4.02502 4.70476 3.88976 5.71085C3.75159 6.73851 3.75 8.09318 3.75 10V14C3.75 15.9068 3.75159 17.2615 3.88976 18.2892C4.02502 19.2952 4.27869 19.8749 4.7019 20.2981C5.12511 20.7213 5.70476 20.975 6.71085 21.1102C7.73851 21.2484 9.09318 21.25 11 21.25H13C14.9068 21.25 16.2615 21.2484 17.2892 21.1102C18.2952 20.975 18.8749 20.7213 19.2981 20.2981C19.7213 19.8749 19.975 19.2952 20.1102 18.2892C20.2484 17.2615 20.25 15.9068 20.25 14V10C20.25 8.09318 20.2484 6.73851 20.1102 5.71085C19.975 4.70476 19.7213 4.12511 19.2981 3.7019C18.8749 3.27869 18.2952 3.02502 17.2892 2.88976C16.2615 2.75159 14.9068 2.75 13 2.75H11C9.09318 2.75 7.73851 2.75159 6.71085 2.88976ZM7.25 8C7.25 7.58579 7.58579 7.25 8 7.25H16C16.4142 7.25 16.75 7.58579 16.75 8C16.75 8.41421 16.4142 8.75 16 8.75H8C7.58579 8.75 7.25 8.41421 7.25 8ZM7.25 12C7.25 11.5858 7.58579 11.25 8 11.25H16C16.4142 11.25 16.75 11.5858 16.75 12C16.75 12.4142 16.4142 12.75 16 12.75H8C7.58579 12.75 7.25 12.4142 7.25 12ZM7.25 16C7.25 15.5858 7.58579 15.25 8 15.25H13C13.4142 15.25 13.75 15.5858 13.75 16C13.75 16.4142 13.4142 16.75 13 16.75H8C7.58579 16.75 7.25 16.4142 7.25 16Z'
//         fill={isActive ? '#000' : '#9EA1A8'}
//       />
//     </svg>
//   );
// };
export const IconMenuBlogArticlesSVG = ({ size = 28, isActive = false }) => {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.9436 1.25H13.0564C14.8942 1.24998 16.3498 1.24997 17.489 1.40314C18.6614 1.56076 19.6104 1.89288 20.3588 2.64124C21.1071 3.38961 21.4392 4.33856 21.5969 5.51098C21.75 6.65019 21.75 8.10583 21.75 9.94359V14.0564C21.75 15.8942 21.75 17.3498 21.5969 18.489C21.4392 19.6614 21.1071 20.6104 20.3588 21.3588C19.6104 22.1071 18.6614 22.4392 17.489 22.5969C16.3498 22.75 14.8942 22.75 13.0564 22.75H10.9436C9.10583 22.75 7.65019 22.75 6.51098 22.5969C5.33856 22.4392 4.38961 22.1071 3.64124 21.3588C2.89288 20.6104 2.56076 19.6614 2.40314 18.489C2.24997 17.3498 2.24998 15.8942 2.25 14.0564V9.94358C2.24998 8.10582 2.24997 6.65019 2.40314 5.51098C2.56076 4.33856 2.89288 3.38961 3.64124 2.64124C4.38961 1.89288 5.33856 1.56076 6.51098 1.40314C7.65019 1.24997 9.10582 1.24998 10.9436 1.25ZM6.71085 2.88976C5.70476 3.02502 5.12511 3.27869 4.7019 3.7019C4.27869 4.12511 4.02502 4.70476 3.88976 5.71085C3.75159 6.73851 3.75 8.09318 3.75 10V14C3.75 15.9068 3.75159 17.2615 3.88976 18.2892C4.02502 19.2952 4.27869 19.8749 4.7019 20.2981C5.12511 20.7213 5.70476 20.975 6.71085 21.1102C7.73851 21.2484 9.09318 21.25 11 21.25H13C14.9068 21.25 16.2615 21.2484 17.2892 21.1102C18.2952 20.975 18.8749 20.7213 19.2981 20.2981C19.7213 19.8749 19.975 19.2952 20.1102 18.2892C20.2484 17.2615 20.25 15.9068 20.25 14V10C20.25 8.09318 20.2484 6.73851 20.1102 5.71085C19.975 4.70476 19.7213 4.12511 19.2981 3.7019C18.8749 3.27869 18.2952 3.02502 17.2892 2.88976C16.2615 2.75159 14.9068 2.75 13 2.75H11C9.09318 2.75 7.73851 2.75159 6.71085 2.88976ZM7.25 10C7.25 9.58579 7.58579 9.25 8 9.25H16C16.4142 9.25 16.75 9.58579 16.75 10C16.75 10.4142 16.4142 10.75 16 10.75H8C7.58579 10.75 7.25 10.4142 7.25 10ZM7.25 14C7.25 13.5858 7.58579 13.25 8 13.25H13C13.4142 13.25 13.75 13.5858 13.75 14C13.75 14.4142 13.4142 14.75 13 14.75H8C7.58579 14.75 7.25 14.4142 7.25 14Z'
        fill={isActive ? '#000' : '#9EA1A8'}
      />
    </svg>
  );
};
export const IconMenuAutomationSVG = ({ size = '28', isActive = false }) => {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M20.5279 10.3736C20.1572 9.73163 19.4779 9.5206 18.8294 9.42992C18.1757 9.33852 17.3008 9.33855 16.2426 9.33858L16.1824 9.33858C15.5523 9.33858 15.1403 9.33237 14.8402 9.29064C14.5688 9.2529 14.4825 9.19704 14.4456 9.16446C14.4187 9.13635 14.3706 9.07063 14.3379 8.83366C14.2993 8.55425 14.2976 8.1711 14.2976 7.55704V7.18255C14.2977 5.59503 14.2977 4.32329 14.1755 3.4166C14.0608 2.56554 13.7882 1.60969 12.844 1.32035C11.9164 1.03608 11.1384 1.64564 10.5337 2.27405C9.88942 2.9435 9.12413 3.97895 8.16596 5.27538L5.02896 9.51969C4.41863 10.3454 3.90984 11.0337 3.60669 11.6029C3.3028 12.1735 3.08164 12.8509 3.41872 13.5268L3.41989 13.5293L3.42344 13.5365L3.42748 13.5445L3.43146 13.5522L3.4358 13.5603L3.44023 13.5685L3.44441 13.576L3.44884 13.5838L3.45289 13.5907L3.45438 13.5931C3.82188 14.2296 4.49825 14.4524 5.1526 14.5523C5.82693 14.6553 6.72671 14.6619 7.81795 14.6619C8.45456 14.6619 8.86048 14.6633 9.1586 14.7013C9.42195 14.7349 9.50071 14.7867 9.53447 14.8165C9.56438 14.8478 9.61682 14.9207 9.6538 15.1663C9.69612 15.4473 9.70276 15.8364 9.70275 16.4435L9.70274 16.8178C9.7027 18.4053 9.70266 19.6771 9.82483 20.5838C9.9395 21.4349 10.2121 22.3907 11.1563 22.6801C12.0839 22.9644 12.8619 22.3548 13.4667 21.7264C14.1109 21.0569 14.8762 20.0215 15.8344 18.725L18.9338 14.5317C19.5646 13.6783 20.0834 12.9652 20.3893 12.3718C20.6887 11.7911 20.8976 11.1097 20.5636 10.44L20.5624 10.4376L20.5589 10.4303L20.5548 10.4223L20.5508 10.4146L20.5465 10.4064L20.542 10.3982L20.5378 10.3907L20.5334 10.3829L20.5293 10.3759L20.5279 10.3736ZM11.6145 3.31416C11.0465 3.90435 10.3387 4.85927 9.335 6.21733L6.27286 10.3604C5.61517 11.2502 5.17513 11.849 4.93062 12.3081C4.81161 12.5315 4.76693 12.6725 4.75421 12.7578C4.74635 12.8105 4.75115 12.8343 4.75742 12.8496C4.78161 12.8852 4.88663 12.9943 5.379 13.0695C5.9169 13.1516 6.69032 13.1619 7.81795 13.1619L7.86392 13.1619C8.44106 13.1618 8.94393 13.1618 9.3483 13.2134C9.78148 13.2686 10.2118 13.3942 10.568 13.7293L10.5739 13.7348L10.5796 13.7404C10.9296 14.0839 11.0719 14.5099 11.1371 14.9429C11.1994 15.3568 11.2028 15.8658 11.2028 16.4435L11.2027 16.753C11.2027 18.42 11.2044 19.5894 11.3114 20.3835C11.3647 20.7789 11.4363 21.0108 11.505 21.1404C11.5564 21.2374 11.586 21.2438 11.5943 21.2456L11.5958 21.2459L11.5973 21.2464C11.6078 21.25 11.6446 21.2628 11.7583 21.2056C11.9003 21.1341 12.1032 20.98 12.3858 20.6863C12.9538 20.0961 13.6616 19.1412 14.6654 17.7831L17.7275 13.6401C18.3815 12.7553 18.8172 12.1478 19.0561 11.6845C19.2608 11.2873 19.2385 11.1528 19.2249 11.1171C19.2024 11.0843 19.1016 10.9826 18.6217 10.9155C18.0846 10.8404 17.3161 10.8386 16.1824 10.8386C15.5796 10.8386 15.0567 10.8352 14.6336 10.7763C14.1968 10.7156 13.7655 10.5841 13.4123 10.252L13.4065 10.2465L13.4008 10.2409C13.0476 9.89419 12.9114 9.46874 12.852 9.03887C12.7975 8.64454 12.7976 8.15622 12.7976 7.60538L12.7976 7.24733C12.7976 5.58044 12.7959 4.41099 12.6889 3.61692C12.6356 3.22153 12.564 2.98959 12.4954 2.86008C12.4439 2.76301 12.4143 2.75666 12.406 2.75487L12.4045 2.75451L12.403 2.75401C12.3925 2.7504 12.3557 2.73767 12.242 2.79487C12.1 2.86633 11.8972 3.02042 11.6145 3.31416Z'
        fill={isActive ? '#000' : '#9EA1A8'}
      />
    </svg>
  );
};

export const IconMoreSVG = ({ size = 28, isActive = false }) => {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M4.97883 9.68508C2.99294 8.89073 2 8.49355 2 8C2 7.50645 2.99294 7.10927 4.97883 6.31492L7.7873 5.19153C9.77318 4.39718 10.7661 4 12 4C13.2339 4 14.2268 4.39718 16.2127 5.19153L19.0212 6.31492C21.0071 7.10927 22 7.50645 22 8C22 8.49355 21.0071 8.89073 19.0212 9.68508L16.2127 10.8085C14.2268 11.6028 13.2339 12 12 12C10.7661 12 9.77318 11.6028 7.7873 10.8085L4.97883 9.68508Z'
        stroke={isActive ? '#000' : '#9EA1A8'}
        strokeWidth='1.5'
      />
      <path
        d='M22 12C22 12 21.0071 12.8907 19.0212 13.6851L16.2127 14.8085C14.2268 15.6028 13.2339 16 12 16C10.7661 16 9.77318 15.6028 7.7873 14.8085L4.97883 13.6851C2.99294 12.8907 2 12 2 12'
        stroke={isActive ? '#000' : '#9EA1A8'}
        strokeWidth='1.5'
        strokeLinecap='round'
      />
      <path
        d='M22 16C22 16 21.0071 16.8907 19.0212 17.6851L16.2127 18.8085C14.2268 19.6028 13.2339 20 12 20C10.7661 20 9.77318 19.6028 7.7873 18.8085L4.97883 17.6851C2.99294 16.8907 2 16 2 16'
        stroke={isActive ? '#000' : '#9EA1A8'}
        strokeWidth='1.5'
        strokeLinecap='round'
      />
    </svg>
  );
};

export const IconEmailSVG = ({ isActive = false }) => {
  return (
    <svg width='28' height='28' viewBox='0 0 100 100' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M87 26.0005L54.2325 52.035C52.0471 53.7713 48.9529 53.7713 46.7676 52.035L14 26.0005' stroke={isActive ? '#000' : '#9EA1A8'} strokeWidth='5' strokeLinecap='round' />
      <path
        d='M84 76.8286H16C14.067 76.8286 12.5 75.2616 12.5 73.3286V25.3286C12.5 23.3956 14.067 21.8286 16 21.8286H84C85.933 21.8286 87.5 23.3956 87.5 25.3286V73.3286C87.5 75.2616 85.933 76.8286 84 76.8286Z'
        stroke={isActive ? '#000' : '#9EA1A8'}
        strokeWidth='5'
      />
    </svg>
  );
};

export const IconLinkShortenSVG = ({ isActive = false }) => {
  return (
    <svg width='28' height='28' viewBox='0 0 100 100' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M56.3468 43.6532C52.9795 40.2873 48.4133 38.3965 43.6523 38.3965C38.8912 38.3965 34.325 40.2873 30.9577 43.6532L18.2591 56.3477C14.8918 59.7151 13 64.2822 13 69.0443C13 73.8064 14.8918 78.3735 18.2591 81.7409C21.6264 85.1082 26.1935 87 30.9557 87C35.7178 87 40.2849 85.1082 43.6523 81.7409L49.9995 75.3936'
        stroke={isActive ? '#000000' : '#9EA1A8'}
        strokeWidth='5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M43.6562 56.3468C47.0235 59.7127 51.5897 61.6035 56.3508 61.6035C61.1118 61.6035 65.678 59.7127 69.0453 56.3468L81.7439 43.6523C85.1113 40.2849 87.003 35.7178 87.003 30.9557C87.003 26.1935 85.1113 21.6264 81.7439 18.2591C78.3766 14.8918 73.8095 13 69.0474 13C64.2852 13 59.7181 14.8918 56.3508 18.2591L50.0035 24.6064'
        stroke={isActive ? '#000' : '#9EA1A8'}
        strokeWidth='5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export const IconStandalonePageSVG = ({ size = 28, isActive = false }) => {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M12.9999 21.9994C17.055 21.9921 19.1784 21.8926 20.5354 20.5355C21.9999 19.0711 21.9999 16.714 21.9999 12C21.9999 7.28595 21.9999 4.92893 20.5354 3.46447C19.071 2 16.714 2 11.9999 2C7.28587 2 4.92884 2 3.46438 3.46447C2.10734 4.8215 2.00779 6.94493 2.00049 11'
        stroke={isActive ? '#000000' : '#9EA1A8'}
        strokeWidth='1.5'
        strokeLinecap='round'
      />
      <path d='M3 21L11 13M11 13H5M11 13V19' stroke={isActive ? '#000000' : '#9EA1A8'} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
};
export const IconMenuMessage = ({ size = 28, isActive = false }) => {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.9426 1.25H12.0574C14.3658 1.24999 16.1748 1.24998 17.5863 1.43975C19.031 1.63399 20.1711 2.03933 21.0659 2.93414C21.9607 3.82895 22.366 4.96897 22.5603 6.41371C22.75 7.82519 22.75 9.63423 22.75 11.9426V12.0574C22.75 12.3718 22.75 12.6769 22.7495 12.9731C22.7498 12.982 22.75 12.991 22.75 13C22.75 13.0099 22.7498 13.0197 22.7494 13.0296C22.746 14.8816 22.7225 16.3793 22.5603 17.5863C22.366 19.031 21.9607 20.1711 21.0659 21.0659C20.1711 21.9607 19.031 22.366 17.5863 22.5603C16.1748 22.75 14.3658 22.75 12.0574 22.75H11.9426C9.63423 22.75 7.82519 22.75 6.41371 22.5603C4.96897 22.366 3.82895 21.9607 2.93414 21.0659C2.03933 20.1711 1.63399 19.031 1.43975 17.5863C1.27747 16.3793 1.25397 14.8816 1.25057 13.0295C1.25019 13.0197 1.25 13.0099 1.25 13C1.25 12.991 1.25016 12.982 1.25047 12.9731C1.25 12.6769 1.25 12.3718 1.25 12.0574V11.9426C1.24999 9.63423 1.24998 7.82519 1.43975 6.41371C1.63399 4.96897 2.03933 3.82895 2.93414 2.93414C3.82895 2.03933 4.96897 1.63399 6.41371 1.43975C7.82519 1.24998 9.63423 1.24999 11.9426 1.25ZM2.7535 13.75C2.76294 15.2526 2.79778 16.43 2.92637 17.3864C3.09825 18.6648 3.42514 19.4355 3.9948 20.0052C4.56445 20.5749 5.33517 20.9018 6.61358 21.0736C7.91356 21.2484 9.62178 21.25 12 21.25C14.3782 21.25 16.0864 21.2484 17.3864 21.0736C18.6648 20.9018 19.4355 20.5749 20.0052 20.0052C20.5749 19.4355 20.9018 18.6648 21.0736 17.3864C21.2022 16.43 21.2371 15.2526 21.2465 13.75H18.8397C17.8659 13.75 17.6113 13.766 17.3975 13.8644C17.1838 13.9627 17.0059 14.1456 16.3722 14.8849L15.7667 15.5913C15.7372 15.6257 15.7082 15.6597 15.6794 15.6933C15.1773 16.2803 14.7796 16.7453 14.2292 16.9984C13.6789 17.2515 13.067 17.2509 12.2945 17.2501C12.2503 17.25 12.2056 17.25 12.1603 17.25H11.8397C11.7944 17.25 11.7497 17.25 11.7055 17.2501C10.933 17.2509 10.3211 17.2515 9.77076 16.9984C9.22039 16.7453 8.82271 16.2803 8.32059 15.6933C8.29184 15.6597 8.26275 15.6257 8.23327 15.5913L7.62784 14.8849C6.9941 14.1456 6.81622 13.9627 6.60245 13.8644C6.38869 13.766 6.13407 13.75 5.16026 13.75H2.7535ZM21.25 12.25H18.8397C18.7944 12.25 18.7497 12.25 18.7055 12.2499C17.933 12.2491 17.3211 12.2485 16.7708 12.5016C16.2204 12.7547 15.8227 13.2197 15.3206 13.8067C15.2918 13.8403 15.2628 13.8743 15.2333 13.9087L14.6278 14.6151C13.9941 15.3544 13.8162 15.5373 13.6025 15.6356C13.3887 15.734 13.1341 15.75 12.1603 15.75H11.8397C10.8659 15.75 10.6113 15.734 10.3975 15.6356C10.1838 15.5373 10.0059 15.3544 9.37216 14.6151L8.76673 13.9087C8.73725 13.8743 8.70816 13.8403 8.67941 13.8067C8.17729 13.2197 7.77961 12.7547 7.22924 12.5016C6.67886 12.2485 6.06705 12.2491 5.29454 12.2499C5.25031 12.25 5.20556 12.25 5.16026 12.25H2.75001C2.75 12.1675 2.75 12.0842 2.75 12C2.75 9.62178 2.75159 7.91356 2.92637 6.61358C3.09825 5.33517 3.42514 4.56445 3.9948 3.9948C4.56445 3.42514 5.33517 3.09825 6.61358 2.92637C7.91356 2.75159 9.62178 2.75 12 2.75C14.3782 2.75 16.0864 2.75159 17.3864 2.92637C18.6648 3.09825 19.4355 3.42514 20.0052 3.9948C20.5749 4.56445 20.9018 5.33517 21.0736 6.61358C21.2484 7.91356 21.25 9.62178 21.25 12C21.25 12.0842 21.25 12.1675 21.25 12.25Z'
        fill={isActive ? '#000000' : '#9EA1A8'}
      />
    </svg>
  );
};

export const IconSmartReplySVG = ({ size = 28, isActive = false }) => {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M22 10.5V12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2H13.5'
        stroke={isActive ? '#000000' : '#9EA1A8'}
        strokeWidth='1.5'
        strokeLinecap='round'
      />
      <circle cx='19' cy='5' r='3' stroke={isActive ? '#000000' : '#9EA1A8'} strokeWidth='1.5' />
    </svg>
  );
};

export function IconForwardActiveSVG({ color = '#ffbc49' }) {
  return (
    <svg width={22} height={22} viewBox='0 0 512 512' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_693_6972)'>
        <path
          d='M276.007 84V163.872C96.006 182 78.0562 323.426 56.0065 427.5C55.174 431.613 132.004 283.681 276.007 283.681V363.554L456.004 223.777L276.007 84Z'
          stroke={color}
          strokeWidth='25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_693_6972'>
          <rect width='512' height='512' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
}

export function IconForwardSVG({ color = '#acb5bf' }) {
  return (
    <svg width='22' height='22' viewBox='0 0 512 512' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_693_6972)'>
        <path
          d='M276.007 84V163.872C96.006 182 78.0562 323.426 56.0065 427.5C55.174 431.613 132.004 283.681 276.007 283.681V363.554L456.004 223.777L276.007 84Z'
          stroke={color}
          strokeWidth='25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_693_6972'>
          <rect width='512' height='512' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
}

export function IconMenuDotsSVG() {
  return (
    <svg
      className='MuiSvgIcon-root MuiSvgIcon-fontSizeMedium fill-black h-12 hover:text-gray-700 transition-colors w-12 css-vubbuv'
      focusable='false'
      aria-hidden='true'
      viewBox='0 0 24 24'
      data-testid='MoreHorizIcon'
    >
      <path d='M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z' />
    </svg>
  );
}

export function IconCopyLinkSVG({ size = 20, color = '#000000' }) {
  return (
    <svg height={size} width={size} fill={color} viewBox='-21 0 512 512' xmlns='http://www.w3.org/2000/svg' className='ButtonLinkMenuItemIcon'>
      <path d='m325.332031 512h-266.664062c-32.363281 0-58.667969-26.304688-58.667969-58.667969v-288c0-32.363281 26.304688-58.664062 58.667969-58.664062h10.664062c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16h-10.664062c-14.699219 0-26.667969 11.964843-26.667969 26.664062v288c0 14.699219 11.96875 26.667969 26.667969 26.667969h266.664062c14.699219 0 26.667969-11.96875 26.667969-26.667969v-10.664062c0-8.832031 7.167969-16 16-16s16 7.167969 16 16v10.664062c0 32.363281-26.304688 58.667969-58.667969 58.667969zm0 0' />
      <path d='m410.667969 384h-224c-32.363281 0-58.667969-26.304688-58.667969-58.667969v-266.664062c0-32.363281 26.304688-58.667969 58.667969-58.667969h224c32.363281 0 58.664062 26.304688 58.664062 58.667969v266.664062c0 32.363281-26.300781 58.667969-58.664062 58.667969zm-224-352c-14.699219 0-26.667969 11.96875-26.667969 26.667969v266.664062c0 14.699219 11.96875 26.667969 26.667969 26.667969h224c14.699219 0 26.664062-11.96875 26.664062-26.667969v-266.664062c0-14.699219-11.964843-26.667969-26.664062-26.667969zm0 0' />
    </svg>
  );
}
export function IconDirectionSVG({ size = '22px', color = '#000' }) {
  return (
    <svg enableBackground='new 0 0 512.024 512.024' fill={color} height={size} viewBox='0 0 512.024 512.024' width={size} xmlns='http://www.w3.org/2000/svg'>
      <path d='m496.012 217.385-201.373-201.373c-21.349-21.347-55.902-21.351-77.254 0l-201.373 201.373c-21.349 21.348-21.35 55.906 0 77.255l201.373 201.373c21.349 21.347 55.902 21.351 77.254 0l201.373-201.373c21.349-21.348 21.351-55.906 0-77.255zm-22.627 54.627-201.373 201.373c-8.844 8.843-23.155 8.844-32 0l-201.373-201.373c-8.842-8.842-8.843-23.155 0-32l201.373-201.372c8.844-8.843 23.155-8.844 32 0l201.373 201.373c0 .282 6.627 5.472 6.627 16 0 6.044-2.353 11.725-6.627 15.999z' />
      <path d='m373.372 206.338c-1.253-1.898 2.612 2.216-56.236-57.551-6.2-6.297-16.331-6.376-22.627-.175-6.297 6.2-6.375 16.33-.176 22.626l28.332 28.774h-154.653c-8.837 0-16 7.164-16 16v104c0 8.836 7.163 16 16 16s16-7.164 16-16v-88h136.93l-28.332 28.774c-9.985 10.141-2.666 27.226 11.4 27.226 4.137 0 8.271-1.594 11.402-4.774l52.508-53.329c8.912-5.083 10.085-16.561 5.452-23.571z' />
    </svg>
  );
}

export function IconSettingsLinkSVG({ color = '#adc6ff', size = '20px' }) {
  return (
    <svg aria-hidden='true' focusable='false' data-prefix='fas' className='ButtonLinkMenuItemIcon' data-icon='cog' role='img' width={size} height={size} viewBox='0 0 512 512'>
      <path
        className='ButtonLinkMenuItemIcon'
        fill={color}
        d='M487.4 315.7l-42.6-24.6c4.3-23.2 4.3-47 0-70.2l42.6-24.6c4.9-2.8 7.1-8.6 5.5-14-11.1-35.6-30-67.8-54.7-94.6-3.8-4.1-10-5.1-14.8-2.3L380.8 110c-17.9-15.4-38.5-27.3-60.8-35.1V25.8c0-5.6-3.9-10.5-9.4-11.7-36.7-8.2-74.3-7.8-109.2 0-5.5 1.2-9.4 6.1-9.4 11.7V75c-22.2 7.9-42.8 19.8-60.8 35.1L88.7 85.5c-4.9-2.8-11-1.9-14.8 2.3-24.7 26.7-43.6 58.9-54.7 94.6-1.7 5.4.6 11.2 5.5 14L67.3 221c-4.3 23.2-4.3 47 0 70.2l-42.6 24.6c-4.9 2.8-7.1 8.6-5.5 14 11.1 35.6 30 67.8 54.7 94.6 3.8 4.1 10 5.1 14.8 2.3l42.6-24.6c17.9 15.4 38.5 27.3 60.8 35.1v49.2c0 5.6 3.9 10.5 9.4 11.7 36.7 8.2 74.3 7.8 109.2 0 5.5-1.2 9.4-6.1 9.4-11.7v-49.2c22.2-7.9 42.8-19.8 60.8-35.1l42.6 24.6c4.9 2.8 11 1.9 14.8-2.3 24.7-26.7 43.6-58.9 54.7-94.6 1.5-5.5-.7-11.3-5.6-14.1zM256 336c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z'
      />
    </svg>
  );
}

export function IconRefreshLinkSVG({ color = '#adc6ff', size = '20px' }) {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M3.67981 11.3333H2.92981H3.67981ZM3.67981 13L3.15157 13.5324C3.44398 13.8225 3.91565 13.8225 4.20805 13.5324L3.67981 13ZM5.88787 11.8657C6.18191 11.574 6.18377 11.0991 5.89203 10.8051C5.60029 10.511 5.12542 10.5092 4.83138 10.8009L5.88787 11.8657ZM2.52824 10.8009C2.2342 10.5092 1.75933 10.511 1.46759 10.8051C1.17585 11.0991 1.17772 11.574 1.47176 11.8657L2.52824 10.8009ZM18.6156 7.39279C18.8325 7.74565 19.2944 7.85585 19.6473 7.63892C20.0001 7.42199 20.1103 6.96007 19.8934 6.60721L18.6156 7.39279ZM12.0789 2.25C7.03155 2.25 2.92981 6.3112 2.92981 11.3333H4.42981C4.42981 7.15072 7.84884 3.75 12.0789 3.75V2.25ZM2.92981 11.3333L2.92981 13H4.42981L4.42981 11.3333H2.92981ZM4.20805 13.5324L5.88787 11.8657L4.83138 10.8009L3.15157 12.4676L4.20805 13.5324ZM4.20805 12.4676L2.52824 10.8009L1.47176 11.8657L3.15157 13.5324L4.20805 12.4676ZM19.8934 6.60721C18.287 3.99427 15.3873 2.25 12.0789 2.25V3.75C14.8484 3.75 17.2727 5.20845 18.6156 7.39279L19.8934 6.60721Z'
        fill={color}
      />
      <path
        d='M20.3139 11L20.8411 10.4666C20.549 10.1778 20.0788 10.1778 19.7867 10.4666L20.3139 11ZM18.1004 12.1333C17.8058 12.4244 17.8031 12.8993 18.0942 13.1939C18.3854 13.4885 18.8603 13.4913 19.1549 13.2001L18.1004 12.1333ZM21.4729 13.2001C21.7675 13.4913 22.2424 13.4885 22.5335 13.1939C22.8247 12.8993 22.822 12.4244 22.5274 12.1332L21.4729 13.2001ZM5.31794 16.6061C5.1004 16.2536 4.6383 16.1442 4.28581 16.3618C3.93331 16.5793 3.82391 17.0414 4.04144 17.3939L5.31794 16.6061ZM11.8827 21.75C16.9451 21.75 21.0639 17.6915 21.0639 12.6667H19.5639C19.5639 16.8466 16.1332 20.25 11.8827 20.25V21.75ZM21.0639 12.6667V11H19.5639V12.6667H21.0639ZM19.7867 10.4666L18.1004 12.1333L19.1549 13.2001L20.8411 11.5334L19.7867 10.4666ZM19.7867 11.5334L21.4729 13.2001L22.5274 12.1332L20.8411 10.4666L19.7867 11.5334ZM4.04144 17.3939C5.65405 20.007 8.56403 21.75 11.8827 21.75V20.25C9.10023 20.25 6.66584 18.7903 5.31794 16.6061L4.04144 17.3939Z'
        fill={color}
      />
    </svg>
  );
}

export function IconNewPageSVG({ color = '#adc6ff', size = '20px' }) {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.25 14.5001C5.25 14.0858 5.58579 13.7501 6 13.7501H14C14.4142 13.7501 14.75 14.0858 14.75 14.5001C14.75 14.9143 14.4142 15.2501 14 15.2501H6C5.58579 15.2501 5.25 14.9143 5.25 14.5001Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.25 18C5.25 17.5858 5.58579 17.25 6 17.25H11.5C11.9142 17.25 12.25 17.5858 12.25 18C12.25 18.4143 11.9142 18.75 11.5 18.75H6C5.58579 18.75 5.25 18.4143 5.25 18Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.25 2.83422C11.7896 2.75598 11.162 2.75005 10.0298 2.75005C8.11311 2.75005 6.75075 2.75163 5.71785 2.88987C4.70596 3.0253 4.12453 3.27933 3.7019 3.70195C3.27869 4.12516 3.02502 4.70481 2.88976 5.7109C2.75159 6.73856 2.75 8.09323 2.75 10.0001V14.0001C2.75 15.9069 2.75159 17.2615 2.88976 18.2892C3.02502 19.2953 3.27869 19.8749 3.7019 20.2981C4.12511 20.7214 4.70476 20.975 5.71085 21.1103C6.73851 21.2485 8.09318 21.2501 10 21.2501H14C15.9068 21.2501 17.2615 21.2485 18.2892 21.1103C19.2952 20.975 19.8749 20.7214 20.2981 20.2981C20.7213 19.8749 20.975 19.2953 21.1102 18.2892C21.2484 17.2615 21.25 15.9069 21.25 14.0001V13.5629C21.25 12.0269 21.2392 11.2988 21.0762 10.7501H17.9463C16.8135 10.7501 15.8877 10.7501 15.1569 10.6518C14.3929 10.5491 13.7306 10.3268 13.2019 9.79815C12.6732 9.26945 12.4509 8.60712 12.3482 7.84317C12.25 7.1123 12.25 6.18657 12.25 5.05374V2.83422ZM13.75 3.6095V5.00005C13.75 6.19976 13.7516 7.0241 13.8348 7.64329C13.9152 8.24091 14.059 8.53395 14.2626 8.73749C14.4661 8.94103 14.7591 9.08486 15.3568 9.16521C15.976 9.24846 16.8003 9.25005 18 9.25005H20.0195C19.723 8.9625 19.3432 8.61797 18.85 8.17407L14.8912 4.61117C14.4058 4.17433 14.0446 3.85187 13.75 3.6095ZM10.1755 1.25002C11.5601 1.24965 12.4546 1.24942 13.2779 1.56535C14.1012 1.88129 14.7632 2.47735 15.7873 3.39955C15.8226 3.43139 15.8584 3.46361 15.8947 3.49623L19.8534 7.05912C19.8956 7.09705 19.9372 7.1345 19.9783 7.17149C21.162 8.23614 21.9274 8.92458 22.3391 9.84902C22.7508 10.7734 22.7505 11.8029 22.75 13.3949C22.75 13.4502 22.75 13.5062 22.75 13.5629V14.0565C22.75 15.8942 22.75 17.3499 22.5969 18.4891C22.4392 19.6615 22.1071 20.6104 21.3588 21.3588C20.6104 22.1072 19.6614 22.4393 18.489 22.5969C17.3498 22.7501 15.8942 22.7501 14.0564 22.7501H9.94359C8.10583 22.7501 6.65019 22.7501 5.51098 22.5969C4.33856 22.4393 3.38961 22.1072 2.64124 21.3588C1.89288 20.6104 1.56076 19.6615 1.40314 18.4891C1.24997 17.3499 1.24998 15.8942 1.25 14.0565V9.94363C1.24998 8.10587 1.24997 6.65024 1.40314 5.51103C1.56076 4.33861 1.89288 3.38966 2.64124 2.64129C3.39019 1.89235 4.34232 1.56059 5.51887 1.40313C6.66283 1.25002 8.1257 1.25003 9.97352 1.25005L10.0298 1.25005C10.0789 1.25005 10.1275 1.25004 10.1755 1.25002Z'
        fill={color}
      />
    </svg>
  );
}

export function IconSettingsPageSVG({ color = '#adc6ff', size = '20px' }) {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='12' cy='12' r='3' stroke={color} strokeWidth='1.5' />
      <path
        d='M13.7654 2.15224C13.3978 2 12.9319 2 12 2C11.0681 2 10.6022 2 10.2346 2.15224C9.74457 2.35523 9.35522 2.74458 9.15223 3.23463C9.05957 3.45834 9.0233 3.7185 9.00911 4.09799C8.98826 4.65568 8.70226 5.17189 8.21894 5.45093C7.73564 5.72996 7.14559 5.71954 6.65219 5.45876C6.31645 5.2813 6.07301 5.18262 5.83294 5.15102C5.30704 5.08178 4.77518 5.22429 4.35436 5.5472C4.03874 5.78938 3.80577 6.1929 3.33983 6.99993C2.87389 7.80697 2.64092 8.21048 2.58899 8.60491C2.51976 9.1308 2.66227 9.66266 2.98518 10.0835C3.13256 10.2756 3.3397 10.437 3.66119 10.639C4.1338 10.936 4.43789 11.4419 4.43786 12C4.43783 12.5581 4.13375 13.0639 3.66118 13.3608C3.33965 13.5629 3.13248 13.7244 2.98508 13.9165C2.66217 14.3373 2.51966 14.8691 2.5889 15.395C2.64082 15.7894 2.87379 16.193 3.33973 17C3.80568 17.807 4.03865 18.2106 4.35426 18.4527C4.77508 18.7756 5.30694 18.9181 5.83284 18.8489C6.07289 18.8173 6.31632 18.7186 6.65204 18.5412C7.14547 18.2804 7.73556 18.27 8.2189 18.549C8.70224 18.8281 8.98826 19.3443 9.00911 19.9021C9.02331 20.2815 9.05957 20.5417 9.15223 20.7654C9.35522 21.2554 9.74457 21.6448 10.2346 21.8478C10.6022 22 11.0681 22 12 22C12.9319 22 13.3978 22 13.7654 21.8478C14.2554 21.6448 14.6448 21.2554 14.8477 20.7654C14.9404 20.5417 14.9767 20.2815 14.9909 19.902C15.0117 19.3443 15.2977 18.8281 15.781 18.549C16.2643 18.2699 16.8544 18.2804 17.3479 18.5412C17.6836 18.7186 17.927 18.8172 18.167 18.8488C18.6929 18.9181 19.2248 18.7756 19.6456 18.4527C19.9612 18.2105 20.1942 17.807 20.6601 16.9999C21.1261 16.1929 21.3591 15.7894 21.411 15.395C21.4802 14.8691 21.3377 14.3372 21.0148 13.9164C20.8674 13.7243 20.6602 13.5628 20.3387 13.3608C19.8662 13.0639 19.5621 12.558 19.5621 11.9999C19.5621 11.4418 19.8662 10.9361 20.3387 10.6392C20.6603 10.4371 20.8675 10.2757 21.0149 10.0835C21.3378 9.66273 21.4803 9.13087 21.4111 8.60497C21.3592 8.21055 21.1262 7.80703 20.6602 7C20.1943 6.19297 19.9613 5.78945 19.6457 5.54727C19.2249 5.22436 18.693 5.08185 18.1671 5.15109C17.9271 5.18269 17.6837 5.28136 17.3479 5.4588C16.8545 5.71959 16.2644 5.73002 15.7811 5.45096C15.2977 5.17191 15.0117 4.65566 14.9909 4.09794C14.9767 3.71848 14.9404 3.45833 14.8477 3.23463C14.6448 2.74458 14.2554 2.35523 13.7654 2.15224Z'
        stroke={color}
        strokeWidth='1.5'
      />
    </svg>
  );
}

export function IconSettingsMinimalPageSVG({ color = '#adc6ff', size = '20px' }) {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12 8.25C9.92893 8.25 8.25 9.92893 8.25 12C8.25 14.0711 9.92893 15.75 12 15.75C14.0711 15.75 15.75 14.0711 15.75 12C15.75 9.92893 14.0711 8.25 12 8.25ZM9.75 12C9.75 10.7574 10.7574 9.75 12 9.75C13.2426 9.75 14.25 10.7574 14.25 12C14.25 13.2426 13.2426 14.25 12 14.25C10.7574 14.25 9.75 13.2426 9.75 12Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12 1.25C11.2954 1.25 10.6519 1.44359 9.94858 1.77037C9.26808 2.08656 8.48039 2.55304 7.49457 3.13685L6.74148 3.58283C5.75533 4.16682 4.96771 4.63324 4.36076 5.07944C3.73315 5.54083 3.25177 6.01311 2.90334 6.63212C2.55548 7.25014 2.39841 7.91095 2.32306 8.69506C2.24999 9.45539 2.24999 10.3865 2.25 11.556V12.444C2.24999 13.6135 2.24999 14.5446 2.32306 15.3049C2.39841 16.0891 2.55548 16.7499 2.90334 17.3679C3.25177 17.9869 3.73315 18.4592 4.36076 18.9206C4.96771 19.3668 5.75533 19.8332 6.74148 20.4172L7.4946 20.8632C8.48038 21.447 9.2681 21.9135 9.94858 22.2296C10.6519 22.5564 11.2954 22.75 12 22.75C12.7046 22.75 13.3481 22.5564 14.0514 22.2296C14.7319 21.9134 15.5196 21.447 16.5054 20.8632L17.2585 20.4172C18.2446 19.8332 19.0323 19.3668 19.6392 18.9206C20.2669 18.4592 20.7482 17.9869 21.0967 17.3679C21.4445 16.7499 21.6016 16.0891 21.6769 15.3049C21.75 14.5446 21.75 13.6135 21.75 12.4441V11.556C21.75 10.3866 21.75 9.45538 21.6769 8.69506C21.6016 7.91095 21.4445 7.25014 21.0967 6.63212C20.7482 6.01311 20.2669 5.54083 19.6392 5.07944C19.0323 4.63324 18.2447 4.16683 17.2585 3.58285L16.5054 3.13685C15.5196 2.55303 14.7319 2.08656 14.0514 1.77037C13.3481 1.44359 12.7046 1.25 12 1.25ZM8.22524 4.44744C9.25238 3.83917 9.97606 3.41161 10.5807 3.13069C11.1702 2.85676 11.5907 2.75 12 2.75C12.4093 2.75 12.8298 2.85676 13.4193 3.13069C14.0239 3.41161 14.7476 3.83917 15.7748 4.44744L16.4609 4.85379C17.4879 5.46197 18.2109 5.89115 18.7508 6.288C19.2767 6.67467 19.581 6.99746 19.7895 7.36788C19.9986 7.73929 20.1199 8.1739 20.1838 8.83855C20.2492 9.51884 20.25 10.378 20.25 11.5937V12.4063C20.25 13.622 20.2492 14.4812 20.1838 15.1614C20.1199 15.8261 19.9986 16.2607 19.7895 16.6321C19.581 17.0025 19.2767 17.3253 18.7508 17.712C18.2109 18.1089 17.4879 18.538 16.4609 19.1462L15.7748 19.5526C14.7476 20.1608 14.0239 20.5884 13.4193 20.8693C12.8298 21.1432 12.4093 21.25 12 21.25C11.5907 21.25 11.1702 21.1432 10.5807 20.8693C9.97606 20.5884 9.25238 20.1608 8.22524 19.5526L7.53909 19.1462C6.5121 18.538 5.78906 18.1089 5.24923 17.712C4.72326 17.3253 4.419 17.0025 4.2105 16.6321C4.00145 16.2607 3.88005 15.8261 3.81618 15.1614C3.7508 14.4812 3.75 13.622 3.75 12.4063V11.5937C3.75 10.378 3.7508 9.51884 3.81618 8.83855C3.88005 8.1739 4.00145 7.73929 4.2105 7.36788C4.419 6.99746 4.72326 6.67467 5.24923 6.288C5.78906 5.89115 6.5121 5.46197 7.53909 4.85379L8.22524 4.44744Z'
        fill={color}
      />
    </svg>
  );
}

export function IconMinimizePageSVG({ color = '#adc6ff', size = '20px' }) {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M2 22L9 15M9 15H3.14286M9 15V20.8571' stroke={color} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M22 2L15 9M15 9H20.8571M15 9V3.14286' stroke={color} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
}

export function IconMaximizePageSVG({ color = '#adc6ff', size = '20px' }) {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M9 15L2 22M2 22H7.85714M2 22V16.1429' stroke={color} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M15 9L22 2M22 2H16.1429M22 2V7.85714' stroke={color} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
}

export function IconTrashLinkSVG({ size = '20px' }) {
  return (
    <svg aria-hidden='true' focusable='false' data-prefix='fas' className='ButtonLinkMenuItemIcon' data-icon='trash' role='img' width={size} height={size} viewBox='0 0 448 512'>
      <path
        className='ButtonLinkMenuItemIcon'
        fill='#adc6ff'
        d='M432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32z'
      />
    </svg>
  );
}

export function IconVideoTypeSVG({ size = '20px' }) {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M2 11.5C2 8.21252 2 6.56878 2.90796 5.46243C3.07418 5.25989 3.25989 5.07418 3.46243 4.90796C4.56878 4 6.21252 4 9.5 4C12.7875 4 14.4312 4 15.5376 4.90796C15.7401 5.07418 15.9258 5.25989 16.092 5.46243C17 6.56878 17 8.21252 17 11.5V12.5C17 15.7875 17 17.4312 16.092 18.5376C15.9258 18.7401 15.7401 18.9258 15.5376 19.092C14.4312 20 12.7875 20 9.5 20C6.21252 20 4.56878 20 3.46243 19.092C3.25989 18.9258 3.07418 18.7401 2.90796 18.5376C2 17.4312 2 15.7875 2 12.5V11.5Z'
        stroke='#1C274C'
        strokeWidth='1.5'
      />
      <path
        d='M17 9.50019L17.6584 9.17101C19.6042 8.19807 20.5772 7.7116 21.2886 8.15127C22 8.59094 22 9.67872 22 11.8543V12.1461C22 14.3217 22 15.4094 21.2886 15.8491C20.5772 16.2888 19.6042 15.8023 17.6584 14.8294L17 14.5002V9.50019Z'
        stroke='#1C274C'
        strokeWidth='1.5'
      />
    </svg>
  );
}

export function IconImageTypeSVG({ size = '20px' }) {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C22 4.92893 22 7.28595 22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12Z'
        stroke='#1C274C'
        strokeWidth='1.5'
      />
      <circle cx='16' cy='8' r='2' stroke='#1C274C' strokeWidth='1.5' />
      <path
        d='M2 12.5001L3.75159 10.9675C4.66286 10.1702 6.03628 10.2159 6.89249 11.0721L11.1822 15.3618C11.8694 16.0491 12.9512 16.1428 13.7464 15.5839L14.0446 15.3744C15.1888 14.5702 16.7369 14.6634 17.7765 15.599L21 18.5001'
        stroke='#1C274C'
        strokeWidth='1.5'
        strokeLinecap='round'
      />
    </svg>
  );
}

export function IconPlusSVG({ size = '18px' }) {
  return (
    <svg fill='#adc6ff' version='1.1' id='Capa_1' xmlns='http://www.w3.org/2000/svg' width={size} height={size} viewBox='0 0 45.402 45.402'>
      <g>
        <path
          d='M41.267,18.557H26.832V4.134C26.832,1.851,24.99,0,22.707,0c-2.283,0-4.124,1.851-4.124,4.135v14.432H4.141
c-2.283,0-4.139,1.851-4.138,4.135c-0.001,1.141,0.46,2.187,1.207,2.934c0.748,0.749,1.78,1.222,2.92,1.222h14.453V41.27
c0,1.142,0.453,2.176,1.201,2.922c0.748,0.748,1.777,1.211,2.919,1.211c2.282,0,4.129-1.851,4.129-4.133V26.857h14.435
c2.283,0,4.134-1.867,4.133-4.15C45.399,20.425,43.548,18.557,41.267,18.557z'
        />
      </g>
    </svg>
  );
}

export function IconReplaceSVG({ size = '24px' }) {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M19.9381 13C19.979 12.6724 20 12.3387 20 12C20 7.58172 16.4183 4 12 4C9.49942 4 7.26681 5.14727 5.7998 6.94416M4.06189 11C4.02104 11.3276 4 11.6613 4 12C4 16.4183 7.58172 20 12 20C14.3894 20 16.5341 18.9525 18 17.2916M15 17H18V17.2916M5.7998 4V6.94416M5.7998 6.94416V6.99993L8.7998 7M18 20V17.2916'
        stroke='#adc6ff'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}

export function IconPreviewLinkSVG({ color = '#000', size = '18' }) {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M10 16H7C4.79086 16 3 14.2091 3 12V12C3 9.79086 4.79086 8 7 8H10' stroke={color} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M16 12H8' stroke={color} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M14 16H17C19.2091 16 21 14.2091 21 12V12C21 9.79086 19.2091 8 17 8H14' stroke={color} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
}
export function IconAddButtonSVG({ color = '#000', width = '18', height = '18' }) {
  return (
    <svg width={width} height={height} viewBox='0 0 800 800' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M687 400.5H399.5M399.5 400.5H112M399.5 400.5V113M399.5 400.5V688' stroke={color} strokeWidth='50' strokeLinecap='round' />
    </svg>
  );
}
export function InactiveBtnSvg({ color = 'rgb(122, 122, 122)', width = '18', height = '18' }) {
  return (
    <svg width='800' height='800' viewBox='0 0 800 800' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M400 275C330.964 275 275 330.964 275 400C275 469.037 330.964 525 400 525C469.037 525 525 469.037 525 400C525 330.964 469.037 275 400 275ZM325 400C325 358.58 358.58 325 400 325C441.42 325 475 358.58 475 400C475 441.42 441.42 475 400 475C358.58 475 325 441.42 325 400Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M400 108.334C249.529 108.334 148.177 198.474 89.3527 274.896L88.2917 276.274C74.9883 293.552 62.7357 309.465 54.4233 328.281C45.5217 348.431 41.667 370.391 41.667 400.001C41.667 429.611 45.5217 451.571 54.4233 471.721C62.7357 490.537 74.9883 506.451 88.292 523.727L89.3527 525.104C148.177 601.527 249.529 691.667 400 691.667C550.47 691.667 651.824 601.527 710.647 525.104L711.707 523.727C725.014 506.451 737.264 490.537 745.577 471.721C754.48 451.571 758.334 429.611 758.334 400.001C758.334 370.391 754.48 348.431 745.577 328.281C737.264 309.464 725.014 293.551 711.707 276.273L710.647 274.896C651.824 198.474 550.47 108.334 400 108.334ZM128.974 305.394C183.288 234.831 271.679 158.334 400 158.334C528.32 158.334 616.714 234.831 671.027 305.394C685.647 324.387 694.21 335.737 699.84 348.484C705.107 360.401 708.334 374.964 708.334 400.001C708.334 425.037 705.107 439.601 699.84 451.517C694.21 464.264 685.647 475.614 671.027 494.607C616.714 565.171 528.32 641.667 400 641.667C271.679 641.667 183.288 565.171 128.974 494.607C114.355 475.614 105.792 464.264 100.159 451.517C94.895 439.601 91.667 425.037 91.667 400.001C91.667 374.964 94.895 360.401 100.159 348.484C105.792 335.737 114.355 324.387 128.974 305.394Z'
        fill={color}
      />
      <line x1='727.215' y1='147.448' x2='69.4478' y2='661.785' stroke={color} strokeWidth='79' strokeLinecap='round' />
    </svg>
  );
}

export function IconShareLinkSVG({ size = 16, color }) {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12 1.25C12.2189 1.25 12.427 1.34567 12.5694 1.51191L15.5694 5.01191C15.839 5.3264 15.8026 5.79988 15.4881 6.06944C15.1736 6.33901 14.7001 6.30259 14.4306 5.98809L12.75 4.02744L12.75 15C12.75 15.4142 12.4142 15.75 12 15.75C11.5858 15.75 11.25 15.4142 11.25 15L11.25 4.02744L9.56944 5.98809C9.29988 6.30259 8.8264 6.33901 8.51191 6.06944C8.19741 5.79988 8.16099 5.3264 8.43056 5.01191L11.4306 1.51191C11.573 1.34567 11.7811 1.25 12 1.25ZM6.99583 8.25196C7.41003 8.24966 7.74768 8.58357 7.74999 8.99778C7.7523 9.41198 7.41838 9.74963 7.00418 9.75194C5.91068 9.75803 5.1356 9.78642 4.54735 9.89448C3.98054 9.99859 3.65246 10.1658 3.40901 10.4092C3.13225 10.686 2.9518 11.0746 2.85315 11.8083C2.75159 12.5637 2.75 13.5648 2.75 15.0002V16.0002C2.75 17.4356 2.75159 18.4367 2.85315 19.1921C2.9518 19.9259 3.13225 20.3144 3.40901 20.5912C3.68577 20.868 4.07434 21.0484 4.80812 21.1471C5.56347 21.2486 6.56458 21.2502 8 21.2502H16C17.4354 21.2502 18.4365 21.2486 19.1919 21.1471C19.9257 21.0484 20.3142 20.868 20.591 20.5912C20.8678 20.3144 21.0482 19.9259 21.1469 19.1921C21.2484 18.4367 21.25 17.4356 21.25 16.0002V15.0002C21.25 13.5648 21.2484 12.5637 21.1469 11.8083C21.0482 11.0746 20.8678 10.686 20.591 10.4092C20.3475 10.1658 20.0195 9.99859 19.4527 9.89448C18.8644 9.78642 18.0893 9.75803 16.9958 9.75194C16.5816 9.74963 16.2477 9.41198 16.25 8.99778C16.2523 8.58357 16.59 8.24966 17.0042 8.25196C18.0857 8.25798 18.9871 8.28387 19.7236 8.41916C20.4816 8.55839 21.1267 8.82363 21.6517 9.34856C22.2536 9.95048 22.5125 10.7084 22.6335 11.6085C22.75 12.4754 22.75 13.5778 22.75 14.9453V16.0551C22.75 17.4227 22.75 18.525 22.6335 19.392C22.5125 20.2921 22.2536 21.0499 21.6517 21.6519C21.0497 22.2538 20.2919 22.5127 19.3918 22.6337C18.5248 22.7503 17.4225 22.7502 16.0549 22.7502H7.94513C6.57754 22.7502 5.47522 22.7503 4.60825 22.6337C3.70814 22.5127 2.95027 22.2538 2.34835 21.6519C1.74643 21.0499 1.48754 20.2921 1.36652 19.392C1.24996 18.525 1.24998 17.4227 1.25 16.0551V14.9453C1.24998 13.5777 1.24996 12.4754 1.36652 11.6085C1.48754 10.7084 1.74643 9.95048 2.34835 9.34856C2.87328 8.82363 3.51835 8.55839 4.27635 8.41916C5.01291 8.28386 5.9143 8.25798 6.99583 8.25196Z'
        fill={color}
      />
    </svg>
  );
}

export function IconShareWebsiteSVG({ size = 16, color }) {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M12 1.25H11.9426C9.63423 1.24999 7.82519 1.24998 6.41371 1.43975C4.96897 1.63399 3.82895 2.03933 2.93414 2.93414C2.03933 3.82895 1.63399 4.96897 1.43975 6.41371C1.24998 7.82519 1.24999 9.63423 1.25 11.9426V12.0574C1.24999 14.3658 1.24998 16.1748 1.43975 17.5863C1.63399 19.031 2.03933 20.1711 2.93414 21.0659C3.82895 21.9607 4.96897 22.366 6.41371 22.5603C7.82519 22.75 9.63423 22.75 11.9426 22.75H12.0574C14.3658 22.75 16.1748 22.75 17.5863 22.5603C19.031 22.366 20.1711 21.9607 21.0659 21.0659C21.9607 20.1711 22.366 19.031 22.5603 17.5863C22.75 16.1748 22.75 14.3658 22.75 12.0574V12C22.75 11.5858 22.4142 11.25 22 11.25C21.5858 11.25 21.25 11.5858 21.25 12C21.25 14.3782 21.2484 16.0864 21.0736 17.3864C20.9018 18.6648 20.5749 19.4355 20.0052 20.0052C19.4355 20.5749 18.6648 20.9018 17.3864 21.0736C16.0864 21.2484 14.3782 21.25 12 21.25C9.62178 21.25 7.91356 21.2484 6.61358 21.0736C5.33517 20.9018 4.56445 20.5749 3.9948 20.0052C3.42514 19.4355 3.09825 18.6648 2.92637 17.3864C2.75159 16.0864 2.75 14.3782 2.75 12C2.75 9.62178 2.75159 7.91356 2.92637 6.61358C3.09825 5.33517 3.42514 4.56445 3.9948 3.9948C4.56445 3.42514 5.33517 3.09825 6.61358 2.92637C7.91356 2.75159 9.62178 2.75 12 2.75C12.4142 2.75 12.75 2.41421 12.75 2C12.75 1.58579 12.4142 1.25 12 1.25Z'
        fill={color}
      />
      <path
        d='M12.4697 10.4697C12.1768 10.7626 12.1768 11.2374 12.4697 11.5303C12.7626 11.8232 13.2374 11.8232 13.5303 11.5303L21.25 3.81066V7.34375C21.25 7.75796 21.5858 8.09375 22 8.09375C22.4142 8.09375 22.75 7.75796 22.75 7.34375V2C22.75 1.58579 22.4142 1.25 22 1.25H16.6562C16.242 1.25 15.9062 1.58579 15.9062 2C15.9062 2.41421 16.242 2.75 16.6562 2.75H20.1893L12.4697 10.4697Z'
        fill={color}
      />
    </svg>
  );
}

export function IconQrCodeSVG({ size = 16, color = 'black' }) {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M5.12911 5.29493C5 5.47689 5 5.73459 5 6.25C5 6.76541 5 7.02311 5.12911 7.20507C5.17467 7.26928 5.23073 7.32534 5.29493 7.37089C5.47689 7.5 5.73459 7.5 6.25 7.5C6.76541 7.5 7.02311 7.5 7.20507 7.37089C7.26928 7.32534 7.32534 7.26928 7.37089 7.20507C7.5 7.02311 7.5 6.76541 7.5 6.25C7.5 5.73459 7.5 5.47689 7.37089 5.29493C7.32534 5.23073 7.26928 5.17467 7.20507 5.12911C7.02311 5 6.76541 5 6.25 5C5.73459 5 5.47689 5 5.29493 5.12911C5.23073 5.17467 5.17467 5.23073 5.12911 5.29493Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.70415 1.29021C9.14651 1.33227 9.55876 1.42353 9.93687 1.65524C10.3069 1.88199 10.618 2.1931 10.8448 2.56313C11.0765 2.94125 11.1677 3.35349 11.2098 3.79585C11.25 4.21899 11.25 4.73995 11.25 5.36422L11.25 6.552C11.25 7.45046 11.2501 8.19971 11.1701 8.79448C11.0857 9.42228 10.9 9.98908 10.4445 10.4445C9.98908 10.9 9.42228 11.0857 8.79448 11.1701C8.19971 11.2501 7.4505 11.25 6.55203 11.25L5.3643 11.25C4.74004 11.25 4.21899 11.25 3.79585 11.2098C3.35349 11.1677 2.94125 11.0765 2.56313 10.8448C2.1931 10.618 1.88199 10.3069 1.65524 9.93687C1.42353 9.55876 1.33227 9.14651 1.29021 8.70415C1.24997 8.281 1.24999 7.76 1.25 7.13571V7.06235C1.24999 6.11229 1.24998 5.34606 1.30863 4.72927C1.36911 4.09318 1.49721 3.53898 1.8026 3.04063C2.11181 2.53605 2.53605 2.11181 3.04063 1.8026C3.53898 1.49721 4.09318 1.36911 4.72927 1.30863C5.34607 1.24998 6.11227 1.24999 7.06233 1.25H7.13569C7.75999 1.24999 8.281 1.24997 8.70415 1.29021ZM8.56217 2.78347C8.21845 2.75079 7.76921 2.75 7.1 2.75C6.10345 2.75 5.4087 2.75079 4.87125 2.80189C4.34496 2.85193 4.04744 2.94487 3.82438 3.08156C3.52163 3.26709 3.26709 3.52163 3.08156 3.82438C2.94487 4.04744 2.85193 4.34496 2.80189 4.87125C2.75079 5.4087 2.75 6.10345 2.75 7.1C2.75 7.76921 2.75079 8.21845 2.78347 8.56217C2.81509 8.89473 2.87119 9.0503 2.9342 9.15312C3.03727 9.32132 3.17868 9.46273 3.34688 9.5658C3.4497 9.62881 3.60527 9.68491 3.93783 9.71653C4.28155 9.74921 4.73079 9.75 5.4 9.75H6.5C7.46401 9.75 8.11157 9.74841 8.59461 9.68347C9.05607 9.62142 9.25357 9.5142 9.38389 9.38389C9.5142 9.25357 9.62142 9.05607 9.68347 8.59461C9.74841 8.11157 9.75 7.46401 9.75 6.5V5.4C9.75 4.73079 9.74921 4.28155 9.71653 3.93783C9.68491 3.60527 9.62881 3.4497 9.5658 3.34688C9.46273 3.17868 9.32132 3.03727 9.15312 2.9342C9.0503 2.87119 8.89473 2.81509 8.56217 2.78347Z'
        fill={color}
      />
      <path
        d='M16.6291 5.29493C16.5 5.47689 16.5 5.73459 16.5 6.25C16.5 6.76541 16.5 7.02311 16.6291 7.20507C16.6747 7.26928 16.7307 7.32534 16.7949 7.37089C16.9769 7.5 17.2346 7.5 17.75 7.5C18.2654 7.5 18.5231 7.5 18.7051 7.37089C18.7693 7.32534 18.8253 7.26928 18.8709 7.20507C19 7.02311 19 6.76541 19 6.25C19 5.73459 19 5.47689 18.8709 5.29493C18.8253 5.23073 18.7693 5.17467 18.7051 5.12911C18.5231 5 18.2654 5 17.75 5C17.2346 5 16.9769 5 16.7949 5.12911C16.7307 5.17467 16.6747 5.23073 16.6291 5.29493Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M16.8643 1.25H16.9377C17.8877 1.24999 18.6539 1.24998 19.2707 1.30863C19.9068 1.36911 20.461 1.49721 20.9594 1.8026C21.464 2.11181 21.8882 2.53605 22.1974 3.04063C22.5028 3.53898 22.6309 4.09318 22.6914 4.72927C22.75 5.34607 22.75 6.11227 22.75 7.06234V7.1357C22.75 7.76 22.75 8.281 22.7098 8.70415C22.6677 9.14651 22.5765 9.55876 22.3448 9.93687C22.118 10.3069 21.8069 10.618 21.4369 10.8448C21.0588 11.0765 20.6465 11.1677 20.2042 11.2098C19.781 11.25 19.2601 11.25 18.6359 11.25L17.448 11.25C16.5495 11.25 15.8003 11.2501 15.2055 11.1701C14.5777 11.0857 14.0109 10.9 13.5555 10.4445C13.1 9.98908 12.9143 9.42228 12.8299 8.79448C12.7499 8.1997 12.75 7.45048 12.75 6.552V5.36431C12.75 4.74001 12.75 4.21901 12.7902 3.79585C12.8323 3.35349 12.9235 2.94125 13.1552 2.56313C13.382 2.1931 13.6931 1.88199 14.0631 1.65524C14.4412 1.42353 14.8535 1.33227 15.2959 1.29021C15.719 1.24997 16.24 1.24999 16.8643 1.25ZM15.4378 2.78347C15.1053 2.81509 14.9497 2.87119 14.8469 2.9342C14.6787 3.03727 14.5373 3.17868 14.4342 3.34688C14.3712 3.4497 14.3151 3.60527 14.2835 3.93783C14.2508 4.28155 14.25 4.73079 14.25 5.4V6.5C14.25 7.46401 14.2516 8.11157 14.3165 8.59461C14.3786 9.05607 14.4858 9.25357 14.6161 9.38389C14.7464 9.5142 14.9439 9.62142 15.4054 9.68347C15.8884 9.74841 16.536 9.75 17.5 9.75H18.6C19.2692 9.75 19.7184 9.74921 20.0622 9.71653C20.3947 9.68491 20.5503 9.62881 20.6531 9.5658C20.8213 9.46273 20.9627 9.32132 21.0658 9.15312C21.1288 9.0503 21.1849 8.89473 21.2165 8.56217C21.2492 8.21845 21.25 7.76921 21.25 7.1C21.25 6.10345 21.2492 5.4087 21.1981 4.87125C21.1481 4.34496 21.0551 4.04744 20.9184 3.82438C20.7329 3.52163 20.4784 3.26709 20.1756 3.08156C19.9526 2.94487 19.655 2.85193 19.1288 2.80189C18.5913 2.75079 17.8966 2.75 16.9 2.75C16.2308 2.75 15.7816 2.75079 15.4378 2.78347Z'
        fill={color}
      />
      <path
        d='M5 17.75C5 17.2346 5 16.9769 5.12911 16.7949C5.17467 16.7307 5.23073 16.6747 5.29493 16.6291C5.47689 16.5 5.73459 16.5 6.25 16.5C6.76541 16.5 7.02311 16.5 7.20507 16.6291C7.26928 16.6747 7.32534 16.7307 7.37089 16.7949C7.5 16.9769 7.5 17.2346 7.5 17.75C7.5 18.2654 7.5 18.5231 7.37089 18.7051C7.32534 18.7693 7.26928 18.8253 7.20507 18.8709C7.02311 19 6.76541 19 6.25 19C5.73459 19 5.47689 19 5.29493 18.8709C5.23073 18.8253 5.17467 18.7693 5.12911 18.7051C5 18.5231 5 18.2654 5 17.75Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.79448 12.8299C9.42228 12.9143 9.98908 13.1 10.4445 13.5555C10.9 14.0109 11.0857 14.5777 11.1701 15.2055C11.2501 15.8003 11.25 16.5495 11.25 17.448L11.25 18.6357C11.25 19.2599 11.25 19.781 11.2098 20.2042C11.1677 20.6465 11.0765 21.0588 10.8448 21.4369C10.618 21.8069 10.3069 22.118 9.93687 22.3448C9.55876 22.5765 9.14651 22.6677 8.70415 22.7098C8.281 22.75 7.76 22.75 7.1357 22.75H7.06234C6.11227 22.75 5.34607 22.75 4.72927 22.6914C4.09318 22.6309 3.53898 22.5028 3.04063 22.1974C2.53605 21.8882 2.11181 21.464 1.8026 20.9594C1.49721 20.461 1.36911 19.9068 1.30863 19.2707C1.24998 18.6539 1.24999 17.8877 1.25 16.9377V16.8643C1.24999 16.24 1.24997 15.719 1.29021 15.2959C1.33227 14.8535 1.42353 14.4412 1.65524 14.0631C1.88199 13.6931 2.1931 13.382 2.56313 13.1552C2.94125 12.9235 3.35349 12.8323 3.79585 12.7902C4.21901 12.75 4.74001 12.75 5.36431 12.75H6.552C7.45048 12.75 8.1997 12.7499 8.79448 12.8299ZM8.59461 14.3165C8.11157 14.2516 7.46401 14.25 6.5 14.25H5.4C4.73079 14.25 4.28155 14.2508 3.93783 14.2835C3.60527 14.3151 3.4497 14.3712 3.34688 14.4342C3.17868 14.5373 3.03727 14.6787 2.9342 14.8469C2.87119 14.9497 2.81509 15.1053 2.78347 15.4378C2.75079 15.7816 2.75 16.2308 2.75 16.9C2.75 17.8966 2.75079 18.5913 2.80189 19.1288C2.85193 19.655 2.94487 19.9526 3.08156 20.1756C3.26709 20.4784 3.52163 20.7329 3.82438 20.9184C4.04744 21.0551 4.34496 21.1481 4.87125 21.1981C5.4087 21.2492 6.10345 21.25 7.1 21.25C7.76921 21.25 8.21845 21.2492 8.56217 21.2165C8.89473 21.1849 9.0503 21.1288 9.15312 21.0658C9.32132 20.9627 9.46273 20.8213 9.5658 20.6531C9.62881 20.5503 9.68491 20.3947 9.71653 20.0622C9.74921 19.7184 9.75 19.2692 9.75 18.6V17.5C9.75 16.536 9.74841 15.8884 9.68347 15.4054C9.62142 14.9439 9.5142 14.7464 9.38389 14.6161C9.25357 14.4858 9.05607 14.3786 8.59461 14.3165Z'
        fill={color}
      />
      <path
        d='M16.9617 12.75L19 12.75V14.25H17C16.2822 14.25 15.8002 14.2509 15.4328 14.2883C15.078 14.3244 14.914 14.3882 14.8055 14.4607C14.6691 14.5519 14.5519 14.6691 14.4607 14.8055C14.3882 14.914 14.3244 15.078 14.2883 15.4328C14.2509 15.8002 14.25 16.2822 14.25 17H12.75L12.75 16.9617C12.75 16.2921 12.75 15.7333 12.796 15.281C12.8442 14.8075 12.9489 14.3682 13.2135 13.9722C13.4141 13.6719 13.6719 13.4141 13.9722 13.2135C14.3682 12.9489 14.8075 12.8442 15.281 12.796C15.7333 12.75 16.2921 12.75 16.9617 12.75Z'
        fill={color}
      />
      <path d='M12.75 22V19H14.25V22C14.25 22.4142 13.9142 22.75 13.5 22.75C13.0858 22.75 12.75 22.4142 12.75 22Z' fill={color} />
      <path d='M22.75 13.5C22.75 13.0858 22.4142 12.75 22 12.75C21.5858 12.75 21.25 13.0858 21.25 13.5V17H22.75V13.5Z' fill={color} />
      <path
        d='M21.25 19C21.25 19.4762 21.2496 19.7958 21.2327 20.0433C21.2163 20.284 21.1868 20.4012 21.1549 20.4784C21.028 20.7846 20.7846 21.028 20.4784 21.1549C20.4012 21.1868 20.284 21.2163 20.0433 21.2327C19.7958 21.2496 19.4762 21.25 19 21.25H17V22.75H19.0253C19.4697 22.75 19.8408 22.75 20.1454 22.7292C20.4625 22.7076 20.762 22.661 21.0524 22.5407C21.7262 22.2616 22.2616 21.7262 22.5407 21.0524C22.661 20.762 22.7076 20.4625 22.7292 20.1454C22.75 19.8408 22.75 19.4698 22.75 19.0253V19H21.25Z'
        fill={color}
      />
      <path
        d='M16.1685 16.4444C16 16.6967 16 17.0478 16 17.75C16 18.4522 16 18.8033 16.1685 19.0556C16.2415 19.1648 16.3352 19.2585 16.4444 19.3315C16.6967 19.5 17.0478 19.5 17.75 19.5C18.4522 19.5 18.8033 19.5 19.0556 19.3315C19.1648 19.2585 19.2585 19.1648 19.3315 19.0556C19.5 18.8033 19.5 18.4522 19.5 17.75C19.5 17.0478 19.5 16.6967 19.3315 16.4444C19.2585 16.3352 19.1648 16.2415 19.0556 16.1685C18.8033 16 18.4522 16 17.75 16C17.0478 16 16.6967 16 16.4444 16.1685C16.3352 16.2415 16.2415 16.3352 16.1685 16.4444Z'
        fill={color}
      />
    </svg>
  );
}

export function IconNotifySlugSVG({ size = 16, color = 'black' }) {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M18.7491 9.70957V9.00497C18.7491 5.13623 15.7274 2 12 2C8.27256 2 5.25087 5.13623 5.25087 9.00497V9.70957C5.25087 10.5552 5.00972 11.3818 4.5578 12.0854L3.45036 13.8095C2.43882 15.3843 3.21105 17.5249 4.97036 18.0229C9.57274 19.3257 14.4273 19.3257 19.0296 18.0229C20.789 17.5249 21.5612 15.3843 20.5496 13.8095L19.4422 12.0854C18.9903 11.3818 18.7491 10.5552 18.7491 9.70957Z'
        stroke={color}
        strokeWidth='1.5'
      />
      <path d='M7.5 19C8.15503 20.7478 9.92246 22 12 22C14.0775 22 15.845 20.7478 16.5 19' stroke={color} strokeWidth='1.5' strokeLinecap='round' />
    </svg>
  );
}

export function IconQuickAddSVG({ size = 16, color }) {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M12.75 9C12.75 8.58579 12.4142 8.25 12 8.25C11.5858 8.25 11.25 8.58579 11.25 9L11.25 11.25H9C8.58579 11.25 8.25 11.5858 8.25 12C8.25 12.4142 8.58579 12.75 9 12.75H11.25V15C11.25 15.4142 11.5858 15.75 12 15.75C12.4142 15.75 12.75 15.4142 12.75 15L12.75 12.75H15C15.4142 12.75 15.75 12.4142 15.75 12C15.75 11.5858 15.4142 11.25 15 11.25H12.75V9Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.0574 1.25H11.9426C9.63424 1.24999 7.82519 1.24998 6.41371 1.43975C4.96897 1.63399 3.82895 2.03933 2.93414 2.93414C2.03933 3.82895 1.63399 4.96897 1.43975 6.41371C1.24998 7.82519 1.24999 9.63422 1.25 11.9426V12.0574C1.24999 14.3658 1.24998 16.1748 1.43975 17.5863C1.63399 19.031 2.03933 20.1711 2.93414 21.0659C3.82895 21.9607 4.96897 22.366 6.41371 22.5603C7.82519 22.75 9.63423 22.75 11.9426 22.75H12.0574C14.3658 22.75 16.1748 22.75 17.5863 22.5603C19.031 22.366 20.1711 21.9607 21.0659 21.0659C21.9607 20.1711 22.366 19.031 22.5603 17.5863C22.75 16.1748 22.75 14.3658 22.75 12.0574V11.9426C22.75 9.63423 22.75 7.82519 22.5603 6.41371C22.366 4.96897 21.9607 3.82895 21.0659 2.93414C20.1711 2.03933 19.031 1.63399 17.5863 1.43975C16.1748 1.24998 14.3658 1.24999 12.0574 1.25ZM3.9948 3.9948C4.56445 3.42514 5.33517 3.09825 6.61358 2.92637C7.91356 2.75159 9.62177 2.75 12 2.75C14.3782 2.75 16.0864 2.75159 17.3864 2.92637C18.6648 3.09825 19.4355 3.42514 20.0052 3.9948C20.5749 4.56445 20.9018 5.33517 21.0736 6.61358C21.2484 7.91356 21.25 9.62177 21.25 12C21.25 14.3782 21.2484 16.0864 21.0736 17.3864C20.9018 18.6648 20.5749 19.4355 20.0052 20.0052C19.4355 20.5749 18.6648 20.9018 17.3864 21.0736C16.0864 21.2484 14.3782 21.25 12 21.25C9.62177 21.25 7.91356 21.2484 6.61358 21.0736C5.33517 20.9018 4.56445 20.5749 3.9948 20.0052C3.42514 19.4355 3.09825 18.6648 2.92637 17.3864C2.75159 16.0864 2.75 14.3782 2.75 12C2.75 9.62177 2.75159 7.91356 2.92637 6.61358C3.09825 5.33517 3.42514 4.56445 3.9948 3.9948Z'
        fill={color}
      />
    </svg>
  );
}

export function IconQuickPlusSVG({ size = 16, color }) {
  return (
    <svg width={size} height={size} viewBox='0 0 512 512' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='244' y='68' width='25' height='377' rx='12.5' fill={color} />
      <rect x='68' y='269' width='25' height='377' rx='12.5' transform='rotate(-90 68 269)' fill={color} />
    </svg>
  );
}

export function IconQuickLinkSVG({ size = 16, color }) {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M14.1625 18.4876L13.4417 19.2084C11.053 21.5971 7.18019 21.5971 4.79151 19.2084C2.40283 16.8198 2.40283 12.9469 4.79151 10.5583L5.51236 9.8374'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
      />
      <path d='M9.8374 14.1625L14.1625 9.8374' stroke='#1C274C' strokeWidth='1.5' strokeLinecap='round' />
      <path
        d='M9.8374 5.51236L10.5583 4.79151C12.9469 2.40283 16.8198 2.40283 19.2084 4.79151C21.5971 7.18019 21.5971 11.053 19.2084 13.4417L18.4876 14.1625'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
      />
    </svg>
  );
}

export function IconQuickPhotoSVG({ size = 16, color }) {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='12' cy='13' r='3' stroke='#1C274C' strokeWidth='1.5' />
      <path
        d='M9.77778 21H14.2222C17.3433 21 18.9038 21 20.0248 20.2646C20.51 19.9462 20.9267 19.5371 21.251 19.0607C22 17.9601 22 16.4279 22 13.3636C22 10.2994 22 8.76721 21.251 7.6666C20.9267 7.19014 20.51 6.78104 20.0248 6.46268C19.3044 5.99013 18.4027 5.82123 17.022 5.76086C16.3631 5.76086 15.7959 5.27068 15.6667 4.63636C15.4728 3.68489 14.6219 3 13.6337 3H10.3663C9.37805 3 8.52715 3.68489 8.33333 4.63636C8.20412 5.27068 7.63685 5.76086 6.978 5.76086C5.59733 5.82123 4.69555 5.99013 3.97524 6.46268C3.48995 6.78104 3.07328 7.19014 2.74902 7.6666C2 8.76721 2 10.2994 2 13.3636C2 16.4279 2 17.9601 2.74902 19.0607C3.07328 19.5371 3.48995 19.9462 3.97524 20.2646C5.09624 21 6.65675 21 9.77778 21Z'
        stroke={color}
        strokeWidth='1.5'
      />
      <path d='M19 10H18' stroke={color} strokeWidth='1.5' strokeLinecap='round' />
    </svg>
  );
}

export function IconQuickMusicSVG({ size = 16, color }) {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M9 19C9 20.6569 7.65685 22 6 22C4.34315 22 3 20.6569 3 19C3 17.3431 4.34315 16 6 16C7.65685 16 9 17.3431 9 19Z' stroke={color} strokeWidth='1.5' />
      <path d='M21 17C21 18.6569 19.6569 20 18 20C16.3431 20 15 18.6569 15 17C15 15.3431 16.3431 14 18 14C19.6569 14 21 15.3431 21 17Z' stroke={color} strokeWidth='1.5' />
      <path d='M9 19V8' stroke={color} strokeWidth='1.5' />
      <path d='M21 17V6' stroke={color} strokeWidth='1.5' />
      <path
        d='M15.7351 3.75466L11.7351 5.08799C10.4151 5.52801 9.75503 5.74801 9.37752 6.27179C9 6.79556 9 7.49128 9 8.88273V11.9997L21 7.99969V7.54939C21 5.01693 21 3.7507 20.1694 3.15206C19.3388 2.55341 18.1376 2.95383 15.7351 3.75466Z'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
      />
    </svg>
  );
}

export function IconQuickFilesSVG({ size = 16, color }) {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M15.3929 4.05365L14.8912 4.61112L15.3929 4.05365ZM19.3517 7.61654L18.85 8.17402L19.3517 7.61654ZM21.654 10.1541L20.9689 10.4592V10.4592L21.654 10.1541ZM3.17157 20.8284L3.7019 20.2981H3.7019L3.17157 20.8284ZM20.8284 20.8284L20.2981 20.2981L20.2981 20.2981L20.8284 20.8284ZM14 21.25H10V22.75H14V21.25ZM2.75 14V10H1.25V14H2.75ZM21.25 13.5629V14H22.75V13.5629H21.25ZM14.8912 4.61112L18.85 8.17402L19.8534 7.05907L15.8947 3.49618L14.8912 4.61112ZM22.75 13.5629C22.75 11.8745 22.7651 10.8055 22.3391 9.84897L20.9689 10.4592C21.2349 11.0565 21.25 11.742 21.25 13.5629H22.75ZM18.85 8.17402C20.2034 9.3921 20.7029 9.86199 20.9689 10.4592L22.3391 9.84897C21.9131 8.89241 21.1084 8.18853 19.8534 7.05907L18.85 8.17402ZM10.0298 2.75C11.6116 2.75 12.2085 2.76158 12.7405 2.96573L13.2779 1.5653C12.4261 1.23842 11.498 1.25 10.0298 1.25V2.75ZM15.8947 3.49618C14.8087 2.51878 14.1297 1.89214 13.2779 1.5653L12.7405 2.96573C13.2727 3.16993 13.7215 3.55836 14.8912 4.61112L15.8947 3.49618ZM10 21.25C8.09318 21.25 6.73851 21.2484 5.71085 21.1102C4.70476 20.975 4.12511 20.7213 3.7019 20.2981L2.64124 21.3588C3.38961 22.1071 4.33855 22.4392 5.51098 22.5969C6.66182 22.7516 8.13558 22.75 10 22.75V21.25ZM1.25 14C1.25 15.8644 1.24841 17.3382 1.40313 18.489C1.56076 19.6614 1.89288 20.6104 2.64124 21.3588L3.7019 20.2981C3.27869 19.8749 3.02502 19.2952 2.88976 18.2892C2.75159 17.2615 2.75 15.9068 2.75 14H1.25ZM14 22.75C15.8644 22.75 17.3382 22.7516 18.489 22.5969C19.6614 22.4392 20.6104 22.1071 21.3588 21.3588L20.2981 20.2981C19.8749 20.7213 19.2952 20.975 18.2892 21.1102C17.2615 21.2484 15.9068 21.25 14 21.25V22.75ZM21.25 14C21.25 15.9068 21.2484 17.2615 21.1102 18.2892C20.975 19.2952 20.7213 19.8749 20.2981 20.2981L21.3588 21.3588C22.1071 20.6104 22.4392 19.6614 22.5969 18.489C22.7516 17.3382 22.75 15.8644 22.75 14H21.25ZM2.75 10C2.75 8.09318 2.75159 6.73851 2.88976 5.71085C3.02502 4.70476 3.27869 4.12511 3.7019 3.7019L2.64124 2.64124C1.89288 3.38961 1.56076 4.33855 1.40313 5.51098C1.24841 6.66182 1.25 8.13558 1.25 10H2.75ZM10.0298 1.25C8.15538 1.25 6.67442 1.24842 5.51887 1.40307C4.34232 1.56054 3.39019 1.8923 2.64124 2.64124L3.7019 3.7019C4.12453 3.27928 4.70596 3.02525 5.71785 2.88982C6.75075 2.75158 8.11311 2.75 10.0298 2.75V1.25Z'
        fill={color}
      />
      <path d='M13 2.5V5C13 7.35702 13 8.53553 13.7322 9.26777C14.4645 10 15.643 10 18 10H22' stroke={color} strokeWidth='1.5' />
    </svg>
  );
}

export function IconQuickStorySVG({ size = 16, color }) {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='12' cy='12' r='10' stroke={color} strokeWidth='1.5' />
      <path d='M15 12L12 12M12 12L9 12M12 12L12 9M12 12L12 15' stroke={color} strokeWidth='1.5' strokeLinecap='round' />
    </svg>
  );
}

export function IconQuickAddBlockSVG({ size = 16, color }) {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M14.5 6.5H17.5M17.5 6.5H20.5M17.5 6.5V9.5M17.5 6.5V3.5' stroke='#1C274C' strokeWidth='1.5' strokeLinecap='round' />
      <path
        d='M2.5 6.5C2.5 4.61438 2.5 3.67157 3.08579 3.08579C3.67157 2.5 4.61438 2.5 6.5 2.5C8.38562 2.5 9.32843 2.5 9.91421 3.08579C10.5 3.67157 10.5 4.61438 10.5 6.5C10.5 8.38562 10.5 9.32843 9.91421 9.91421C9.32843 10.5 8.38562 10.5 6.5 10.5C4.61438 10.5 3.67157 10.5 3.08579 9.91421C2.5 9.32843 2.5 8.38562 2.5 6.5Z'
        stroke={color}
        strokeWidth='1.5'
      />
      <path
        d='M13.5 17.5C13.5 15.6144 13.5 14.6716 14.0858 14.0858C14.6716 13.5 15.6144 13.5 17.5 13.5C19.3856 13.5 20.3284 13.5 20.9142 14.0858C21.5 14.6716 21.5 15.6144 21.5 17.5C21.5 19.3856 21.5 20.3284 20.9142 20.9142C20.3284 21.5 19.3856 21.5 17.5 21.5C15.6144 21.5 14.6716 21.5 14.0858 20.9142C13.5 20.3284 13.5 19.3856 13.5 17.5Z'
        stroke={color}
        strokeWidth='1.5'
      />
      <path
        d='M2.5 17.5C2.5 15.6144 2.5 14.6716 3.08579 14.0858C3.67157 13.5 4.61438 13.5 6.5 13.5C8.38562 13.5 9.32843 13.5 9.91421 14.0858C10.5 14.6716 10.5 15.6144 10.5 17.5C10.5 19.3856 10.5 20.3284 9.91421 20.9142C9.32843 21.5 8.38562 21.5 6.5 21.5C4.61438 21.5 3.67157 21.5 3.08579 20.9142C2.5 20.3284 2.5 19.3856 2.5 17.5Z'
        stroke={color}
        strokeWidth='1.5'
      />
    </svg>
  );
}

export function IconQuickVideoSVG({ size = 16, color }) {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C22 4.92893 22 7.28595 22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12Z'
        stroke={color}
        strokeWidth='1.5'
      />
      <path d='M21.5 8H2.5' stroke={color} strokeWidth='1.5' strokeLinecap='round' />
      <path d='M10.5 2.5L7 8' stroke={color} strokeWidth='1.5' strokeLinecap='round' />
      <path d='M17 2.5L13.5 8' stroke={color} strokeWidth='1.5' strokeLinecap='round' />
      <path
        d='M15 14.5C15 13.8666 14.338 13.4395 13.014 12.5852C11.6719 11.7193 11.0008 11.2863 10.5004 11.6042C10 11.9221 10 12.7814 10 14.5C10 16.2186 10 17.0779 10.5004 17.3958C11.0008 17.7137 11.6719 17.2807 13.014 16.4148C14.338 15.5605 15 15.1334 15 14.5Z'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
      />
    </svg>
  );
}

export function IconQuickProductSVG({ size = 16, color }) {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M3.74181 18.5545C4.94143 20 7.17414 20 11.6395 20H12.3607C16.8261 20 19.0589 20 20.2585 18.5545M3.74181 18.5545C2.54219 17.1091 2.95365 14.9146 3.77657 10.5257C4.36179 7.40452 4.65441 5.84393 5.7653 4.92196M3.74181 18.5545C3.74181 18.5545 3.74181 18.5545 3.74181 18.5545ZM20.2585 18.5545C21.4581 17.1091 21.0466 14.9146 20.2237 10.5257C19.6385 7.40452 19.3459 5.84393 18.235 4.92196M20.2585 18.5545C20.2585 18.5545 20.2585 18.5545 20.2585 18.5545ZM18.235 4.92196C17.1241 4 15.5363 4 12.3607 4H11.6395C8.46398 4 6.8762 4 5.7653 4.92196M18.235 4.92196C18.235 4.92196 18.235 4.92196 18.235 4.92196ZM5.7653 4.92196C5.7653 4.92196 5.7653 4.92196 5.7653 4.92196Z'
        stroke={color}
        strokeWidth='1.5'
      />
      <path d='M9.1709 8C9.58273 9.16519 10.694 10 12.0002 10C13.3064 10 14.4177 9.16519 14.8295 8' stroke={color} strokeWidth='1.5' strokeLinecap='round' />
    </svg>
  );
}

export function IconQuickPostSVG({ size = 16, color }) {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M22 10.5V12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2H13.5'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
      />
      <path
        d='M16.652 3.45506L17.3009 2.80624C18.3759 1.73125 20.1188 1.73125 21.1938 2.80624C22.2687 3.88124 22.2687 5.62415 21.1938 6.69914L20.5449 7.34795M16.652 3.45506C16.652 3.45506 16.7331 4.83379 17.9497 6.05032C19.1662 7.26685 20.5449 7.34795 20.5449 7.34795M16.652 3.45506L10.6872 9.41993C10.2832 9.82394 10.0812 10.0259 9.90743 10.2487C9.70249 10.5114 9.52679 10.7957 9.38344 11.0965C9.26191 11.3515 9.17157 11.6225 8.99089 12.1646L8.41242 13.9M20.5449 7.34795L14.5801 13.3128C14.1761 13.7168 13.9741 13.9188 13.7513 14.0926C13.4886 14.2975 13.2043 14.4732 12.9035 14.6166C12.6485 14.7381 12.3775 14.8284 11.8354 15.0091L10.1 15.5876M10.1 15.5876L8.97709 15.9619C8.71035 16.0508 8.41626 15.9814 8.21744 15.7826C8.01862 15.5837 7.9492 15.2897 8.03811 15.0229L8.41242 13.9M10.1 15.5876L8.41242 13.9'
        stroke={color}
        strokeWidth='1.5'
      />
    </svg>
  );
}

export function IconQuickArticleSVG({ size = 16, color }) {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M3 10C3 6.22876 3 4.34315 4.17157 3.17157C5.34315 2 7.22876 2 11 2H13C16.7712 2 18.6569 2 19.8284 3.17157C21 4.34315 21 6.22876 21 10V14C21 17.7712 21 19.6569 19.8284 20.8284C18.6569 22 16.7712 22 13 22H11C7.22876 22 5.34315 22 4.17157 20.8284C3 19.6569 3 17.7712 3 14V10Z'
        stroke={color}
        strokeWidth='1.5'
      />
      <path d='M8 12H16' stroke={color} strokeWidth='1.5' strokeLinecap='round' />
      <path d='M8 8H16' stroke={color} strokeWidth='1.5' strokeLinecap='round' />
      <path d='M8 16H13' stroke={color} strokeWidth='1.5' strokeLinecap='round' />
    </svg>
  );
}

export function IconShareOpenLinkSVG() {
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' className=' ' role='img' aria-hidden='false' aria-labelledby='ltclid:19_title '>
      <title id='ltclid:19_title'>External</title>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.5.999H15v6.5h-1V2.706L7.354 9.352l-.708-.707L13.293 2H8.5v-1ZM1 3h4v1H2v9.999L3.346 14H12v-3h1V14.999h-.5L11.154 15H3.346L1.5 14.999H1V3Z'
        fill='currentColor'
      ></path>
    </svg>
  );
}

export function IconShareFormatSVG() {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className='ml-2 text-black'
      role='img'
      aria-hidden='false'
      aria-labelledby='ltclid:36_title '
    >
      <title id='ltclid:36_title'>Download</title>
      <path
        d='M0.5 14.9991L-4.37114e-08 14.9991L4.37114e-08 15.9991L0.5 15.9991L0.5 14.9991ZM15.5 15.9991L16 15.9991L16 14.9991L15.5 14.9991L15.5 15.9991ZM0.5 15.9991L15.5 15.9991L15.5 14.9991L0.5 14.9991L0.5 15.9991Z'
        fill='currentColor'
      ></path>
      <path
        d='M3.35355 6.89645L3 6.54289L2.29289 7.25L2.64645 7.60355L3.35355 6.89645ZM8 12.25L7.64645 12.6036H8.35355L8 12.25ZM13.3536 7.60355L13.7071 7.25L13 6.54289L12.6464 6.89645L13.3536 7.60355ZM2.64645 7.60355L7.64645 12.6036L8.35355 11.8964L3.35355 6.89645L2.64645 7.60355ZM8.35355 12.6036L13.3536 7.60355L12.6464 6.89645L7.64645 11.8964L8.35355 12.6036Z'
        fill='currentColor'
      ></path>
      <path
        d='M8.5 0.499146L8.5 -0.00085447L7.5 -0.000854514L7.5 0.499145L8.5 0.499146ZM7.5 11.4991L7.5 11.9991L8.5 11.9991L8.5 11.4991L7.5 11.4991ZM7.5 0.499145L7.5 11.4991L8.5 11.4991L8.5 0.499146L7.5 0.499145Z'
        fill='currentColor'
      ></path>
    </svg>
  );
}

export const IconHighlightActiveSVG = ({ size = 22, color = 'orange' }) => {
  return (
    <svg width={size} height={size} viewBox='0 0 512 512' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_689_7113)'>
        <path
          d='M262.164 384.688C258.393 382.715 253.895 382.713 250.122 384.682L152.124 435.837C142.581 440.818 131.465 432.707 133.298 422.099L151.973 314.012C152.706 309.771 151.292 305.442 148.197 302.451L69.0772 225.987C61.3048 218.476 65.5611 205.311 76.2599 203.772L185.586 188.041C189.815 187.432 193.474 184.785 195.376 180.96L244.359 82.4189C249.14 72.801 262.86 72.801 267.641 82.4189L316.624 180.96C318.525 184.785 322.185 187.432 326.414 188.041L435.74 203.772C446.439 205.311 450.695 218.476 442.923 225.987L363.803 302.451C360.708 305.442 359.294 309.771 360.027 314.012L378.697 422.069C380.53 432.682 369.403 440.794 359.86 435.801L262.164 384.688Z'
          stroke={color}
          strokeWidth='25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_689_7113'>
          <rect width='512' height='512' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export const IconHighlightSVG = ({ size = 22, color = '#acb5bf' }) => {
  return (
    <svg width={size} height={size} viewBox='0 0 512 512' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_689_7113)'>
        <path
          d='M262.164 384.688C258.393 382.715 253.895 382.713 250.122 384.682L152.124 435.837C142.581 440.818 131.465 432.707 133.298 422.099L151.973 314.012C152.706 309.771 151.292 305.442 148.197 302.451L69.0772 225.987C61.3048 218.476 65.5611 205.311 76.2599 203.772L185.586 188.041C189.815 187.432 193.474 184.785 195.376 180.96L244.359 82.4189C249.14 72.801 262.86 72.801 267.641 82.4189L316.624 180.96C318.525 184.785 322.185 187.432 326.414 188.041L435.74 203.772C446.439 205.311 450.695 218.476 442.923 225.987L363.803 302.451C360.708 305.442 359.294 309.771 360.027 314.012L378.697 422.069C380.53 432.682 369.403 440.794 359.86 435.801L262.164 384.688Z'
          stroke={color}
          strokeWidth='25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_689_7113'>
          <rect width='512' height='512' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export const IconLockActiveSVG = ({ size = 18, color = 'orange' }) => {
  return (
    <svg width={size} height={size} viewBox='0 0 512 512' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M119.52 275.003C119.52 264.659 123.628 254.739 130.942 247.426C138.256 240.112 148.176 236.003 158.519 236.003H353.517C363.86 236.003 373.78 240.112 381.094 247.426C388.408 254.739 392.517 264.659 392.517 275.003V392.001C392.517 402.345 388.408 412.264 381.094 419.578C373.78 426.892 363.86 431.001 353.517 431.001H158.519C148.176 431.001 138.256 426.892 130.942 419.578C123.628 412.264 119.52 402.345 119.52 392.001V275.003Z'
        stroke={color}
        strokeWidth='25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M236.52 333.497C236.52 338.669 238.574 343.628 242.231 347.285C245.888 350.942 250.848 352.997 256.019 352.997C261.191 352.997 266.151 350.942 269.808 347.285C273.465 343.628 275.519 338.669 275.519 333.497C275.519 328.325 273.465 323.365 269.808 319.708C266.151 316.052 261.191 313.997 256.019 313.997C250.848 313.997 245.888 316.052 242.231 319.708C238.574 323.365 236.52 328.325 236.52 333.497Z'
        stroke={color}
        strokeWidth='25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M178.02 235.998V157.999C178.02 137.312 186.237 117.473 200.865 102.845C215.493 88.2177 235.332 80 256.019 80C276.705 80 296.545 88.2177 311.172 102.845C325.8 117.473 334.018 137.312 334.018 157.999V235.998'
        stroke={color}
        strokeWidth='25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export const IconLockSVG = ({ size = 22, color = 'orange' }) => {
  return (
    <svg width={size} height={size} viewBox='0 0 512 512' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M89 237.4C89 224.564 94.0421 212.253 103.017 203.176C111.992 194.099 124.165 189 136.857 189H376.143C388.835 189 401.008 194.099 409.983 203.176C418.958 212.253 424 224.564 424 237.4V382.6C424 395.436 418.958 407.747 409.983 416.824C401.008 425.901 388.835 431 376.143 431H136.857C124.165 431 111.992 425.901 103.017 416.824C94.0421 407.747 89 395.436 89 382.6V237.4Z'
        stroke={color}
        strokeWidth='25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M227 310C227 317.691 230.055 325.068 235.494 330.506C240.932 335.945 248.309 339 256 339C263.691 339 271.068 335.945 276.506 330.506C281.945 325.068 285 317.691 285 310C285 302.309 281.945 294.932 276.506 289.494C271.068 284.055 263.691 281 256 281C248.309 281 240.932 284.055 235.494 289.494C230.055 294.932 227 302.309 227 310Z'
        fill={color}
      />
      <path
        d='M178.02 188V157.999C178.02 137.312 186.237 117.473 200.865 102.845C215.493 88.2177 235.332 80 256.019 80C276.705 80 296.545 88.2177 311.172 102.845C325.8 117.473 334.018 137.312 334.018 157.999V188'
        stroke={color}
        strokeWidth='25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export const IconInstagramSVG = ({ size = 22, color = 'orange' }) => {
  return (
    <svg width={size} height={size} viewBox='0 0 512 512' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M179.5 81H332.5C388.834 81 434.5 126.667 434.5 183V336C434.5 392.334 388.834 438 332.5 438H179.5C123.167 438 77.5 392.334 77.5 336V183C77.5 126.667 123.167 81 179.5 81ZM256 336C213.751 336 179.5 301.75 179.5 259.5C179.5 217.251 213.751 183 256 183C298.25 183 332.5 217.251 332.5 259.5C332.5 301.75 298.25 336 256 336Z'
        stroke={color}
        strokeWidth='25'
      />
      <path
        d='M359.435 116.172C355.412 116.167 351.478 117.357 348.132 119.589C344.785 121.821 342.176 124.996 340.634 128.712C339.093 132.428 338.689 136.518 339.472 140.463C340.256 144.409 342.193 148.034 345.038 150.878C347.882 153.723 351.507 155.66 355.452 156.443C359.398 157.227 363.488 156.823 367.204 155.281C370.919 153.74 374.094 151.131 376.327 147.784C378.559 144.437 379.748 140.504 379.744 136.481C379.733 131.098 377.59 125.939 373.783 122.133C369.977 118.326 364.818 116.183 359.435 116.172Z'
        fill={color}
      />
    </svg>
  );
};

export const IconTimerSVG = ({ size = 22, color = 'orange' }) => {
  return (
    <svg width={size} height={size} viewBox='0 0 512 512' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M100 286.345C100 306.786 104.026 327.027 111.849 345.912C119.671 364.797 131.136 381.956 145.59 396.41C160.044 410.864 177.203 422.329 196.088 430.152C214.973 437.974 235.214 442 255.655 442C276.096 442 296.336 437.974 315.221 430.152C334.106 422.329 351.266 410.864 365.719 396.41C380.173 381.956 391.639 364.797 399.461 345.912C407.284 327.027 411.31 306.786 411.31 286.345C411.31 265.904 407.284 245.664 399.461 226.779C391.639 207.894 380.173 190.735 365.719 176.281C351.266 161.827 334.106 150.361 315.221 142.539C296.336 134.717 276.096 130.69 255.655 130.69C235.214 130.69 214.973 134.717 196.088 142.539C177.203 150.361 160.044 161.827 145.59 176.281C131.136 190.735 119.671 207.894 111.849 226.779C104.026 245.664 100 265.904 100 286.345Z'
        stroke={color}
        strokeWidth='26.0583'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M255.641 197.399L255.641 285.998' stroke={color} strokeWidth='26.0583' strokeLinecap='round' strokeLinejoin='round' />
      <line x1='290.557' y1='84.0291' x2='220.721' y2='84.0291' stroke={color} strokeWidth='26.0583' strokeLinecap='round' />
      <line x1='363' y1='168.607' x2='388.352' y2='143.255' stroke={color} strokeWidth='26.0583' strokeLinecap='round' />
    </svg>
  );
};

export const IconCalendarSVG = ({ size = 22, color = 'orange' }) => {
  return (
    <svg width={size} height={size} viewBox='0 0 512 512' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M252.399 434.756H114.837C104.098 434.756 93.7998 430.49 86.2067 422.897C78.6135 415.304 74.3477 405.005 74.3477 394.267V151.332C74.3477 140.594 78.6135 130.295 86.2067 122.702C93.7998 115.109 104.098 110.843 114.837 110.843H357.772C368.51 110.843 378.809 115.109 386.402 122.702C393.995 130.295 398.261 140.594 398.261 151.332V232.31'
        stroke={color}
        strokeWidth='23.8898'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M297.055 374.022C297.055 395.499 305.586 416.096 320.773 431.283C335.959 446.469 356.556 455.001 378.033 455.001C399.51 455.001 420.107 446.469 435.293 431.283C450.48 416.096 459.011 395.499 459.011 374.022C459.011 352.545 450.48 331.948 435.293 316.762C420.107 301.576 399.51 293.044 378.033 293.044C356.556 293.044 335.959 301.576 320.773 316.762C305.586 331.948 297.055 352.545 297.055 374.022Z'
        stroke={color}
        strokeWidth='23.8898'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M317.285 70.3496V151.328' stroke={color} strokeWidth='23.8898' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M155.309 70.3496V151.328' stroke={color} strokeWidth='23.8898' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M74.3477 232.31H398.261' stroke={color} strokeWidth='23.8898' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M378.016 343.566V374.014L398.26 394.259' stroke={color} strokeWidth='23.8898' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
};

export const IconEffectsSVG = ({ size = 22, color = 'orange' }) => {
  return (
    <svg width={size} height={size} viewBox='0 0 512 512' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='148.484' y='83.5' width='215.124' height='345' rx='25.9' fill='white' stroke={color} strokeWidth='25' />
      <path d='M87.4922 143.863L87.4922 367.62' stroke={color} strokeWidth='25' strokeLinecap='round' />
      <path d='M424.598 143.863L424.598 367.62' stroke={color} strokeWidth='25' strokeLinecap='round' />
      <path d='M39 207.941L39 303.647' stroke={color} strokeWidth='25' strokeLinecap='round' />
      <path d='M473.355 207.941L473.355 303.647' stroke={color} strokeWidth='25' strokeLinecap='round' />
    </svg>
  );
};

export const IconEffectsActiveSVG = ({ size = 20, color = 'orange' }) => {
  return (
    <svg width={size} height={size} viewBox='0 0 800 800' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='218' y='66' width='363' height='668' rx='36' fill={color} stroke={color} strokeWidth='48' />
      <path d='M111 183L111 616' stroke={color} strokeWidth='48' strokeLinecap='round' />
      <path d='M688 183L688 616' stroke={color} strokeWidth='48' strokeLinecap='round' />
      <path d='M28 307L28 492.203' stroke={color} strokeWidth='48' strokeLinecap='round' />
      <path d='M771.453 307L771.453 492.203' stroke={color} strokeWidth='48' strokeLinecap='round' />
    </svg>
  );
};

export const IconPaymentSVG = ({ size = 22, color = '#acb5bf' }) => {
  return (
    <svg width={size} height={size} viewBox='0 0 800 800' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_253_6337)'>
        <path
          d='M52.6213 543.889C33.7255 498.271 24 449.377 24 400C24 350.623 33.7255 301.729 52.6213 256.111C71.5171 210.493 99.213 169.043 134.128 134.128C169.043 99.213 210.493 71.5171 256.111 52.6213C301.729 33.7255 350.623 24 400 24C449.377 24 498.271 33.7255 543.889 52.6213C589.507 71.5171 630.957 99.213 665.872 134.128C700.787 169.043 728.483 210.493 747.379 256.111C766.274 301.729 776 350.623 776 400C776 449.377 766.274 498.271 747.379 543.889C728.483 589.507 700.787 630.957 665.872 665.872C630.957 700.787 589.507 728.483 543.889 747.379C498.271 766.274 449.377 776 400 776C350.623 776 301.729 766.274 256.111 747.379C210.493 728.483 169.043 700.787 134.128 665.872C99.213 630.957 71.5171 589.507 52.6213 543.889Z'
          fill='white'
          stroke={color}
          strokeWidth='40'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M402.276 534.883C399.185 534.287 396.015 534.18 392.885 534.597C361.515 531.341 337.85 507.678 337.797 479.53C337.797 466.04 325.53 455.103 310.4 455.103C295.27 455.103 283.003 466.04 283.003 479.53C283.083 526.534 318.346 567.707 369.18 580.147V604.573C369.18 618.063 381.447 629 396.577 629C411.707 629 423.974 618.063 423.974 604.573V581.626C482.647 570.677 522.525 521.954 516.358 468.795C510.178 415.636 459.945 375.239 400.001 375.227C365.648 375.227 337.797 350.395 337.797 319.767C337.797 289.138 365.648 264.306 400.001 264.306C434.355 264.306 462.206 289.138 462.206 319.767C462.206 333.256 474.473 344.193 489.603 344.193C504.733 344.193 517 333.256 517 319.767C516.92 270.412 478.139 227.844 423.974 217.659V195.427C423.974 181.937 411.707 171 396.577 171C381.447 171 369.18 181.937 369.18 195.427V219.15C312.647 232.913 276.261 281.85 284.046 333.638C291.832 385.425 341.395 424.081 400.001 424.069C433.9 424.069 461.551 448.269 462.166 478.48C462.795 508.692 436.147 533.786 402.276 534.883Z'
          fill={color}
        />
      </g>
    </svg>
  );
};

export const IconPaymentActiveSVG = ({ size = 22, color = 'orange' }) => {
  return (
    <svg width={size} height={size} viewBox='0 0 800 800' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_253_6337)'>
        <path
          d='M52.6213 543.889C33.7255 498.271 24 449.377 24 400C24 350.623 33.7255 301.729 52.6213 256.111C71.5171 210.493 99.213 169.043 134.128 134.128C169.043 99.213 210.493 71.5171 256.111 52.6213C301.729 33.7255 350.623 24 400 24C449.377 24 498.271 33.7255 543.889 52.6213C589.507 71.5171 630.957 99.213 665.872 134.128C700.787 169.043 728.483 210.493 747.379 256.111C766.274 301.729 776 350.623 776 400C776 449.377 766.274 498.271 747.379 543.889C728.483 589.507 700.787 630.957 665.872 665.872C630.957 700.787 589.507 728.483 543.889 747.379C498.271 766.274 449.377 776 400 776C350.623 776 301.729 766.274 256.111 747.379C210.493 728.483 169.043 700.787 134.128 665.872C99.213 630.957 71.5171 589.507 52.6213 543.889Z'
          fill={color}
          stroke='white'
          strokeWidth='48'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M402.276 534.883C399.185 534.287 396.015 534.18 392.885 534.597C361.515 531.341 337.85 507.678 337.797 479.53C337.797 466.04 325.53 455.103 310.4 455.103C295.27 455.103 283.003 466.04 283.003 479.53C283.083 526.534 318.346 567.707 369.18 580.147V604.573C369.18 618.063 381.447 629 396.577 629C411.707 629 423.974 618.063 423.974 604.573V581.626C482.647 570.677 522.525 521.954 516.358 468.795C510.178 415.636 459.945 375.239 400.001 375.227C365.648 375.227 337.797 350.395 337.797 319.767C337.797 289.138 365.648 264.306 400.001 264.306C434.355 264.306 462.206 289.138 462.206 319.767C462.206 333.256 474.473 344.193 489.603 344.193C504.733 344.193 517 333.256 517 319.767C516.92 270.412 478.139 227.844 423.974 217.659V195.427C423.974 181.937 411.707 171 396.577 171C381.447 171 369.18 181.937 369.18 195.427V219.15C312.647 232.913 276.261 281.85 284.046 333.638C291.832 385.425 341.395 424.081 400.001 424.069C433.9 424.069 461.551 448.269 462.166 478.48C462.795 508.692 436.147 533.786 402.276 534.883Z'
          fill='white'
        />
      </g>
    </svg>
  );
};

export const IconDuplicateSVG = ({ size = '18', color = '#acb5bf' }) => {
  return (
    <svg width={size} height={size} viewBox='0 0 512 512' xmlns='http://www.w3.org/2000/svg'>
      <rect x='128' y='128' width='336' height='336' rx='57' ry='57' fill='none' stroke={color} strokeLinecap='round' strokeLinejoin='round' strokeWidth='32px' />
      <path
        d='M383.5,128l.5-24a56.16,56.16,0,0,0-56-56H112a64.19,64.19,0,0,0-64,64V328a56.16,56.16,0,0,0,56,56h24'
        fill='none'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='32px'
      />
      <line x1='296' y1='216' x2='296' y2='376' fill='none' stroke={color} strokeLinecap='round' strokeLinejoin='round' strokeWidth='32px' />
      <line x1='376' y1='296' x2='216' y2='296' fill='none' stroke={color} strokeLinecap='round' strokeLinejoin='round' strokeWidth='32px' />
    </svg>
  );
};

export const IconClicksSVG = ({ color = '#acb5bf' }) => {
  return (
    <svg width='16' height='16' viewBox='0 0 512 512' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M64.75 277.25C64.75 271.614 66.9888 266.209 70.974 262.224C74.9591 258.239 80.3641 256 85.9999 256H171C176.635 256 182.04 258.239 186.026 262.224C190.011 266.209 192.25 271.614 192.25 277.25V404.75C192.25 410.385 190.011 415.79 186.026 419.775C182.04 423.761 176.635 425.999 171 425.999H85.9999C80.3641 425.999 74.9591 423.761 70.974 419.775C66.9888 415.79 64.75 410.385 64.75 404.75V277.25Z'
        stroke={color}
        strokeWidth='25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M192.25 192.251C192.25 186.615 194.489 181.21 198.474 177.225C202.459 173.24 207.864 171.001 213.5 171.001H298.5C304.135 171.001 309.54 173.24 313.526 177.225C317.511 181.21 319.75 186.615 319.75 192.251V404.75C319.75 410.386 317.511 415.791 313.526 419.776C309.54 423.761 304.135 426 298.5 426H213.5C207.864 426 202.459 423.761 198.474 419.776C194.489 415.791 192.25 410.386 192.25 404.75V192.251Z'
        stroke={color}
        strokeWidth='25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M319.75 107.25C319.75 101.614 321.989 96.2091 325.974 92.224C329.959 88.2388 335.364 86 341 86H426C431.635 86 437.04 88.2388 441.026 92.224C445.011 96.2091 447.25 101.614 447.25 107.25V404.749C447.25 410.385 445.011 415.79 441.026 419.775C437.04 423.76 431.635 425.999 426 425.999H341C335.364 425.999 329.959 423.76 325.974 419.775C321.989 415.79 319.75 410.385 319.75 404.749V107.25Z'
        stroke={color}
        strokeWidth='25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export function IconCheckSVG({ size = '30' }) {
  return (
    <svg
      version='1.1'
      id='Capa_1'
      xmlns='http://www.w3.org/2000/svg'
      x='0px'
      y='0px'
      width={size}
      height={size}
      viewBox='0 0 215.434 215.434'
      enableBackground='new 0 0 215.434 215.434'
    >
      <g>
        <circle fill='#17ce17' cx='107.717' cy='107.717' r='106.299' />
        <polygon fill='#FFFFFF' points='96.977,121.718 145.084,50.79 168.752,69.02 103.583,164.647 46.678,120.299 63.562,96.402 	' />
      </g>
    </svg>
  );
}

export function IconTrashSVG({ color = '#bdbdbd', size = '30' }) {
  return (
    <svg width={size} height={size} viewBox='0 0 1080 1080' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M372.958 179.2H364.167C369.002 179.2 372.958 175.24 372.958 170.4V179.2H707.042V170.4C707.042 175.24 710.998 179.2 715.833 179.2H707.042V258.4H786.167V170.4C786.167 131.57 754.627 100 715.833 100H364.167C325.373 100 293.833 131.57 293.833 170.4V258.4H372.958V179.2ZM926.833 258.4H153.167C133.715 258.4 118 274.13 118 293.6V328.8C118 333.64 121.956 337.6 126.792 337.6H215.148L220.313 912.9C222.071 950.41 253.062 980 290.536 980H789.464C827.048 980 857.929 950.52 859.687 912.9L864.852 337.6H953.208C958.044 337.6 962 333.64 962 328.8V293.6C962 274.13 946.285 258.4 926.833 258.4ZM781.002 900.8H298.998L294.383 337.6H785.617L781.002 900.8Z'
        fill={color}
      />
      <path d='M364.167 179.2H372.958V170.4C372.958 175.24 369.002 179.2 364.167 179.2Z' fill={color} />
      <path d='M707.042 170.4V179.2H715.833C710.998 179.2 707.042 175.24 707.042 170.4Z' fill={color} />
      <path d='M354 162H373V261H354V162Z' fill={color} />
      <path d='M707 162H726V261H707V162Z' fill={color} />
      <path d='M356 160H743V180H356V160Z' fill={color} />
    </svg>
  );
}

export function IconFillTrashSVG() {
  return (
    <svg width='30' height='30' viewBox='0 0 1080 1080' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M194 195.547C194 178.147 207.253 164.042 223.602 164.042H856.398C872.747 164.042 886 178.147 886 195.547C886 212.947 872.747 227.052 856.398 227.052H223.602C207.253 227.052 194 212.947 194 195.547Z'
        fill='#bdbdbd'
      />
      <path
        d='M815.635 305.039V862.44C815.635 884.733 807.324 906.113 792.529 921.876C777.733 937.639 757.667 946.495 736.744 946.495H342.286C321.362 946.495 301.296 937.639 286.501 921.876C271.706 906.113 263.394 884.733 263.394 862.44V305.039H815.635Z'
        fill='#bdbdbd'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M233.792 305.039C233.792 287.639 247.046 273.534 263.394 273.534H815.635C831.984 273.534 845.237 287.639 845.237 305.039V862.44C845.237 893.077 833.814 922.467 813.472 944.141C793.128 965.817 765.528 978 736.744 978H342.286C313.501 978 285.902 965.817 265.558 944.141C245.215 922.467 233.792 893.077 233.792 862.44V305.039ZM292.996 336.544V862.44C292.996 876.388 298.197 889.758 307.444 899.611C316.69 909.462 329.224 914.991 342.286 914.991H736.744C749.806 914.991 762.339 909.462 771.585 899.611C780.833 889.758 786.034 876.388 786.034 862.44V336.544H292.996Z'
        fill='#bdbdbd'
      />
      <path
        d='M447.975 144.817C437.919 153.34 432.269 164.9 432.269 176.954H646.76C646.76 164.9 641.111 153.34 631.054 144.817C620.998 136.293 607.359 131.505 593.137 131.505H485.892C471.67 131.505 458.031 136.293 447.975 144.817Z'
        fill='#bdbdbd'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M429.534 120.172C445.393 106.73 465.727 100 485.892 100H593.137C613.303 100 633.636 106.73 649.495 120.172C665.526 133.76 676.362 153.929 676.362 176.954C676.362 194.354 663.109 208.459 646.76 208.459H432.269C415.921 208.459 402.668 194.354 402.668 176.954C402.668 153.929 413.503 133.76 429.534 120.172Z'
        fill='#bdbdbd'
      />
    </svg>
  );
}

export const IconTwoMobileViewSVG = ({ isActive = false }) => {
  return (
    <svg width='114' height='114' viewBox='0 0 200 200' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='57' y='26' width='86.2353' height='148' rx='9' fill='#F6F9FE' stroke={isActive ? '#17ce17' : '#AFAFAF'} strokeWidth='2' />
      <rect x='69' y='52' width='28' height='28' rx='1' fill='#B1D0FE' stroke='#AFAFAF' strokeWidth='2' />
      <rect x='69' y='86' width='28' height='28' rx='1' fill='#B1D0FE' stroke='#AFAFAF' strokeWidth='2' />
      <rect x='69' y='120' width='28' height='28' rx='1' fill='#B1D0FE' stroke='#AFAFAF' strokeWidth='2' />
      <rect x='103' y='52' width='28' height='28' rx='1' fill='#B1D0FE' stroke='#AFAFAF' strokeWidth='2' />
      <rect x='103' y='86' width='28' height='28' rx='1' fill='#B1D0FE' stroke='#AFAFAF' strokeWidth='2' />
      <rect x='103' y='120' width='28' height='28' rx='1' fill='#B1D0FE' stroke='#AFAFAF' strokeWidth='2' />
    </svg>
  );
};

export const IconThreeMobileViewSVG = ({ isActive = false }) => {
  return (
    <svg width='94' height='94' viewBox='0 0 160 272' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M24 11H136C143.18 11 149 16.8203 149 24V248C149 255.18 143.18 261 136 261H24C16.8203 261 11 255.18 11 248V24C11 16.8203 16.8203 11 24 11Z'
        fill='#F6F9FE'
        stroke={isActive ? '#17ce17' : '#AFAFAF'}
        strokeWidth='2'
      />
      <rect x='23' y='49' width='51' height='82' rx='5' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
      <rect x='23' y='143' width='51' height='82' rx='5' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
      <rect x='86' y='49' width='51' height='82' rx='5' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
      <rect x='86' y='143' width='51' height='82' rx='5' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
    </svg>
  );
};

export const IconForthMobileViewSVG = ({ isActive = false }) => {
  return (
    <svg width='114' height='114' viewBox='0 0 200 200' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='57' y='26' width='86.2353' height='148' rx='9' fill='#F6F9FE' stroke={isActive ? '#17ce17' : '#AFAFAF'} strokeWidth='2' />
      <rect x='67' y='45' width='65' height='77' rx='1' fill='#B1D0FE' stroke='#AFAFAF' strokeWidth='2' />
      <rect x='67' y='134' width='65' height='40' rx='1' fill='#B1D0FE' stroke='#AFAFAF' strokeWidth='2' />
    </svg>
  );
};

export const IconFistMobileViewSVG = ({ isActive = false }) => {
  return (
    <svg width='114' height='114' viewBox='0 0 200 200' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='57' y='26' width='86.2353' height='148' rx='9' fill='#F6F9FE' stroke={isActive ? '#17ce17' : '#AFAFAF'} strokeWidth='2' />
      <rect x='67' y='61' width='18' height='18' rx='1' fill='#B1D0FE' stroke='#AFAFAF' strokeWidth='2' />
      <rect x='91' y='61' width='18' height='18' rx='1' fill='#B1D0FE' stroke='#AFAFAF' strokeWidth='2' />
      <rect x='115' y='61' width='18' height='18' rx='1' fill='#B1D0FE' stroke='#AFAFAF' strokeWidth='2' />
      <rect x='67' y='109' width='18' height='18' rx='1' fill='#B1D0FE' stroke='#AFAFAF' strokeWidth='2' />
      <rect x='91' y='109' width='18' height='18' rx='1' fill='#B1D0FE' stroke='#AFAFAF' strokeWidth='2' />
      <rect x='115' y='109' width='18' height='18' rx='1' fill='#B1D0FE' stroke='#AFAFAF' strokeWidth='2' />
      <rect x='67' y='85' width='18' height='18' rx='1' fill='#B1D0FE' stroke='#AFAFAF' strokeWidth='2' />
      <rect x='91' y='85' width='18' height='18' rx='1' fill='#B1D0FE' stroke='#AFAFAF' strokeWidth='2' />
      <rect x='115' y='85' width='18' height='18' rx='1' fill='#B1D0FE' stroke='#AFAFAF' strokeWidth='2' />
      <rect x='67' y='133' width='18' height='18' rx='1' fill='#B1D0FE' stroke='#AFAFAF' strokeWidth='2' />
      <rect x='91' y='133' width='18' height='18' rx='1' fill='#B1D0FE' stroke='#AFAFAF' strokeWidth='2' />
      <rect x='115' y='133' width='18' height='18' rx='1' fill='#B1D0FE' stroke='#AFAFAF' strokeWidth='2' />
    </svg>
  );
};

export const IconImageViewFullSVG = ({ isActive = false }) => {
  return (
    <svg width='50' height='50' viewBox='0 0 120 114' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_1259_5660)'>
        <rect x='1' y='1' width='118' height='112' rx='13' fill='#F6F9FE' stroke={isActive ? '#17ce17' : '#AFAFAF'} strokeWidth='2' />
        <rect x='1' y='1' width='118' height='112' rx='13' fill='#F6F9FE' stroke={isActive ? '#17ce17' : '#AFAFAF'} strokeWidth='2' />
        <path d='M14 1H106C113.18 1 119 6.8203 119 14V79H1V14C1 6.8203 6.8203 1 14 1Z' fill='#B1D0FE' stroke={isActive ? '#17ce17' : '#AFAFAF'} strokeWidth='2' />
      </g>
      <defs>
        <clipPath id='clip0_1259_5660'>
          <rect width='120' height='114' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export const IconImageViewSquareSVG = ({ isActive = false }) => {
  return (
    <svg width='50' height='50' viewBox='0 0 120 114' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_1259_5656)'>
        <rect x='1' y='1' width='118' height='112' rx='13' fill='#F6F9FE' stroke={isActive ? '#17ce17' : '#AFAFAF'} strokeWidth='2' />
        <rect x='1' y='1' width='118' height='112' rx='13' fill='#F6F9FE' stroke={isActive ? '#17ce17' : '#AFAFAF'} strokeWidth='2' />
        <path
          d='M24 9H96C103.18 9 109 14.8203 109 22V66C109 73.1797 103.18 79 96 79H24C16.8203 79 11 73.1797 11 66V22C11 14.8203 16.8203 9 24 9Z'
          fill='#B1D0FE'
          stroke='#A9ACBA'
          strokeWidth='2'
        />
      </g>
      <defs>
        <clipPath id='clip0_1259_5656'>
          <rect width='120' height='114' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export const IconNineMobileViewSVG = ({ isActive = false }) => {
  return (
    <svg width='114' height='114' viewBox='0 0 200 200' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='57' y='26' width='86.2353' height='148' rx='9' fill='#F6F9FE' stroke={isActive ? '#17ce17' : '#AFAFAF'} strokeWidth='2' />
      <rect x='70' y='52' width='60' height='28' rx='1' fill='#ECF2FF' stroke='#AFAFAF' strokeWidth='2' />
      <rect x='70' y='86' width='60' height='28' rx='1' fill='#ECF2FF' stroke='#AFAFAF' strokeWidth='2' />
      <rect x='70' y='120' width='60' height='28' rx='1' fill='#ECF2FF' stroke='#AFAFAF' strokeWidth='2' />
      <line x1='76' y1='65' x2='124' y2='65' stroke='#AFAFAF' strokeWidth='2' strokeLinecap='round' />
      <line x1='76' y1='99' x2='124' y2='99' stroke='#AFAFAF' strokeWidth='2' strokeLinecap='round' />
      <line x1='76' y1='133' x2='124' y2='133' stroke='#AFAFAF' strokeWidth='2' strokeLinecap='round' />
    </svg>
  );
};

export const IconSixMobileViewSVG = ({ isActive = false }) => {
  return (
    <svg width='114' height='114' viewBox='0 0 200 200' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='57' y='26' width='86.2353' height='148' rx='9' fill='#F6F9FE' stroke={isActive ? '#17ce17' : '#AFAFAF'} strokeWidth='2' />
      <rect x='70' y='52' width='60' height='28' rx='1' fill='#ECF2FF' stroke='#AFAFAF' strokeWidth='2' />
      <rect x='70' y='86' width='60' height='28' rx='1' fill='#ECF2FF' stroke='#AFAFAF' strokeWidth='2' />
      <rect x='70' y='120' width='60' height='28' rx='1' fill='#ECF2FF' stroke='#AFAFAF' strokeWidth='2' />
      <rect x='70' y='52' width='28' height='28' rx='1' fill='#B1D0FE' stroke='#AFAFAF' strokeWidth='2' />
      <rect x='70' y='86' width='28' height='28' rx='1' fill='#B1D0FE' stroke='#AFAFAF' strokeWidth='2' />
      <rect x='70' y='120' width='28' height='28' rx='1' fill='#B1D0FE' stroke='#AFAFAF' strokeWidth='2' />
      <line x1='106' y1='65' x2='124' y2='65' stroke='#AFAFAF' strokeWidth='2' strokeLinecap='round' />
      <line x1='106' y1='99' x2='124' y2='99' stroke='#AFAFAF' strokeWidth='2' strokeLinecap='round' />
      <line x1='106' y1='133' x2='124' y2='133' stroke='#AFAFAF' strokeWidth='2' strokeLinecap='round' />
    </svg>
  );
};

export const IconFistSliderViewSVG = ({ isActive = false }) => {
  return (
    <svg width='92' height='92' viewBox='0 0 160 272' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='11' y='11' width='138' height='250' rx='13' fill='#F6F9FE' stroke={isActive ? '#17ce17' : '#AFAFAF'} strokeWidth='2' />
      <rect x='21' y='121' width='31' height='30' rx='3' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
      <rect x='60' y='121' width='31' height='30' rx='3' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
      <rect x='99' y='121' width='31' height='30' rx='3' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
      <path d='M141 121H149V151H141C139.343 151 138 149.657 138 148V124C138 122.343 139.343 121 141 121Z' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
    </svg>
  );
};

export const IconSixSliderViewSVG = ({ isActive = false }) => {
  return (
    <svg width='114' height='114' viewBox='0 0 200 200' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='57' y='26' width='86.2353' height='148' rx='9' fill='#F6F9FE' stroke={isActive ? '#17ce17' : '#AFAFAF'} strokeWidth='2' />
      <rect x='70' y='86' width='60' height='28' rx='1' fill='#ECF2FF' stroke='#AFAFAF' strokeWidth='2' />
      <rect x='70' y='86' width='28' height='28' rx='1' fill='#B1D0FE' stroke='#AFAFAF' strokeWidth='2' />
      <line x1='106' y1='99' x2='124' y2='99' stroke='#AFAFAF' strokeWidth='2' strokeLinecap='round' />
    </svg>
  );
};

export const IconNineSliderViewSVG = ({ isActive = false }) => {
  return (
    <svg width='114' height='114' viewBox='0 0 200 200' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='57' y='26' width='86.2353' height='148' rx='9' fill='#F6F9FE' stroke={isActive ? '#17ce17' : '#AFAFAF'} strokeWidth='2' />
      <rect x='70' y='86' width='60' height='28' rx='1' fill='#ECF2FF' stroke='#AFAFAF' strokeWidth='2' />
      <line x1='76' y1='99' x2='124' y2='99' stroke='#AFAFAF' strokeWidth='2' strokeLinecap='round' />
    </svg>
  );
};

export const IconSevenMobileViewSVG = ({ isActive = false, margin = '0 0 0 16px' }) => {
  return (
    <svg style={{ margin: margin }} width='54' height='115' viewBox='0 0 160 280' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='11' y='11' width='145' height='250' rx='13' fill='#F6F9FE' stroke={isActive ? '#17ce17' : '#AFAFAF'} strokeWidth='2' />
      <rect x='27' y='49' width='51' height='82' rx='5' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
      <rect x='27' y='143' width='51' height='82' rx='5' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
      <rect x='91' y='49' width='51' height='82' rx='5' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
      <rect x='91' y='143' width='51' height='82' rx='5' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
    </svg>
  );
};

export const IconFirstSliderViewSVG = ({ isActive = false }) => {
  return (
    <svg width='92' height='92' viewBox='0 0 160 272' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='11' y='11' width='138' height='250' rx='13' fill='#F6F9FE' stroke={isActive ? '#17ce17' : '#AFAFAF'} strokeWidth='2' />
      <rect x='21' y='74' width='94' height='118' rx='3' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
      <path d='M127 189L127 77C127 75.3431 128.343 74 130 74L149 74L149 192L130 192C128.343 192 127 190.657 127 189Z' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
    </svg>
  );
};

export const IconSecondSliderViewSVG = ({ isActive = false }) => {
  return (
    <svg width='92' height='92' viewBox='0 0 160 272' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='11' y='11' width='138' height='250' rx='13' fill='#F6F9FE' stroke={isActive ? '#17ce17' : '#AFAFAF'} strokeWidth='2' />
      <rect x='21' y='97' width='44' height='71' rx='5' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
      <rect x='75' y='97' width='43' height='71' rx='5' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
      <path d='M133 97H149V168H133C130.239 168 128 165.761 128 163V102C128 99.2386 130.239 97 133 97Z' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
    </svg>
  );
};

export const IconPreviewInstagramViewSVG = ({ isActive = false }) => {
  return (
    <svg width='92' height='92' viewBox='0 0 160 272' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='11' y='11' width='138' height='250' rx='13' fill='#F6F9FE' stroke={isActive ? '#17ce17' : '#AFAFAF'} strokeWidth='2' />
      <rect x='40' y='199' width='40' height='5' rx='2.5' fill='#A9ACBA' />
      <rect x='99' y='194' width='44' height='14' rx='7' fill='#A9ACBA' />
      <rect x='18' y='193' width='17' height='17' rx='8.5' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
      <rect x='105' y='59' width='36' height='36' rx='3' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
      <rect x='105' y='103' width='36' height='36' rx='3' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
      <path
        d='M108 148H138C139.657 148 141 149.343 141 151V181C141 182.657 139.657 184 138 184H108C106.343 184 105 182.657 105 181V151C105 149.343 106.343 148 108 148Z'
        fill='#B1D0FE'
        stroke='#A9ACBA'
        strokeWidth='2'
      />
      <rect x='18' y='59' width='80' height='80' rx='3' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
      <rect x='18' y='148' width='36' height='36' rx='3' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
      <rect x='62' y='148' width='36' height='36' rx='3' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
    </svg>
  );
};

export const IconPreviewInstagramSquareViewSVG = ({ isActive = false }) => {
  return (
    <svg width='92' height='92' viewBox='0 0 160 272' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='11' y='11' width='138' height='250' rx='13' fill='#F6F9FE' stroke={isActive ? '#17ce17' : '#AFAFAF'} strokeWidth='2' />
      <rect x='61' y='103' width='36' height='36' rx='3' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
      <rect x='18' y='103' width='36' height='36' rx='3' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
      <rect x='61' y='59' width='36' height='36' rx='3' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
      <rect x='40' y='199' width='40' height='5' rx='2.5' fill='#A9ACBA' />
      <rect x='99' y='194' width='44' height='14' rx='7' fill='#A9ACBA' />
      <rect x='18' y='193' width='17' height='17' rx='8.5' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
      <rect x='105' y='59' width='36' height='36' rx='3' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
      <rect x='105' y='103' width='36' height='36' rx='3' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
      <path
        d='M108 148H138C139.657 148 141 149.343 141 151V181C141 182.657 139.657 184 138 184H108C106.343 184 105 182.657 105 181V151C105 149.343 106.343 148 108 148Z'
        fill='#B1D0FE'
        stroke='#A9ACBA'
        strokeWidth='2'
      />
      <rect x='18' y='59' width='36' height='36' rx='3' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
      <rect x='18' y='148' width='36' height='36' rx='3' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
      <rect x='62' y='148' width='36' height='36' rx='3' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
    </svg>
  );
};

export const IconThirdSliderViewSVG = ({ isActive = false }) => {
  return (
    <svg width='92' height='92' viewBox='0 0 160 272' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='11' y='11' width='138' height='250' rx='13' fill='#F6F9FE' stroke={isActive ? '#17ce17' : '#AFAFAF'} strokeWidth='2' />
      <rect x='21' y='112' width='46' height='46' rx='3' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
      <rect x='77' y='112' width='46' height='46' rx='3' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
      <path d='M136 112H149V158H136C134.343 158 133 156.657 133 155V115C133 113.343 134.343 112 136 112Z' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
    </svg>
  );
};

export const IconSavingSVG = () => {
  return (
    <svg
      width='20'
      height='20'
      style={{ marginLeft: '10px' }}
      version='1.1'
      id='Layer_1'
      xmlns='http://www.w3.org/2000/svg'
      x='0px'
      y='0px'
      viewBox='0 0 100.25 100.25'
      fill='#fff'
    >
      <path
        d='M83.061,27.94l-11-11c-0.281-0.281-0.663-0.439-1.061-0.439H18c-0.828,0-1.5,0.671-1.5,1.5v64c0,0.829,0.672,1.5,1.5,1.5h64
  c0.828,0,1.5-0.671,1.5-1.5v-53C83.5,28.602,83.342,28.221,83.061,27.94z M34.5,19.5h31v21h-31V19.5z M71.5,80.5h-43v-26h43V80.5z
  M80.5,80.5h-6V53c0-0.829-0.672-1.5-1.5-1.5H27c-0.828,0-1.5,0.671-1.5,1.5v27.5h-6v-61h12V42c0,0.829,0.672,1.5,1.5,1.5h34
  c0.828,0,1.5-0.671,1.5-1.5V19.5h1.879L80.5,29.621V80.5z'
      />
    </svg>
  );
};

export const IconHeader1SVG = ({ isActive = false }) => {
  return (
    <svg width='590' height='272' viewBox='0 0 590 272' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='1' y='1' width='588' height='270' rx='19' fill='#F6F9FE' />
      <rect x='1' y='1' width='588' height='270' rx='19' stroke={isActive ? '#17ce17' : '#CACBCD'} strokeWidth='7' />
      <circle cx='166' cy='136' r='70' fill='#B1D0FE' />
      <rect x='263' y='95' width='230' height='27.7108' rx='13.8554' fill='#B1D0FE' />
      <rect x='265.771' y='140.723' width='41.5663' height='41.5663' rx='6.5972' fill='#B1D0FE' />
      <rect x='326.735' y='140.723' width='41.5663' height='41.5663' rx='6.5972' fill='#B1D0FE' />
      <rect x='387.699' y='140.723' width='41.5663' height='41.5663' rx='6.5972' fill='#B1D0FE' />
      <rect x='448.663' y='140.723' width='41.5663' height='41.5663' rx='6.5972' fill='#B1D0FE' />
    </svg>
  );
};

export const IconHeader2SVG = ({ isActive = false }) => {
  return (
    <svg width='590' height='272' viewBox='0 0 590 272' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='1' y='1' width='588' height='270' rx='19' fill='#F6F9FE' />
      <rect x='1' y='1' width='588' height='270' rx='19' stroke={isActive ? '#17ce17' : '#CACBCD'} strokeWidth='7' />
      <circle cx='166' cy='113' r='70' fill='#B1D0FE' />
      <rect x='263' y='72' width='230' height='27.7108' rx='13.8554' fill='#B1D0FE' />
      <rect x='265.771' y='117.723' width='41.5663' height='41.5663' rx='6.5972' fill='#B1D0FE' />
      <rect x='326.735' y='117.723' width='41.5663' height='41.5663' rx='6.5972' fill='#B1D0FE' />
      <rect x='387.699' y='117.723' width='41.5663' height='41.5663' rx='6.5972' fill='#B1D0FE' />
      <rect x='448.663' y='117.723' width='41.5663' height='41.5663' rx='6.5972' fill='#B1D0FE' />
      <rect x='96' y='203' width='397' height='25' rx='12.5' fill='#B1D0FE' />
    </svg>
  );
};

export const IconHeader3SVG = ({ isActive = false }) => {
  return (
    <svg width='590' height='272' viewBox='0 0 590 272' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='1' y='1' width='588' height='270' rx='19' fill='#F6F9FE' />
      <rect x='1' y='1' width='588' height='270' rx='19' stroke={isActive ? '#17ce17' : '#CACBCD'} strokeWidth='7' />
      <circle cx='295' cy='95' r='66' fill='#B1D0FE' />
      <rect x='212' y='180' width='166' height='20' rx='10' fill='#B1D0FE' />
      <rect x='214' y='213' width='30' height='30' rx='4.76146' fill='#B1D0FE' />
      <rect x='258' y='213' width='30' height='30' rx='4.76146' fill='#B1D0FE' />
      <rect x='302' y='213' width='30' height='30' rx='4.76146' fill='#B1D0FE' />
      <rect x='346' y='213' width='30' height='30' rx='4.76146' fill='#B1D0FE' />
    </svg>
  );
};

export const IconHeader5SVG = ({ isActive = false }) => {
  return (
    <svg width='590' height='272' viewBox='0 0 590 272' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='1' y='1' width='588' height='270' rx='19' fill='#F6F9FE' />
      <rect x='1' y='1' width='588' height='270' rx='19' stroke={isActive ? '#17ce17' : '#CACBCD'} strokeWidth='7' />
      <rect x='202' y='142' width='186' height='22.4096' rx='11.2048' fill='#B1D0FE' />
      <rect x='204.241' y='178.977' width='33.6145' height='33.6145' rx='5.33513' fill='#B1D0FE' />
      <rect x='253.542' y='178.977' width='33.6145' height='33.6145' rx='5.33513' fill='#B1D0FE' />
      <rect x='302.844' y='178.977' width='33.6145' height='33.6145' rx='5.33513' fill='#B1D0FE' />
      <rect x='352.145' y='178.977' width='33.6145' height='33.6145' rx='5.33513' fill='#B1D0FE' />
      <rect width='590' height='120' fill='#B1D0FE' />
    </svg>
  );
};

export const IconHeader4SVG = ({ isActive = false }) => {
  return (
    <svg width='590' height='272' viewBox='0 0 590 272' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_1180_23079)'>
        <rect width='590' height='272' rx='20' fill='#F6F9FE' />
        <rect width='590' height='272' fill='#B1D0FE' />
        <rect x='202' y='136' width='186' height='22.4096' rx='11.2048' fill='white' />
        <rect x='204.241' y='172.977' width='33.6145' height='33.6145' rx='5.33513' fill='white' />
        <rect x='253.542' y='172.977' width='33.6145' height='33.6145' rx='5.33513' fill='white' />
        <rect x='302.844' y='172.977' width='33.6145' height='33.6145' rx='5.33513' fill='white' />
        <rect x='352.145' y='172.977' width='33.6145' height='33.6145' rx='5.33513' fill='white' />
      </g>
      <rect x='1' y='1' width='588' height='270' rx='19' stroke={isActive ? '#17ce17' : '#CACBCD'} strokeWidth='7' />
      <defs>
        <clipPath id='clip0_1180_23079'>
          <rect width='590' height='272' rx='20' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export const IconHeader6SVG = ({ isActive = false }) => {
  return (
    <svg width='590' height='272' viewBox='0 0 590 272' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_2491_119)'>
        <rect width='590' height='272' rx='20' fill='#F6F9FE' />
        <rect width='590' height='272' fill='#B1D0FE' />
        <rect x='206' y='191' width='33.6145' height='33.6145' rx='5.33513' fill='white' />
        <rect x='255.301' y='191' width='33.6145' height='33.6145' rx='5.33513' fill='white' />
        <rect x='304.603' y='191' width='33.6145' height='33.6145' rx='5.33513' fill='white' />
        <rect x='353.903' y='191' width='33.6145' height='33.6145' rx='5.33513' fill='white' />
        <rect x='202' y='52' width='186' height='22.4096' rx='11.2048' fill='white' />
      </g>

      <rect x='3.5' y='3.5' width='583' height='265' rx='16.5' stroke={isActive ? '#17ce17' : '#CACBCD'} strokeWidth='7' />

      <defs>
        <clipPath id='clip0_2491_119'>
          <rect width='590' height='272' rx='20' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export const IconHeaderLayoutFirstViewSVG = ({ isActive = false, isTabletSize = false }) => {
  const width = !isTabletSize ? '104' : '89';
  const height = !isTabletSize ? '72' : '62';
  return (
    <svg width={width} height={height} viewBox='0 0 200 200' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='-10' y='0' width='145' height='280' rx='9' transform='rotate(-90 60 100)' fill='#F6F9FE' stroke={isActive ? '#17ce17' : '#AFAFAF'} strokeWidth='2' />
      <rect x='15' y='60' width='70' height='70' rx='36' fill='#B1D0FE' />
      <line x1='103' y1='88' x2='180' y2='88' stroke='#B1D0FE' strokeWidth='12' strokeLinecap='round' />
      <rect x='97' y='103' width='15' height='15' rx='2' fill='#B1D0FE' />
      <rect x='121' y='103' width='15' height='15' rx='2' fill='#B1D0FE' />
      <rect x='145' y='103' width='15' height='15' rx='2' fill='#B1D0FE' />
      <rect x='169' y='103' width='15' height='15' rx='2' fill='#B1D0FE' />
    </svg>
  );
};

export const IconHeaderLayoutSecondViewSVG = ({ isActive = false, isTabletSize = false }) => {
  const width = !isTabletSize ? '80' : '70';
  const height = !isTabletSize ? '72' : '62';
  return (
    <svg width={width} height={height} style={{ overflow: 'visible' }} viewBox='0 0 590 334' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='-90' y='-35' width='760' height='395' rx='15' fill='#F6F9FE' stroke={isActive ? '#17ce17' : '#AFAFAF'} strokeWidth='4' />
      <circle cx='135.625' cy='135.625' r='95.625' fill='#B1D0FE' />
      <rect x='271.094' y='83.8281' width='278.906' height='33.2031' rx='16.6016' fill='#B1D0FE' />
      <rect x='40' y='261' width='510' height='33' rx='16.5' fill='#B1D0FE' />
      <rect x='271.094' y='151.562' width='55.7812' height='53.125' rx='8' fill='#B1D0FE' />
      <rect x='345.469' y='151.562' width='55.7812' height='53.125' rx='8' fill='#B1D0FE' />
      <rect x='419.844' y='151.562' width='55.7812' height='53.125' rx='8' fill='#B1D0FE' />
      <rect x='494.219' y='151.562' width='55.7812' height='53.125' rx='8' fill='#B1D0FE' />
    </svg>
  );
};

export const IconHeaderLayoutThirdViewSVG = ({ isActive = false, isTabletSize = false }) => {
  const width = !isTabletSize ? '104' : '89';
  const height = !isTabletSize ? '72' : '62';
  return (
    <svg width={width} height={height} viewBox='0 0 200 200' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='-10' y='0' width='145' height='280' rx='9' transform='rotate(-90 60 100)' fill='#F6F9FE' stroke={isActive ? '#17ce17' : '#AFAFAF'} strokeWidth='2' />
      <rect x='70' y='35' width='70' height='70' rx='36' fill='#B1D0FE' />
      <line x1='70' y1='120' x2='141' y2='120' stroke='#B1D0FE' strokeWidth='12' strokeLinecap='round' />
      <rect x='60' y='132' width='15' height='15' rx='2' fill='#B1D0FE' />
      <rect x='85' y='132' width='15' height='15' rx='2' fill='#B1D0FE' />
      <rect x='110' y='132' width='15' height='15' rx='2' fill='#B1D0FE' />
      <rect x='135' y='132' width='15' height='15' rx='2' fill='#B1D0FE' />
    </svg>
  );
};

export const IconHeaderLayoutFourthViewSVG = ({ isActive = false, isTabletSize = false }) => {
  const width = !isTabletSize ? '104' : '89';
  const height = !isTabletSize ? '72' : '62';
  return (
    <svg width={width} height={height} viewBox='0 0 200 200' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='-10' y='0' width='145' height='280' rx='9' transform='rotate(-90 60 100)' fill='#B1D0FE' stroke={isActive ? '#17ce17' : '#AFAFAF'} strokeWidth='2' />
      <line x1='70' y1='120' x2='141' y2='120' stroke='#F6F9FE' strokeWidth='12' strokeLinecap='round' />
      <rect x='60' y='132' width='15' height='15' rx='2' fill='#F6F9FE' />
      <rect x='85' y='132' width='15' height='15' rx='2' fill='#F6F9FE' />
      <rect x='110' y='132' width='15' height='15' rx='2' fill='#F6F9FE' />
      <rect x='135' y='132' width='15' height='15' rx='2' fill='#F6F9FE' />
    </svg>
  );
};

export const IconSpacerFirstViewSVG = ({ isActive = false, size = '114' }) => {
  return (
    <svg width={size} height={size} viewBox='0 0 200 200' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='57' y='26' width='86.2353' height='148' rx='9' fill='#F6F9FE' stroke={isActive ? '#17ce17' : '#AFAFAF'} strokeWidth='2' />
      <rect x='58' y='40' width='84' height='133' rx='4' fill='#B1D0FE' stroke='#AFAFAF' strokeWidth='2' />
      <path
        d='M100.707 27.2929C100.317 26.9024 99.6834 26.9024 99.2929 27.2929L92.9289 33.6569C92.5384 34.0474 92.5384 34.6805 92.9289 35.0711C93.3195 35.4616 93.9526 35.4616 94.3431 35.0711L100 29.4142L105.657 35.0711C106.047 35.4616 106.681 35.4616 107.071 35.0711C107.462 34.6805 107.462 34.0474 107.071 33.6569L100.707 27.2929ZM99 28L99 40L101 40L101 28L99 28Z'
        fill='#AFAFAF'
      />
    </svg>
  );
};

export const IconSpacerSecondViewSVG = ({ isActive = false, size = '114' }) => {
  return (
    <svg width={size} height={size} viewBox='0 0 200 200' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='57' y='26' width='86.2353' height='148' rx='9' fill='#F6F9FE' stroke={isActive ? '#17ce17' : '#AFAFAF'} strokeWidth='2' />
      <rect x='58' y='73' width='84' height='100' rx='4' fill='#B1D0FE' stroke='#AFAFAF' strokeWidth='2' />
      <path
        d='M100.707 28.2929C100.317 27.9024 99.6834 27.9024 99.2929 28.2929L92.9289 34.6569C92.5384 35.0474 92.5384 35.6805 92.9289 36.0711C93.3195 36.4616 93.9526 36.4616 94.3431 36.0711L100 30.4142L105.657 36.0711C106.047 36.4616 106.681 36.4616 107.071 36.0711C107.462 35.6805 107.462 35.0474 107.071 34.6569L100.707 28.2929ZM99.2929 73.7071C99.6834 74.0976 100.317 74.0976 100.707 73.7071L107.071 67.3431C107.462 66.9526 107.462 66.3195 107.071 65.9289C106.681 65.5384 106.047 65.5384 105.657 65.9289L100 71.5858L94.3431 65.9289C93.9526 65.5384 93.3195 65.5384 92.9289 65.9289C92.5384 66.3195 92.5384 66.9526 92.9289 67.3431L99.2929 73.7071ZM99 29L99 73L101 73L101 29L99 29Z'
        fill='#AFAFAF'
      />
    </svg>
  );
};

export const IconSpacerThirdViewSVG = ({ isActive = false, size = '114' }) => {
  return (
    <svg width={size} height={size} viewBox='0 0 200 200' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='57' y='26' width='86.2353' height='148' rx='9' fill='#F6F9FE' stroke={isActive ? '#17ce17' : '#AFAFAF'} strokeWidth='2' />
      <rect x='58' y='103' width='84' height='70' rx='4' fill='#B1D0FE' stroke='#AFAFAF' strokeWidth='2' />
      <path
        d='M100.707 30.2929C100.317 29.9024 99.6834 29.9024 99.2929 30.2929L92.9289 36.6569C92.5384 37.0474 92.5384 37.6805 92.9289 38.0711C93.3195 38.4616 93.9526 38.4616 94.3431 38.0711L100 32.4142L105.657 38.0711C106.047 38.4616 106.681 38.4616 107.071 38.0711C107.462 37.6805 107.462 37.0474 107.071 36.6569L100.707 30.2929ZM99.2929 100.707C99.6834 101.098 100.317 101.098 100.707 100.707L107.071 94.3431C107.462 93.9526 107.462 93.3195 107.071 92.9289C106.681 92.5384 106.047 92.5384 105.657 92.9289L100 98.5858L94.3431 92.9289C93.9526 92.5384 93.3195 92.5384 92.9289 92.9289C92.5384 93.3195 92.5384 93.9526 92.9289 94.3431L99.2929 100.707ZM99 31L99 100L101 100L101 31L99 31Z'
        fill='#AFAFAF'
      />
    </svg>
  );
};

export const IconSpacerFourthViewSVG = ({ isActive = false, size = '114' }) => {
  return (
    <svg width={size} height={size} viewBox='0 0 200 200' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='57' y='26' width='86.2353' height='148' rx='9' fill='#F6F9FE' stroke={isActive ? '#17ce17' : '#AFAFAF'} strokeWidth='2' />
      <rect x='58' y='150' width='84' height='23' rx='4' fill='#B1D0FE' stroke='#AFAFAF' strokeWidth='2' />
      <path
        d='M100.707 31.2929C100.317 30.9024 99.6834 30.9024 99.2929 31.2929L92.9289 37.6569C92.5384 38.0474 92.5384 38.6805 92.9289 39.0711C93.3195 39.4616 93.9526 39.4616 94.3431 39.0711L100 33.4142L105.657 39.0711C106.047 39.4616 106.681 39.4616 107.071 39.0711C107.462 38.6805 107.462 38.0474 107.071 37.6569L100.707 31.2929ZM99.2929 145.707C99.6834 146.098 100.317 146.098 100.707 145.707L107.071 139.343C107.462 138.953 107.462 138.319 107.071 137.929C106.681 137.538 106.047 137.538 105.657 137.929L100 143.586L94.3432 137.929C93.9526 137.538 93.3195 137.538 92.9289 137.929C92.5384 138.319 92.5384 138.953 92.9289 139.343L99.2929 145.707ZM99 32L99 145L101 145L101 32L99 32Z'
        fill='#AFAFAF'
      />
    </svg>
  );
};

export const IconSpacerFifthViewSVG = ({ isActive = false, size = '114' }) => {
  return (
    <svg width={size} height={size} viewBox='0 0 200 200' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_817_1194)'>
        <rect x='57' y='26' width='86.2353' height='148' rx='9' fill='#F6F9FE' stroke={isActive ? '#17ce17' : '#AFAFAF'} strokeWidth='2' />
        <path
          d='M100.707 29.2929C100.317 28.9024 99.6834 28.9024 99.2929 29.2929L92.9289 35.6569C92.5384 36.0474 92.5384 36.6805 92.9289 37.0711C93.3195 37.4616 93.9526 37.4616 94.3431 37.0711L100 31.4142L105.657 37.0711C106.047 37.4616 106.681 37.4616 107.071 37.0711C107.462 36.6805 107.462 36.0474 107.071 35.6569L100.707 29.2929ZM99.2929 169.707C99.6834 170.098 100.317 170.098 100.707 169.707L107.071 163.343C107.462 162.953 107.462 162.319 107.071 161.929C106.681 161.538 106.047 161.538 105.657 161.929L100 167.586L94.3432 161.929C93.9526 161.538 93.3195 161.538 92.9289 161.929C92.5384 162.319 92.5384 162.953 92.9289 163.343L99.2929 169.707ZM99 30L99 169L101 169L101 30L99 30Z'
          fill='#AFAFAF'
        />
      </g>
      <defs>
        <clipPath id='clip0_817_1194'>
          <rect width='200' height='200' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};
// ------------------------------------------------------

// -----------------1
export const IconColumnBlock = () => {
  return (
    <svg
      viewBox='0 0 114 114'
      xmlns='http://www.w3.org/2000/svg'
      xmlns:xlink='http://www.w3.org/1999/xlink'
      width='114.000000'
      height='114.000000'
      fill='none'
      customFrame='#000000'
    >
      <defs>
        <clipPath id='clipPath_2'>
          <rect width='114.000000' height='114.000000' x='0.000000' y='0.000000' fill='rgb(255,255,255)' />
        </clipPath>
      </defs>
      <g id='Сочетание 1'>
        <g id='heading layout 1 2' clipPath='url(#clipPath_2)' customFrame='url(#clipPath_2)'>
          <rect id='heading layout 1 2' width='114.000000' height='114.000000' x='0.000000' y='0.000000' />
          <path
            id='Форма 4'
            d='M27 30L87 30C94.1797 30 100 35.8203 100 43L100 51C100 58.1797 94.1797 64 87 64L27 64C19.8203 64 14 58.1797 14 51L14 43C14 35.8203 19.8203 30 27 30Z'
            fill='rgb(177,208,254)'
            fillRule='nonzero'
          />
          <path
            id='Форма 4'
            d='M87 30C94.1797 30 100 35.8203 100 43L100 51C100 58.1797 94.1797 64 87 64L27 64C19.8203 64 14 58.1797 14 51L14 43C14 35.8203 19.8203 30 27 30L87 30Z'
            fillRule='nonzero'
            stroke='rgb(169,172,186)'
            strokeWidth='2.000000'
          />
          <path id='Форма 5' d='M21 85L78 85' stroke='rgb(169,172,186)' strokeLinecap='round' strokeWidth='5.000000' />
          <path id='Форма 6' d='M21 76L91 76' stroke='rgb(169,172,186)' strokeLinecap='round' strokeWidth='5.000000' />
        </g>
      </g>
    </svg>
  );
};
// -----------------2
export const IconRowBlock = () => {
  return (
    <svg viewBox='-5 -5 97.5 44' xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' width='87.5' height='34' fill='none' customFrame='#000000'>
      <g id='Сочетание 2'>
        <rect id='Прямоугольник 1' width='34' height='32' x='1' y='1' rx='7' fill='rgb(177,208,254)' />
        <rect id='Прямоугольник 1' width='34' height='32' x='1' y='1' rx='7' stroke='rgb(169,172,186)' strokeWidth='2' />
        <path id='Форма 7' d='M45 22L77 22' stroke='rgb(169,172,186)' strokeLinecap='round' strokeWidth='5' />
        <path id='Форма 8' d='M45 13L85 13' stroke='rgb(169,172,186)' strokeLinecap='round' strokeWidth='5' />
      </g>
    </svg>
  );
};

export const IconDateLeftBlock = () => {
  return (
    <svg viewBox='0 0 87 44' xmlns='http://www.w3.org/2000/svg' width='87' height='34' fill='none'>
      <path d='M2 11L18 11' stroke='rgb(169,172,186)' strokeLinecap='round' strokeWidth='3' />
      <path d='M2 33L18 33' stroke='rgb(169,172,186)' strokeLinecap='round' strokeWidth='3' />
      <path d='M28 2L28 42' stroke='rgb(169,172,186)' strokeLinecap='round' strokeWidth='2' />
      <circle cx='28' cy='11' r='4' fill='rgb(177,208,254)' stroke='rgb(169,172,186)' strokeWidth='1.5' />
      <circle cx='28' cy='33' r='4' fill='rgb(177,208,254)' stroke='rgb(169,172,186)' strokeWidth='1.5' />
      <path d='M38 8L82 8' stroke='rgb(169,172,186)' strokeLinecap='round' strokeWidth='4' />
      <path d='M38 15L68 15' stroke='rgb(169,172,186)' strokeLinecap='round' strokeWidth='3' />
      <path d='M38 30L82 30' stroke='rgb(169,172,186)' strokeLinecap='round' strokeWidth='4' />
      <path d='M38 37L72 37' stroke='rgb(169,172,186)' strokeLinecap='round' strokeWidth='3' />
    </svg>
  );
};

// ------------------------------------------------------/////
export const IconInsideBlock = () => {
  return (
    <svg width='40' height='40' viewBox='0 0 114 114' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M22 23H92C99.1797 23 105 28.8203 105 36V79C105 86.1797 99.1797 92 92 92H22C14.8203 92 9 86.1797 9 79V36C9 28.8203 14.8203 23 22 23Z'
        fill='#B1D0FE'
        stroke='#A9ACBA'
        strokeWidth='2'
      />
      <path d='M21 48L85 48' stroke='#A9ACBA' strokeWidth='5' strokeLinecap='round' />
      <path d='M21 39L96 39' stroke='#A9ACBA' strokeWidth='5' strokeLinecap='round' />
    </svg>
  );
};

export const IconOutsideBlock = () => {
  return (
    <svg width='40' height='40' viewBox='0 0 114 114' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M22 49H92C99.1797 49 105 54.8203 105 62V79C105 86.1797 99.1797 92 92 92H22C14.8203 92 9 86.1797 9 79V62C9 54.8203 14.8203 49 22 49Z'
        fill='#B1D0FE'
        stroke='#A9ACBA'
        strokeWidth='2'
      />
      <path d='M19 36L83 36' stroke='#A9ACBA' strokeWidth='5' strokeLinecap='round' />
      <path d='M19 27L94 27' stroke='#A9ACBA' strokeWidth='5' strokeLinecap='round' />
    </svg>
  );
};

export const IconAlignRight = () => {
  return (
    <svg width='25' height='25' viewBox='0 0 100 100' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect width='25' height='25' fill='transparent' />
      <path d='M14 30H86' stroke='black' strokeWidth='5' strokeLinecap='round' />
      <path d='M32 43.667H86.4865' stroke='black' strokeWidth='5' strokeLinecap='round' />
      <path d='M14 57.333H86' stroke='black' strokeWidth='5' strokeLinecap='round' />
      <path d='M32 71H86.4865' stroke='black' strokeWidth='5' strokeLinecap='round' />
    </svg>
  );
};

export const IconAlignLeft = () => {
  return (
    <svg width='25' height='25' viewBox='0 0 100 100' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect width='25' height='25' fill='transparent' />
      <path d='M14 30H86' stroke='black' strokeWidth='5' strokeLinecap='round' />
      <path d='M14 43.667H68.4865' stroke='black' strokeWidth='5' strokeLinecap='round' />
      <path d='M14 57.333H86' stroke='black' strokeWidth='5' strokeLinecap='round' />
      <path d='M14 71H68.4865' stroke='black' strokeWidth='5' strokeLinecap='round' />
    </svg>
  );
};

export const IconExtendForm = ({ size = 24, color = '#000000' }) => {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M11 2C6.94493 2.0073 4.8215 2.10686 3.46447 3.46389C2 4.92835 2 7.28538 2 11.9994C2 16.7135 2 19.0705 3.46447 20.535C4.92893 21.9994 7.28596 21.9994 12 21.9994C16.714 21.9994 19.0711 21.9994 20.5355 20.535C21.8926 19.1779 21.9921 17.0545 21.9994 12.9994'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
      />
      <path d='M13 11L22 2M22 2H16.6562M22 2V7.34375M21 3L12 12M12 12H16M12 12V8' stroke={color} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
};

export const IconLockPost = ({ size = 24, color = '#1C274C' }) => {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M2 16C2 13.1716 2 11.7574 2.87868 10.8787C3.75736 10 5.17157 10 8 10H16C18.8284 10 20.2426 10 21.1213 10.8787C22 11.7574 22 13.1716 22 16C22 18.8284 22 20.2426 21.1213 21.1213C20.2426 22 18.8284 22 16 22H8C5.17157 22 3.75736 22 2.87868 21.1213C2 20.2426 2 18.8284 2 16Z'
        stroke={color}
        strokeWidth='1.5'
      />
      <path d='M12 14V18' stroke={color} strokeWidth='1.5' strokeLinecap='round' />
      <path d='M6 10V8C6 4.68629 8.68629 2 12 2C15.3137 2 18 4.68629 18 8V10' stroke={color} strokeWidth='1.5' strokeLinecap='round' />
    </svg>
  );
};

export const IconViewTypeHorizontal = () => {
  return (
    <svg width='45' height='45' viewBox='0 0 180 152' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='15' y='66' width='81' height='19' rx='9.5' fill='#B1D0FE' />
      <rect x='142' y='63' width='25' height='25' rx='8' fill='#B1D0FE' />
      <rect x='113' y='63' width='25' height='25' rx='8' fill='#B1D0FE' />
    </svg>
  );
};

export const IconViewTypeVertical = () => {
  return (
    <svg width='45' height='45' viewBox='0 0 180 152' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='24' y='73' width='26.3197' height='25.0664' rx='8' fill='#B1D0FE' />
      <rect x='59.0898' y='73' width='26.3197' height='25.0664' rx='8' fill='#B1D0FE' />
      <rect x='94.1875' y='73' width='26.3197' height='25.0664' rx='8' fill='#B1D0FE' />
      <rect x='129.277' y='73' width='26.3197' height='25.0664' rx='8' fill='#B1D0FE' />
      <rect x='50' y='42' width='79' height='19' rx='9.5' fill='#B1D0FE' />
    </svg>
  );
};

export const IconViewTypeFull = () => {
  return (
    <svg width='45' height='45' viewBox='0 0 180 152' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='64' y='35' width='21' height='20' rx='8' fill='#B1D0FE' />
      <rect x='91.999' y='35' width='21' height='20' rx='8' fill='#B1D0FE' />
      <rect x='120.001' y='35' width='21' height='20' rx='8' fill='#B1D0FE' />
      <rect x='147.999' y='35' width='21' height='20' rx='8' fill='#B1D0FE' />
      <rect x='11' y='80' width='158' height='19' rx='9.5' fill='#B1D0FE' />
      {/*<rect x='11' y='111' width='112' height='19' rx='9.5' fill='#B1D0FE' />*/}
      <path d='M56 45.5C56 57.9264 45.9264 68 33.5 68C21.0736 68 11 57.9264 11 45.5C11 33.0736 21.0736 23 33.5 23C45.9264 23 56 33.0736 56 45.5Z' fill='#B1D0FE' />
      <path d='M56 45.5C56 57.9264 45.9264 68 33.5 68C21.0736 68 11 57.9264 11 45.5C11 33.0736 21.0736 23 33.5 23C45.9264 23 56 33.0736 56 45.5Z' fill='#B1D0FE' />
    </svg>
  );
};

export const IconViewTypeShort = () => {
  return (
    <svg width='45' height='45' viewBox='0 0 180 152' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M53 47.5C53 59.9264 42.9264 70 30.5 70C18.0736 70 8 59.9264 8 47.5C8 35.0736 18.0736 25 30.5 25C42.9264 25 53 35.0736 53 47.5Z' fill='#B1D0FE' />
      <path d='M53 47.5C53 59.9264 42.9264 70 30.5 70C18.0736 70 8 59.9264 8 47.5C8 35.0736 18.0736 25 30.5 25C42.9264 25 53 35.0736 53 47.5Z' fill='#B1D0FE' />
      <rect x='63' y='37' width='21' height='20' rx='8' fill='#B1D0FE' />
      <rect x='90.999' y='37' width='21' height='20' rx='8' fill='#B1D0FE' />
      <rect x='119.001' y='37' width='21' height='20' rx='8' fill='#B1D0FE' />
      <rect x='146.999' y='37' width='21' height='20' rx='8' fill='#B1D0FE' />
      <rect x='65' y='82' width='103' height='19' rx='9.5' fill='#B1D0FE' />
      {/*<rect x='65' y='113' width='80' height='19' rx='9.5' fill='#B1D0FE' />*/}
    </svg>
  );
};

export const IconAlignCenter = () => {
  return (
    <svg width='25' height='25' viewBox='0 0 100 100' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect width='25' height='25' fill='transparent' />
      <path d='M14 30H86' stroke='black' strokeWidth='5' strokeLinecap='round' />
      <path d='M22.8906 43.667H77.3771' stroke='black' strokeWidth='5' strokeLinecap='round' />
      <path d='M14 57.333H86' stroke='black' strokeWidth='5' strokeLinecap='round' />
      <path d='M22.8906 71H77.3771' stroke='black' strokeWidth='5' strokeLinecap='round' />
    </svg>
  );
};

export const IconTextPositionTop = () => {
  return (
    <svg width='25' height='25' viewBox='0 0 114 114' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M19 31L83 31' stroke='#A9ACBA' strokeWidth='5' strokeLinecap='round' />
      <path d='M19 22L94 22' stroke='#A9ACBA' strokeWidth='5' strokeLinecap='round' />
    </svg>
  );
};

export const IconTextPositionMiddle = () => {
  return (
    <svg width='25' height='25' viewBox='0 0 114 114' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M19 62L83 62' stroke='#A9ACBA' strokeWidth='5' strokeLinecap='round' />
      <path d='M19 53L94 53' stroke='#A9ACBA' strokeWidth='5' strokeLinecap='round' />
    </svg>
  );
};

export const IconTextPositionBottom = () => {
  return (
    <svg width='25' height='25' viewBox='0 0 114 114' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M19 93L83 93' stroke='#A9ACBA' strokeWidth='5' strokeLinecap='round' />
      <path d='M19 84L94 84' stroke='#A9ACBA' strokeWidth='5' strokeLinecap='round' />
    </svg>
  );
};

export const IconImageShapeRoundSVG = ({ isActive = false }) => {
  return (
    <svg width='60' height='65' viewBox='-2 0 104 100' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect width='100' height='100' rx='8' fill='#E8F1FF' stroke={isActive ? '#FFC561' : '#E8F1FF'} strokeWidth='5' />
      <rect x='11' y='33' width='78' height='34' rx='7' fill='#F6F9FE' stroke='#A9ACBA' strokeWidth='2' />
      <circle cx='29' cy='50' r='11' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
      <path d='M48 46H77' stroke='#A9ACBA' strokeWidth='5' strokeLinecap='round' />
      <path d='M48 55H69' stroke='#A9ACBA' strokeWidth='5' strokeLinecap='round' />
    </svg>
  );
};

export const IconImageShapeRegularSVG = ({ isActive = false }) => {
  return (
    <svg width='60' height='65' viewBox='-2 0 104 100' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect width='100' height='100' rx='8' fill='#F2F6FC' stroke={isActive ? '#FFC561' : '#E8F1FF'} strokeWidth='5' />
      <rect x='11' y='33' width='78' height='34' rx='7' fill='#F6F9FE' stroke='#A9ACBA' strokeWidth='2' />
      <path d='M23 46L77 46' stroke='#A9ACBA' strokeWidth='5' strokeLinecap='round' />
      <path d='M23 55L69.0013 55' stroke='#A9ACBA' strokeWidth='5' strokeLinecap='round' />
    </svg>
  );
};

export const IconImageShapePreviewSVG = ({ isActive = false }) => {
  return (
    <svg width='60' height='65' viewBox='0 0 100 100' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect width='100' height='100' rx='8' fill='#E8F1FF' stroke={isActive ? '#FFC561' : '#E8F1FF'} strokeWidth='5' />
      <rect x='11' y='20' width='78' height='62' rx='7' fill='#F6F9FE' stroke='#A9ACBA' strokeWidth='2' />
      <rect x='65' y='51' width='18' height='25' rx='3' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
      <rect x='41' y='51' width='18' height='25' rx='3' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
      <rect x='17' y='51' width='18' height='25' rx='3' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
      <rect x='17' y='29' width='13' height='13' rx='3' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
      <path d='M36 40H65' stroke='#A9ACBA' strokeWidth='5' strokeLinecap='round' />
      <path d='M36 31H78' stroke='#A9ACBA' strokeWidth='5' strokeLinecap='round' />
    </svg>
  );
};

// export const IconImageShapeRoundSVG = ({isActive = false}) => {
//   return (
//     <svg width="85" height="70" viewBox="0 0 100 70" fill="none" xmlns="http://www.w3.org/2000/svg">
//       <rect x="11" y="11" width="78" height="48" rx="7" fill="#F6F9FE" stroke={isActive ? '#17ce17': '#AFAFAF'} strokeWidth="2"/>
//       <circle cx="35" cy="35" r="17" fill="#B1D0FE" stroke="#A9ACBA" strokeWidth="2"/>
//     </svg>
// );
// }

// export const IconImageShapeSquareSVG = ({isActive = false}) => {
//   return (
//     <svg width="85" height="70" viewBox="0 0 100 70" fill="none" xmlns="http://www.w3.org/2000/svg">
//       <rect x="11" y="11" width="78" height="48" rx="7" fill="#F6F9FE" stroke={isActive ? '#17ce17': '#AFAFAF'} strokeWidth="2"/>
//       <rect x="19" y="19" width="32" height="32" rx="3" fill="#B1D0FE" stroke="#A9ACBA" strokeWidth="2"/>
//     </svg>
// );
// }

export const IconImageShapeSquareSVG = ({ isActive = false }) => {
  return (
    <svg width='60' height='65' viewBox='-2 0 104 100' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect width='100' height='100' rx='8' fill='#E8F1FF' stroke={isActive ? '#FFC561' : '#E8F1FF'} strokeWidth='5' />
      <rect x='11' y='33' width='78' height='34' rx='7' fill='#F6F9FE' stroke='#A9ACBA' strokeWidth='2' />
      <rect x='18' y='40' width='20' height='20' rx='3' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
      <path d='M47 55H69' stroke='#A9ACBA' strokeWidth='5' strokeLinecap='round' />
      <path d='M47 46H77' stroke='#A9ACBA' strokeWidth='5' strokeLinecap='round' />
    </svg>
  );
};

// export const IconImageShapeFullSVG = ({isActive = false}) => {
//   return (
//     <svg width="85" height="70" viewBox="0 0 100 70" fill="none" xmlns="http://www.w3.org/2000/svg">
//       <rect x="11" y="11" width="78" height="48" rx="7" fill="#F6F9FE" stroke={isActive ? '#17ce17': '#AFAFAF'} strokeWidth="2"/>
//       <path d="M18 11H40C41.6569 11 43 12.3431 43 14V56C43 57.6569 41.6569 59 40 59H18C14.134 59 11 55.866 11 52V18C11 14.134 14.134 11 18 11Z" fill="#B1D0FE" stroke={isActive ? '#17ce17': '#AFAFAF'} strokeWidth="2"/>
//     </svg>
// );
// }

export const IconImageShapeFullSVG = ({ isActive = false }) => {
  return (
    <svg width='60' height='65' viewBox='-2 0 104 100' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect width='100' height='100' rx='8' fill='#E8F1FF' stroke={isActive ? '#FFC561' : '#E8F1FF'} strokeWidth='5' />
      <rect x='11' y='33' width='78' height='34' rx='7' fill='#F6F9FE' stroke='#A9ACBA' strokeWidth='2' />
      <path
        d='M18 33H39C40.6569 33 42 34.3431 42 36V64C42 65.6569 40.6569 67 39 67H18C14.134 67 11 63.866 11 60V40C11 36.134 14.134 33 18 33Z'
        fill='#B1D0FE'
        stroke='#A9ACBA'
        strokeWidth='2'
      />
      <path d='M51 55H70' stroke='#A9ACBA' strokeWidth='5' strokeLinecap='round' />
      <path d='M51 46H78' stroke='#A9ACBA' strokeWidth='5' strokeLinecap='round' />
    </svg>
  );
};

// export const IconImageShapeCoverSVG = ({isActive = false}) => {
//   return (
//     <svg width="85" height="70" viewBox="0 0 100 70" fill="none" xmlns="http://www.w3.org/2000/svg">
//       <rect x="11" y="11" width="78" height="48" rx="7" fill="#B1D0FE" stroke={isActive ? '#17ce17': '#AFAFAF'} strokeWidth="2"/>
//     </svg>
// );
// }

export const IconImageShapeCoverSVG = ({ isActive = false }) => {
  return (
    <svg width='60' height='65' viewBox='-2 0 104 100' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect width='100' height='100' rx='8' fill='#E8F1FF' stroke={isActive ? '#FFC561' : '#E8F1FF'} strokeWidth='5' />
      <rect x='11' y='33' width='78' height='34' rx='7' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
      <path d='M22 55H78' stroke='#9799A6' strokeWidth='5' strokeLinecap='round' />
      <path d='M22 46H78' stroke='#9799A6' strokeWidth='5' strokeLinecap='round' />
    </svg>
  );
};

// export const IconImageShapeCardSVG = ({isActive = false}) => {
//   return (
//     <svg width="85" height="70" viewBox="0 0 100 70" fill="none" xmlns="http://www.w3.org/2000/svg">
//       <rect x="11" y="11" width="78" height="48" rx="7" fill="#F6F9FE" stroke={isActive ? '#17ce17': '#AFAFAF'} strokeWidth="2"/>
//       <path d="M18 11H82C85.866 11 89 14.134 89 18V42H11V18C11 14.134 14.134 11 18 11Z" fill="#B1D0FE" stroke={isActive ? '#17ce17': '#AFAFAF'} strokeWidth="2"/>
//     </svg>
// );
// }

export const IconImageShapeCardSVG = ({ isActive = false }) => {
  return (
    <svg width='60' height='65' viewBox='-2 0 104 100' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect width='100' height='100' rx='8' fill='#E8F1FF' stroke={isActive ? '#FFC561' : '#E8F1FF'} strokeWidth='5' />
      <rect x='11' y='34' width='78' height='48' rx='7' fill='#F6F9FE' stroke='#A9ACBA' strokeWidth='2' />
      <path d='M18 19H82C85.866 19 89 22.134 89 26V57H11V26C11 22.134 14.134 19 18 19Z' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
      <path d='M22 74H78' stroke='#A9ACBA' strokeWidth='5' strokeLinecap='round' />
      <path d='M22 65H78' stroke='#A9ACBA' strokeWidth='5' strokeLinecap='round' />
    </svg>
  );
};

export const IconRightArrowAngleSVG = ({ color = 'black', size = 20 }) => {
  return (
    <svg width={size} height={size} viewBox='0 0 100 100' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M32 13L69 50L32 87' stroke={color} strokeWidth='5' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
};

export const IconRightArrowLineSVG = ({ color = 'black', width = 24, height = 24 }) => {
  return (
    <svg width={width} height={height} viewBox='0 0 100 100' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M13 50H87' stroke={color} strokeWidth='5' strokeLinecap='round' />
      <path d='M70 31L88 50L70 69' stroke={color} strokeWidth='5' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
};

export const IconLeftArrowLineSVG = ({ color = 'black', width = 24, height = 24 }) => {
  return (
    <svg width={width} height={height} viewBox='0 0 100 100' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M87 50H13' stroke={color} strokeWidth='5' strokeLinecap='round' />
      <path d='M30 31L12 50L30 69' stroke={color} strokeWidth='5' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
};

export const IconRightArrowShareSVG = ({ color = 'black', size = 22 }) => {
  return (
    <svg width={size} height={size} viewBox='0 0 100 100' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M82 49.002V79.002C82 83.4202 78.4183 87.002 74 87.002H21C16.5817 87.002 13 83.4202 13 79.002V26.002C13 21.5837 16.5817 18.002 21 18.002H51.8081'
        stroke={color}
        strokeWidth='5'
        strokeLinecap='round'
      />
      <path d='M87.2627 13.2626L43.5 57.0254' stroke={color} strokeWidth='5' strokeLinecap='round' />
      <path d='M88.1016 32.5059L87.2648 13.2606L68.0195 12.4238' stroke={color} strokeWidth='5' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
};

export const IconDownloadCtaSVG = ({ color = 'black', size = 22 }) => {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M12.5535 16.5061C12.4114 16.6615 12.2106 16.75 12 16.75C11.7894 16.75 11.5886 16.6615 11.4465 16.5061L7.44648 12.1311C7.16698 11.8254 7.18822 11.351 7.49392 11.0715C7.79963 10.792 8.27402 10.8132 8.55352 11.1189L11.25 14.0682V3C11.25 2.58579 11.5858 2.25 12 2.25C12.4142 2.25 12.75 2.58579 12.75 3V14.0682L15.4465 11.1189C15.726 10.8132 16.2004 10.792 16.5061 11.0715C16.8118 11.351 16.833 11.8254 16.5535 12.1311L12.5535 16.5061Z'
        fill={color}
      />
      <path
        d='M3.75 15C3.75 14.5858 3.41422 14.25 3 14.25C2.58579 14.25 2.25 14.5858 2.25 15V15.0549C2.24998 16.4225 2.24996 17.5248 2.36652 18.3918C2.48754 19.2919 2.74643 20.0497 3.34835 20.6516C3.95027 21.2536 4.70814 21.5125 5.60825 21.6335C6.47522 21.75 7.57754 21.75 8.94513 21.75H15.0549C16.4225 21.75 17.5248 21.75 18.3918 21.6335C19.2919 21.5125 20.0497 21.2536 20.6517 20.6516C21.2536 20.0497 21.5125 19.2919 21.6335 18.3918C21.75 17.5248 21.75 16.4225 21.75 15.0549V15C21.75 14.5858 21.4142 14.25 21 14.25C20.5858 14.25 20.25 14.5858 20.25 15C20.25 16.4354 20.2484 17.4365 20.1469 18.1919C20.0482 18.9257 19.8678 19.3142 19.591 19.591C19.3142 19.8678 18.9257 20.0482 18.1919 20.1469C17.4365 20.2484 16.4354 20.25 15 20.25H9C7.56459 20.25 6.56347 20.2484 5.80812 20.1469C5.07435 20.0482 4.68577 19.8678 4.40901 19.591C4.13225 19.3142 3.9518 18.9257 3.85315 18.1919C3.75159 17.4365 3.75 16.4354 3.75 15Z'
        fill={color}
      />
    </svg>
  );
};

export const IconHeartSVG = () => {
  return (
    <svg width='30' height='30' viewBox='0 0 100 100' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M81.2939 23.6581C79.4858 21.8643 77.3389 20.4413 74.976 19.4705C72.6131 18.4997 70.0805 18 67.5228 18C64.9651 18 62.4324 18.4997 60.0695 19.4705C57.7066 20.4413 55.5598 21.8643 53.7516 23.6581L49.9991 27.379L46.2465 23.6581C42.5942 20.0365 37.6405 18.0019 32.4754 18.0019C27.3102 18.0019 22.3565 20.0365 18.7042 23.6581C15.0519 27.2797 13 32.1916 13 37.3133C13 42.435 15.0519 47.347 18.7042 50.9686L22.4567 54.6895L49.9991 82L77.5414 54.6895L81.2939 50.9686C83.1029 49.1756 84.5379 47.0468 85.517 44.7038C86.4961 42.3608 87 39.8495 87 37.3133C87 34.7771 86.4961 32.2658 85.517 29.9228C84.5379 27.5798 83.1029 25.451 81.2939 23.6581V23.6581Z'
        stroke='black'
        strokeWidth='5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export const IconCartOutlineSVG = () => {
  return (
    <svg width='30' height='30' viewBox='0 0 100 100' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M19.8776 42.0091C20.0264 40.1547 20.8683 38.4244 22.2355 37.1628C23.6027 35.9012 25.395 35.2008 27.2554 35.2012H71.8698C73.7301 35.2008 75.5224 35.9012 76.8896 37.1628C78.2568 38.4244 79.0987 40.1547 79.2475 42.0091L82.2186 79.009C82.3003 80.0272 82.1704 81.0513 81.8369 82.0168C81.5034 82.9823 80.9736 83.8683 80.2809 84.619C79.5883 85.3698 78.7476 85.969 77.812 86.3789C76.8764 86.7888 75.866 87.0006 74.8446 87.0009H24.2806C23.2591 87.0006 22.2488 86.7888 21.3131 86.3789C20.3775 85.969 19.5369 85.3698 18.8442 84.619C18.1515 83.8683 17.6217 82.9823 17.2883 82.0168C16.9548 81.0513 16.8248 80.0272 16.9065 79.009L19.8776 42.0091V42.0091Z'
        stroke='black'
        strokeWidth='5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M64.3577 46.2998V27.7999C64.3577 23.8747 62.7984 20.1103 60.0229 17.3348C57.2473 14.5593 53.4829 13 49.5577 13C45.6326 13 41.8681 14.5593 39.0926 17.3348C36.3171 20.1103 34.7578 23.8747 34.7578 27.7999V46.2998'
        stroke='black'
        strokeWidth='5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export const IconCartButtonSVG = () => {
  return (
    <svg width='30' height='30' viewBox='0 0 100 100' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M56 58H17C16.4477 58 16 57.5523 16 57V32C16 31.4477 16.4477 31 17 31H83C83.5523 31 84 31.4477 84 32V57C84 57.5523 83.5523 58 83 58H66L71.5 63H83C86.3137 63 89 60.3137 89 57V32C89 28.6863 86.3137 26 83 26H17C13.6863 26 11 28.6863 11 32V57C11 60.3137 13.6863 63 17 63H56V58Z'
        fill='black'
      />
      <path
        d='M75.9981 73.7134H70.0309L73.1714 80.6193C73.3902 81.0981 73.1402 81.6349 72.6402 81.838L69.8746 82.9261C69.3591 83.1292 68.781 82.8971 68.5622 82.4328L65.578 75.8751L60.7031 80.4017C60.0535 81.0048 59 80.5398 59 79.7488V57.9292C59 57.0964 60.1206 56.6904 60.7031 57.2764L76.7013 72.132C77.3466 72.6997 76.8704 73.7134 75.9981 73.7134V73.7134Z'
        fill='black'
      />
      <path
        d='M32.6531 51H29.5224L34.2926 37.1818H38.0575L42.821 51H39.6903L36.229 40.3395H36.1211L32.6531 51ZM32.4574 45.5685H39.8523V47.8491H32.4574V45.5685ZM49.3826 51H44.4842V37.1818H49.4231C50.813 37.1818 52.0095 37.4585 53.0126 38.0117C54.0157 38.5605 54.7871 39.3499 55.3269 40.38C55.8712 41.41 56.1433 42.6425 56.1433 44.0774C56.1433 45.5168 55.8712 46.7538 55.3269 47.7884C54.7871 48.8229 54.0112 49.6168 52.9991 50.1701C51.9915 50.7234 50.786 51 49.3826 51ZM47.4057 48.4968H49.2612C50.1248 48.4968 50.8513 48.3439 51.4405 48.038C52.0343 47.7276 52.4796 47.2486 52.7765 46.6009C53.0778 45.9486 53.2285 45.1075 53.2285 44.0774C53.2285 43.0563 53.0778 42.2219 52.7765 41.5742C52.4796 40.9265 52.0365 40.4497 51.4473 40.1438C50.858 39.8379 50.1316 39.685 49.2679 39.685H47.4057V48.4968ZM63.2059 51H58.3074V37.1818H63.2464C64.6363 37.1818 65.8328 37.4585 66.8358 38.0117C67.8389 38.5605 68.6104 39.3499 69.1501 40.38C69.6944 41.41 69.9665 42.6425 69.9665 44.0774C69.9665 45.5168 69.6944 46.7538 69.1501 47.7884C68.6104 48.8229 67.8344 49.6168 66.8224 50.1701C65.8148 50.7234 64.6093 51 63.2059 51ZM61.229 48.4968H63.0844C63.9481 48.4968 64.6745 48.3439 65.2638 48.038C65.8575 47.7276 66.3028 47.2486 66.5997 46.6009C66.9011 45.9486 67.0518 45.1075 67.0518 44.0774C67.0518 43.0563 66.9011 42.2219 66.5997 41.5742C66.3028 40.9265 65.8598 40.4497 65.2705 40.1438C64.6813 39.8379 63.9548 39.685 63.0912 39.685H61.229V48.4968Z'
        fill='black'
      />
    </svg>
  );
};

export const IconCartAvailableSVG = () => {
  return (
    <svg width='30' height='30' fill='#000000' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 50 50'>
      <path d='M 25 2 C 12.309534 2 2 12.309534 2 25 C 2 37.690466 12.309534 48 25 48 C 37.690466 48 48 37.690466 48 25 C 48 12.309534 37.690466 2 25 2 z M 25 4 C 36.609534 4 46 13.390466 46 25 C 46 36.609534 36.609534 46 25 46 C 13.390466 46 4 36.609534 4 25 C 4 13.390466 13.390466 4 25 4 z M 34.988281 14.988281 A 1.0001 1.0001 0 0 0 34.171875 15.439453 L 23.970703 30.476562 L 16.679688 23.710938 A 1.0001 1.0001 0 1 0 15.320312 25.177734 L 24.316406 33.525391 L 35.828125 16.560547 A 1.0001 1.0001 0 0 0 34.988281 14.988281 z' />
    </svg>
  );
};

export const IconCartCategoriesSVG = () => {
  return (
    <svg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' x='0px' y='0px' viewBox='0 0 40 40' enableBackground='new 0 0 40 40' fill='#000000'>
      <g>
        <path
          d='M20,21.569c-0.095,0-0.189-0.021-0.282-0.062L5.434,15.115C5.165,14.995,4.994,14.72,5,14.413
        c0.006-0.303,0.191-0.578,0.46-0.683l14.286-5.681C19.828,8.017,19.913,8,20,8c0.086,0,0.172,0.017,0.254,0.049l14.285,5.679
        c0.275,0.11,0.455,0.378,0.461,0.683c0.008,0.308-0.163,0.584-0.434,0.704L20.281,21.51C20.192,21.549,20.096,21.569,20,21.569
        L20,21.569z M7.626,14.468l12.339,5.522l12.409-5.522L20,9.549L7.626,14.468z'
        />
        <path
          d='M5.434,20.49c-0.361-0.163-0.53-0.604-0.376-0.983c0.113-0.275,0.372-0.454,0.659-0.454c0.097,0,0.191,0.021,0.282,0.062
        l13.967,6.249l14.037-6.249c0.092-0.042,0.186-0.062,0.283-0.062c0.286,0,0.544,0.177,0.656,0.454
        c0.155,0.379-0.014,0.82-0.376,0.983L20,27.008L5.434,20.49z'
        />
        <path
          d='M5.434,25.48c-0.362-0.164-0.531-0.604-0.376-0.981c0.113-0.275,0.372-0.454,0.659-0.454c0.097,0,0.191,0.021,0.282,0.061
        l13.967,6.25l14.037-6.25c0.09-0.039,0.186-0.061,0.283-0.061c0.286,0,0.544,0.179,0.656,0.454
        c0.155,0.378-0.014,0.819-0.375,0.981L20,32L5.434,25.48z'
        />
      </g>
    </svg>
  );
};

export const IconCartSortSVG = () => {
  return (
    <svg width='30' height='30' viewBox='0 0 100 100' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M41 32.9999H83' stroke='black' strokeWidth='5' strokeLinecap='round' />
      <path d='M41 46.9999H71' stroke='black' strokeWidth='5' strokeLinecap='round' />
      <path d='M41 60.9999H61' stroke='black' strokeWidth='5' strokeLinecap='round' />
      <path d='M23 70V26' stroke='black' strokeWidth='5' strokeLinecap='round' />
      <path d='M17 67.9999L23 73.9999L29 67.9999' stroke='black' strokeWidth='5' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
};

export const IconCartSeacrhSVG = ({ isProducts }) => {
  return (
    <svg width='30' height='30' viewBox='0 0 100 100' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='45.6007' cy='45.6007' r='27.1007' stroke={isProducts ? '#89919c' : 'black'} strokeWidth='5' />
      <path d='M65.457 65.4572L83.3098 83.31' stroke={isProducts ? '#89919c' : 'black'} strokeWidth='5' strokeLinecap='round' />
    </svg>
  );
};

export const IconSimilarProductSVG = () => {
  return (
    <svg width='30' height='30' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M3 7L6 4H9C9 4.39397 9.0776 4.78407 9.22836 5.14805C9.37913 5.51203 9.6001 5.84274 9.87868 6.12132C10.1573 6.3999 10.488 6.62087 10.8519 6.77164C11.2159 6.9224 11.606 7 12 7C12.394 7 12.7841 6.9224 13.1481 6.77164C13.512 6.62087 13.8427 6.3999 14.1213 6.12132C14.3999 5.84274 14.6209 5.51203 14.7716 5.14805C14.9224 4.78407 15 4.39397 15 4H18L21 7L20.5785 11.2152C20.542 11.5801 20.1382 11.7829 19.8237 11.5942L18 10.5V18C18 19.1046 17.1046 20 16 20H8C6.89543 20 6 19.1046 6 18V10.5L4.17629 11.5942C3.86184 11.7829 3.45801 11.5801 3.42152 11.2152L3 7Z'
        stroke='#000000'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export const IconShopListSVG = ({ isActive = false }) => {
  return (
    <svg width='21' height='21' viewBox='0 0 100 100' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='10' y='10' width='80' height='22' rx='2' fill={isActive ? '#b2ccfd' : '#AFAFAF'} />
      <rect x='10' y='39' width='80' height='22' rx='2' fill={isActive ? '#b2ccfd' : '#AFAFAF'} />
      <rect x='10' y='68' width='80' height='22' rx='2' fill={isActive ? '#b2ccfd' : '#AFAFAF'} />
    </svg>
  );
};

export const IconShopBlocksSVG = ({ isActive = false }) => {
  return (
    <svg width='21' height='21' viewBox='0 0 100 100' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='10' y='10' width='36' height='36' rx='2' fill={isActive ? '#b2ccfd' : '#AFAFAF'} />
      <rect x='10' y='54' width='36' height='36' rx='2' fill={isActive ? '#b2ccfd' : '#AFAFAF'} />
      <rect x='54' y='54' width='36' height='36' rx='2' fill={isActive ? '#b2ccfd' : '#AFAFAF'} />
      <rect x='54' y='10' width='36' height='36' rx='2' fill={isActive ? '#b2ccfd' : '#AFAFAF'} />
    </svg>
  );
};

export const IconContactMessengerSVG = () => {
  return (
    <svg width='25' height='25' viewBox='0 0 1080 1080' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M277 611.5L485 461L605.5 551.5L786.5 402' stroke='black' strokeWidth='25' />
      <path
        d='M418.132 885.506C414.988 884.627 411.625 885.012 408.762 886.58L278.489 957.905V824.108C278.489 820.189 276.651 816.497 273.524 814.134C177.524 741.605 116.5 630.985 116.5 507.308C116.5 290.027 305.286 112.5 539.978 112.5C774.715 112.5 963.5 290.028 963.5 507.308C963.5 724.545 774.714 902.116 539.978 902.116C497.612 902.116 456.684 896.29 418.132 885.506Z'
        stroke='black'
        strokeWidth='25'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export const IconContactWhatsAppSVG = () => {
  return (
    <svg width='25' height='25' viewBox='0 0 1080 1080' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M967.5 540C967.5 776.327 781.879 967.5 546 967.5C407.44 967.5 302.077 886.846 294.688 881.04C289.82 877.214 284 877.696 280.112 879.736L115.84 965.898C115.293 966.185 115.036 966.139 114.932 966.121C114.731 966.084 114.406 965.951 114.087 965.635C113.768 965.318 113.632 964.995 113.594 964.794C113.574 964.691 113.527 964.434 113.809 963.884L198.796 798.341C200.862 794.316 201.312 788.031 196.785 783.091L187.569 791.536L196.785 783.091C191.218 777.016 112.5 688.328 112.5 534C112.5 298.121 303.673 112.5 540 112.5C776.102 112.5 967.5 303.898 967.5 540Z'
        stroke='black'
        strokeWidth='25'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M460.412 395.816L467.348 454.703C468.938 468.203 462.997 481.488 451.875 489.304L403.381 523.38L380.721 539L385.501 566.5L466.248 509.758C484.885 496.662 494.84 474.401 492.176 451.779L485.241 392.891C478.255 333.58 411.178 302.476 361.394 335.464C352.65 341.257 348.162 351.675 349.958 362.01L374 360C374 359.5 374.5 357 375.203 356.304C409.455 333.608 455.606 355.008 460.412 395.816Z'
        fill='black'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M684.609 621.333L625.792 613.825C612.307 612.104 598.965 617.916 591.042 628.961L556.496 677.121L540.001 699.508L513.204 694.581L570.728 614.39C584.005 595.881 606.362 586.142 628.957 589.027L687.774 596.534C747.014 604.096 777.465 671.472 743.995 720.933C741.092 725.224 737.07 728.465 732.501 730.419C727.818 732.421 722.56 733.07 717.339 732.11L719.281 710L719.501 707.5L721.86 707.522C722.501 707.5 722.975 707.389 723.29 706.922C723.943 705.958 724.56 704.983 725.143 704C745.114 670.297 724.212 626.388 684.609 621.333Z'
        fill='black'
      />
      <path d='M713.176 731.345L717.339 732.11C722.56 733.07 727.818 732.421 732.501 730.419C727.301 733.154 711.001 734.279 703.501 734.5L713.176 731.345Z' fill='black' />
      <path
        d='M723.29 706.922C722.975 707.389 722.501 707.5 721.86 707.522L719.501 707.5L718.753 707.361C721.334 706.621 723.9 705.523 725.143 704C724.56 704.983 723.943 705.958 723.29 706.922Z'
        fill='black'
      />
      <path d='M719.501 707.5L719.281 710L713 708.5C714.412 708.348 716.588 707.981 718.753 707.361L719.501 707.5Z' fill='black' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M382.396 498.239C396.767 545.893 422.769 589.222 458.059 624.322C493.348 659.422 536.817 685.19 584.547 699.305C628.508 712.305 674.812 715.042 719.904 707.375L724.095 732.022C675.245 740.327 625.082 737.362 577.458 723.279C525.75 707.988 478.659 680.072 440.429 642.047C402.198 604.022 374.029 557.082 358.461 505.457C343.447 455.674 340.606 403.042 350.138 351.982L374.713 356.57C365.915 403.702 368.537 452.285 382.396 498.239Z'
        fill='black'
      />
    </svg>
  );
};

export const IconContactTelegramSVG = () => {
  return (
    <svg width='25' height='25' viewBox='0 0 1080 1080' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M967 174L113 479.416L357.001 601.583L722.999 357.25L478.999 662.666L845 907L967 174Z' stroke='black' strokeWidth='25' strokeLinejoin='round' />
    </svg>
  );
};

export const IconContactTwitterSVG = () => {
  return (
    <svg width='25' height='25' viewBox='0 0 1080 1080' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M968 191.391C930.784 217.667 889.577 237.764 845.968 250.907C822.562 223.97 791.455 204.877 756.855 196.212C722.255 187.546 685.83 189.726 652.508 202.456C619.186 215.186 590.574 237.853 570.541 267.39C550.508 296.927 540.022 331.909 540.5 367.606V406.505C472.202 408.278 404.527 393.117 343.501 362.372C282.474 331.627 229.992 286.253 190.727 230.291C190.727 230.291 35.2727 580.386 385.045 735.984C305.007 790.364 209.66 817.631 113 813.783C462.773 1008.28 890.273 813.783 890.273 366.439C890.237 355.604 889.196 344.795 887.164 334.152C926.828 295 954.819 245.567 968 191.391Z'
        stroke='black'
        strokeWidth='25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export const IconLocationSVG = ({ color = '#000' }) => {
  return (
    <svg fill={color} version='1.1' id='Capa_1' xmlns='http://www.w3.org/2000/svg' width='25' height='25' x='25px' y='25px' viewBox='0 0 368.16 368.16'>
      <path
        d='M184.08,0c-74.992,0-136,61.008-136,136c0,24.688,11.072,51.24,11.536,52.36c3.576,8.488,10.632,21.672,15.72,29.4
				l93.248,141.288c3.816,5.792,9.464,9.112,15.496,9.112s11.68-3.32,15.496-9.104l93.256-141.296
				c5.096-7.728,12.144-20.912,15.72-29.4c0.464-1.112,11.528-27.664,11.528-52.36C320.08,61.008,259.072,0,184.08,0z
				 M293.8,182.152c-3.192,7.608-9.76,19.872-14.328,26.8l-93.256,141.296c-1.84,2.792-2.424,2.792-4.264,0L88.696,208.952
				c-4.568-6.928-11.136-19.2-14.328-26.808C74.232,181.816,64.08,157.376,64.08,136c0-66.168,53.832-120,120-120
				c66.168,0,120,53.832,120,120C304.08,157.408,293.904,181.912,293.8,182.152z'
      />
      <path
        d='M184.08,64.008c-39.704,0-72,32.304-72,72c0,39.696,32.296,72,72,72c39.704,0,72-32.304,72-72
				C256.08,96.312,223.784,64.008,184.08,64.008z M184.08,192.008c-30.872,0-56-25.12-56-56s25.128-56,56-56s56,25.12,56,56
				S214.952,192.008,184.08,192.008z'
      />
    </svg>
  );
};

export const IconLinkTypeSVG = ({ size = '25', color }) => {
  return (
    <svg width={size} height={size} viewBox='0 0 100 100' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M56.3468 43.6532C52.9795 40.2873 48.4133 38.3965 43.6523 38.3965C38.8912 38.3965 34.325 40.2873 30.9577 43.6532L18.2591 56.3477C14.8918 59.7151 13 64.2822 13 69.0443C13 73.8064 14.8918 78.3735 18.2591 81.7409C21.6264 85.1082 26.1935 87 30.9557 87C35.7178 87 40.2849 85.1082 43.6523 81.7409L49.9995 75.3936'
        stroke={color}
        strokeWidth='5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M43.6562 56.3468C47.0235 59.7127 51.5897 61.6035 56.3508 61.6035C61.1118 61.6035 65.678 59.7127 69.0453 56.3468L81.7439 43.6523C85.1113 40.2849 87.003 35.7178 87.003 30.9557C87.003 26.1935 85.1113 21.6264 81.7439 18.2591C78.3766 14.8918 73.8095 13 69.0474 13C64.2852 13 59.7181 14.8918 56.3508 18.2591L50.0035 24.6064'
        stroke={color}
        strokeWidth='5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export const IconContactInstagramSVG = () => {
  return (
    <svg width='25' height='25' viewBox='0 0 100 100' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M68.5 13H31.5C21.2827 13 13 21.2827 13 31.5V68.5C13 78.7173 21.2827 87 31.5 87H68.5C78.7173 87 87 78.7173 87 68.5V31.5C87 21.2827 78.7173 13 68.5 13Z'
        stroke='black'
        strokeWidth='5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M64.7954 47.6701C65.252 50.7494 64.7261 53.8943 63.2923 56.6575C61.8586 59.4206 59.59 61.6613 56.8094 63.0609C54.0288 64.4605 50.8777 64.9476 47.8042 64.4531C44.7308 63.9585 41.8915 62.5074 39.6903 60.3062C37.4891 58.105 36.038 55.2658 35.5435 52.1923C35.0489 49.1189 35.536 45.9677 36.9356 43.1871C38.3352 40.4065 40.5759 38.138 43.339 36.7042C46.1022 35.2705 49.2471 34.7445 52.3264 35.2011C55.4674 35.6669 58.3753 37.1305 60.6207 39.3758C62.866 41.6212 64.3296 44.5291 64.7954 47.6701Z'
        stroke='black'
        strokeWidth='5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M70.3516 29.6504H70.3886' stroke='black' strokeWidth='5' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
};

export const IconSkypeTypeSVG = ({ color }) => {
  return (
    <svg width='25' height='25' viewBox='0 0 100 100' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M84.3911 56.1813C84.7704 54.0946 84.9739 51.9615 84.9739 49.8284C84.9739 45.0985 84.0488 40.5077 82.2263 36.1951C80.4686 32.0217 77.9431 28.2748 74.7329 25.0566C71.5496 21.8572 67.776 19.3089 63.6223 17.5537C59.3113 15.7267 54.7412 14.7992 50.0231 14.7992C47.8029 14.7992 45.5733 15.0125 43.4086 15.4299C40.4132 13.8386 37.0756 13.0045 33.6856 13C28.1627 13 22.9635 15.1609 19.0596 19.0747C17.1331 20.996 15.6057 23.2812 14.5656 25.7979C13.5256 28.3147 12.9934 31.0132 13.0001 33.7374C13.0001 37.2617 13.9067 40.7303 15.5996 43.7908C15.2573 45.7755 15.0723 47.8066 15.0723 49.8284C15.0723 54.5583 15.9974 59.1491 17.8199 63.4617C19.5776 67.6352 22.0939 71.382 25.3041 74.6002C28.5142 77.8184 32.2517 80.341 36.4147 82.1031C40.7257 83.9302 45.2958 84.8576 50.0139 84.8576C52.0676 84.8576 54.1214 84.6721 56.1381 84.3104C59.2373 86.0633 62.7342 87 66.3144 87C71.8373 87 77.0365 84.8483 80.9404 80.9253C84.8537 77.0115 86.9999 71.7993 86.9999 66.2626C87.0092 62.7383 86.1026 59.2604 84.3911 56.1813Z'
        stroke={color}
        strokeWidth='5'
      />
      <path
        d='M32.1953 60.5867C32.1953 65.1682 37.746 71.2893 50.161 71.2893C61.9747 71.2893 67.8307 65.5763 67.8307 57.9435C67.8307 53.0095 65.5642 47.7695 56.6091 45.7663L48.4311 43.9485C45.3227 43.2344 41.7425 42.2977 41.7425 39.3577C41.7425 36.4177 44.2495 34.3588 48.7826 34.3588C57.9135 34.3588 57.0809 40.6468 61.6139 40.6468C64.0007 40.6468 66.0915 39.2464 66.0915 36.8258C66.0915 31.187 57.0809 26.9486 49.4394 26.9486C41.1412 26.9486 32.3063 30.4821 32.3063 39.8863C32.3063 44.4122 33.9253 49.2349 42.8156 51.47L53.8615 54.2337C57.2104 55.0591 58.043 56.9511 58.043 58.6483C58.043 61.477 55.2399 64.2408 50.161 64.2408C40.2531 64.2408 41.6222 56.5894 36.3121 56.5894C33.9253 56.5894 32.1953 58.231 32.1953 60.5867Z'
        fill={color}
      />
    </svg>
  );
};

export const IconViberTypeSVG = ({ color }) => {
  return (
    <svg width='25' height='25' viewBox='0 0 100 100' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M36.7998 15.1124C41.3916 14.7536 46.0438 14.5 50 14.5C53.9562 14.5 58.6084 14.7536 63.2002 15.1124C74.3558 15.9841 83.2247 24.6673 84.0838 35.7558C84.3362 39.0128 84.5 42.2082 84.5 45C84.5 47.7918 84.3362 50.9872 84.0838 54.2442C83.2247 65.3327 74.3558 74.0159 63.2002 74.8876C58.6084 75.2464 53.9562 75.5 50 75.5C48.2806 75.5 46.4268 75.4521 44.5 75.3681L42.7251 77.1639L42.5605 80.2802C45.1468 80.4168 47.6744 80.5 50 80.5C54.1417 80.5 58.939 80.2358 63.5897 79.8724C77.1327 78.8142 88.0143 68.2418 89.0689 54.6304C89.3267 51.303 89.5 47.9682 89.5 45C89.5 42.0318 89.3267 38.697 89.0689 35.3696C88.0143 21.7582 77.1327 11.1858 63.5897 10.1276C58.939 9.76415 54.1417 9.5 50 9.5C45.8583 9.5 41.061 9.76415 36.4103 10.1276C22.8673 11.1858 11.9857 21.7582 10.9311 35.3696C10.6733 38.697 10.5 42.0318 10.5 45C10.5 49.3491 10.8724 54.5018 11.3425 59.2881C12.4043 70.0999 20.9934 78.4804 31.7701 79.4757L32.2299 74.4969C23.7992 73.7182 17.1421 67.1844 16.3185 58.7994C15.8544 54.0737 15.5 49.1084 15.5 45C15.5 42.2082 15.6638 39.0128 15.9162 35.7558C16.7753 24.6673 25.6442 15.9841 36.7998 15.1124Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M30.5 87.5858V74.5H32H32.5C33.0523 74.5 33.5 74.9477 33.5 75.5V86.3787L43.9393 75.9393L46.0607 78.0607L34.7678 89.3536C33.1929 90.9285 30.5 89.813 30.5 87.5858Z'
        fill={color}
      />
      <path
        d='M48.0916 23.008C46.4682 23.008 46.4682 25.2391 48.0916 25.2391C60.1049 25.2391 70.4948 33.2072 70.4948 48.1873C70.4948 49.7809 72.7676 49.7809 72.7676 48.1873C72.7676 31.9323 61.7283 22.6893 48.0916 23.008ZM35.2244 25.9562C34.4887 25.8696 33.7477 26.0686 33.1594 26.5108C29.9125 28.1044 26.6625 31.298 27.6365 34.804C27.6365 34.804 28.2859 37.6693 31.8574 43.7251C33.8055 46.5936 35.4289 49.1434 37.0523 51.0558C38.6758 53.2869 41.2732 55.8367 43.8707 57.749C49.0657 61.8924 57.1827 66.0359 60.7543 66.992C64.0011 67.9482 67.5726 64.761 69.1961 61.5737C69.8454 60.2988 69.5207 58.7052 68.222 57.749C66.2739 55.8367 63.0271 53.6056 60.7543 52.3307C59.1309 51.3745 57.1828 52.012 56.5334 52.9681L54.91 54.8805C54.2606 55.8367 52.6372 55.8367 52.6372 55.8367C41.9226 52.9681 39.0004 42.1315 39.0004 42.1315C39.0004 42.1315 39.0004 40.8566 39.9745 39.9004L41.9226 38.3068C42.8967 37.6693 43.546 35.757 42.572 34.1634C41.9226 33.2072 40.9485 31.2948 39.9745 30.3387C39.0004 29.0638 37.0523 26.8327 37.0523 26.8327C36.5597 26.3485 35.9163 26.0399 35.2244 25.9562ZM50.3644 29.3825C48.741 29.0638 48.4163 31.6136 50.0397 31.6136C59.1309 32.251 64.3258 38.3068 64.0011 45.9562C63.6764 47.5498 66.2739 47.5498 66.2739 45.9562C66.5986 37.0319 60.7543 29.7012 50.3644 29.3825ZM51.3384 35.4383C49.715 35.1195 49.715 37.6693 51.3384 37.6693C55.2346 37.6693 57.1828 39.9004 57.1828 43.7251C57.5074 45.3187 59.7802 45.3187 59.7802 43.7251C59.4555 38.6255 56.5334 35.4383 51.3384 35.4383Z'
        fill={color}
      />
    </svg>
  );
};

export const IconEmailTypeSVG = ({ color }) => {
  return (
    <svg width='25' height='25' viewBox='0 0 100 100' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M87 26.0005L54.2325 52.035C52.0471 53.7713 48.9529 53.7713 46.7676 52.035L14 26.0005' stroke={color} strokeWidth='5' strokeLinecap='round' />
      <path
        d='M84 76.8286H16C14.067 76.8286 12.5 75.2616 12.5 73.3286V25.3286C12.5 23.3956 14.067 21.8286 16 21.8286H84C85.933 21.8286 87.5 23.3956 87.5 25.3286V73.3286C87.5 75.2616 85.933 76.8286 84 76.8286Z'
        stroke={color}
        strokeWidth='5'
      />
    </svg>
  );
};

export const IconPhoneTypeSVG = ({ color }) => {
  return (
    <svg width='25' height='25' viewBox='0 0 100 100' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M46.5424 30.3114L44.5152 31.7745C45.131 32.6277 46.2151 33.004 47.2271 32.7158C48.2391 32.4277 48.9623 31.5367 49.0362 30.487L46.5424 30.3114ZM35.7862 15.4077L37.8133 13.9447L37.8131 13.9443L35.7862 15.4077ZM30.3933 14.8106L31.9924 16.7323L31.9928 16.7319L30.3933 14.8106ZM20.0878 23.3863L21.6863 25.3085L21.6869 25.308L20.0878 23.3863ZM17.3182 33.736L19.6476 32.8283L19.646 32.8241L17.3182 33.736ZM60.9402 86.2775L62.2628 84.1561L62.261 84.155L60.9402 86.2775ZM71.6168 85.4463L73.2153 87.3684L73.2159 87.368L71.6168 85.4463ZM82.0186 76.7906L80.4213 74.8674L80.4195 74.8689L82.0186 76.7906ZM82.4062 71.3596L84.2079 69.6265L84.2073 69.6259L82.4062 71.3596ZM69.6602 58.1183L67.859 59.852L67.8591 59.8521L69.6602 58.1183ZM64.589 57.9082L66.1878 59.8301L66.1888 59.8293L64.589 57.9082ZM59.5364 62.1112L57.9376 60.1893C57.9224 60.2019 57.9074 60.2148 57.8924 60.2278L59.5364 62.1112ZM57.6013 62.1975L56.1382 64.2246C56.1572 64.2384 56.1764 64.2518 56.1958 64.265L57.6013 62.1975ZM40.3596 41.4322L38.0701 42.4363C38.0791 42.4569 38.0884 42.4773 38.098 42.4976L40.3596 41.4322ZM40.799 39.5431L42.3499 41.5039C42.3657 41.4913 42.3815 41.4786 42.397 41.4656L40.799 39.5431ZM45.8365 35.3558L47.4346 37.2784L47.4387 37.2749L45.8365 35.3558ZM46.5427 30.308L48.57 28.8451C47.9542 27.9918 46.8701 27.6154 45.8581 27.9035C44.846 28.1917 44.1228 29.0827 44.0488 30.1324L46.5427 30.308ZM48.5696 28.8484L37.8133 13.9447L33.759 16.8708L44.5152 31.7745L48.5696 28.8484ZM37.8131 13.9443C35.6825 10.9934 31.5284 10.6127 28.7937 12.8893L31.9928 16.7319C32.6144 16.2144 33.4097 16.387 33.7593 16.8712L37.8131 13.9443ZM28.7941 12.8889L18.4886 21.4647L21.6869 25.308L31.9924 16.7323L28.7941 12.8889ZM18.4892 21.4642C14.6246 24.6781 13.1657 29.9902 14.9905 34.6479L19.646 32.8241C18.6361 30.2463 19.4167 27.1959 21.6863 25.3085L18.4892 21.4642ZM14.9888 34.6437C23.6453 56.8593 39.3701 75.7993 59.6193 88.4001L62.261 84.155C42.9287 72.1247 27.9117 54.0371 19.6476 32.8283L14.9888 34.6437ZM59.6175 88.399C63.8609 91.0446 69.3497 90.5832 73.2153 87.3684L70.0182 83.5241C67.7497 85.4107 64.6103 85.6197 62.2628 84.1561L59.6175 88.399ZM73.2159 87.368L83.6177 78.7123L80.4195 74.8689L70.0177 83.5246L73.2159 87.368ZM83.6159 78.7137C86.3599 76.4347 86.743 72.2619 84.2079 69.6265L80.6045 73.0928C81.0217 73.5265 81.0478 74.347 80.4213 74.8674L83.6159 78.7137ZM84.2073 69.6259L71.4614 56.3846L67.8591 59.8521L80.6051 73.0934L84.2073 69.6259ZM71.4615 56.3847C69.1769 54.011 65.4717 53.9199 62.9893 55.987L66.1888 59.8293C66.7515 59.3608 67.4773 59.4555 67.859 59.852L71.4615 56.3847ZM62.9902 55.9862L57.9376 60.1893L61.1352 64.0332L66.1878 59.8301L62.9902 55.9862ZM57.8924 60.2278C58.0669 60.0755 58.2799 59.9961 58.4862 59.9869L58.7089 64.9819C59.6143 64.9415 60.487 64.5999 61.1804 63.9947L57.8924 60.2278ZM58.4862 59.9869C58.6898 59.9778 58.8696 60.0367 59.0068 60.13L56.1958 64.265C56.9264 64.7617 57.8062 65.0222 58.7089 64.9819L58.4862 59.9869ZM59.0645 60.1704C52.0049 55.0749 46.3304 48.2407 42.6212 40.3668L38.098 42.4976C42.1682 51.1378 48.3922 58.6337 56.1382 64.2246L59.0645 60.1704ZM42.6491 40.4281C42.7156 40.5797 42.7407 40.767 42.6945 40.9654L37.8245 39.8327C37.6196 40.7135 37.715 41.6267 38.0701 42.4363L42.6491 40.4281ZM42.6945 40.9654C42.6478 41.1663 42.5308 41.3607 42.3499 41.5039L39.2481 37.5823C38.5259 38.1535 38.03 38.9492 37.8245 39.8327L42.6945 40.9654ZM42.397 41.4656L47.4346 37.2784L44.2385 33.4332L39.2009 37.6205L42.397 41.4656ZM47.4387 37.2749C49.922 35.2017 50.5077 31.5305 48.57 28.8451L44.5154 31.7709C44.8414 32.2226 44.8041 32.9611 44.2344 33.4367L47.4387 37.2749ZM44.0488 30.1324L44.0486 30.1358L49.0362 30.487L49.0365 30.4836L44.0488 30.1324Z'
        fill={color}
      />
    </svg>
  );
};

export const IconPageLinkSVG = ({ color }) => {
  return (
    <svg height='24' viewBox='-78 -18 560 560.00187' width='24' xmlns='http://www.w3.org/2000/svg'>
      <path
        fill={color}
        d='m260.722656 3.878906-.128906-.125c-2.355469-2.429687-5.605469-3.7890622-8.996094-3.74999975-.417968-.01953125-.839844.01953125-1.25.12890575h-191.953125c-34.503906.007813-62.46875 27.976563-62.484375 62.484376v399.898437c.015625 34.503906 27.980469 62.472656 62.484375 62.484375h278.308594c34.503906-.011719 62.472656-27.980469 62.484375-62.484375v-315.175781c-.023438-3.308594-1.320312-6.484375-3.625-8.867188zm3.371094 38.742188 92.726562 92.476562h-55.234374c-20.679688-.0625-37.433594-16.8125-37.492188-37.488281zm72.734375 457.261718h-278.433594c-20.679687-.058593-37.425781-16.8125-37.492187-37.492187v-399.902344c.066406-20.675781 16.8125-37.429687 37.492187-37.488281h180.707031v72.609375c.011719 34.5 27.980469 62.46875 62.484376 62.484375h72.609374v302.296875c.039063 20.671875-16.695312 37.464844-37.367187 37.492187zm0 0'
      />
      <path
        fill={color}
        d='m76.015625 241.195312h135.09375c6.898437 0 12.5-5.59375 12.5-12.496093 0-6.902344-5.601563-12.496094-12.5-12.496094h-135.09375c-6.902344 0-12.496094 5.59375-12.496094 12.496094 0 6.902343 5.59375 12.496093 12.496094 12.496093zm0 0'
      />
      <path
        fill={color}
        d='m319.207031 310.679688h-243.191406c-6.902344 0-12.496094 5.59375-12.496094 12.496093 0 6.898438 5.59375 12.496094 12.496094 12.496094h243.191406c6.898438 0 12.5-5.597656 12.5-12.496094 0-6.902343-5.601562-12.496093-12.5-12.496093zm0 0'
      />
      <path
        fill={color}
        d='m319.207031 405.28125h-243.191406c-6.902344 0-12.496094 5.59375-12.496094 12.496094s5.59375 12.496094 12.496094 12.496094h243.191406c6.898438 0 12.5-5.59375 12.5-12.496094s-5.601562-12.496094-12.5-12.496094zm0 0'
      />
    </svg>
  );
};

export const IconPostLinkSVG = ({ color }) => {
  return (
    <svg id='line' width='24' height='24' viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'>
      <path
        fill={color}
        d='m19 21.75h-16c-1.5166 0-2.75-1.2334-2.75-2.75v-16c0-1.5166 1.2334-2.75 2.75-2.75h16c1.5166 0 2.75 1.2334 2.75 2.75v16c0 1.5166-1.2334 2.75-2.75 2.75zm-16-20c-.6895 0-1.25.5605-1.25 1.25v16c0 .6895.5605 1.25 1.25 1.25h16c.6895 0 1.25-.5605 1.25-1.25v-16c0-.6895-.5605-1.25-1.25-1.25z'
      />
      <path
        fill={color}
        d='m29 31.75h-16c-1.5166 0-2.75-1.2334-2.75-2.75v-5c0-.4141.3359-.75.75-.75s.75.3359.75.75v5c0 .6895.5605 1.25 1.25 1.25h16c.6895 0 1.25-.5605 1.25-1.25v-16c0-.6895-.5605-1.25-1.25-1.25h-5c-.4141 0-.75-.3359-.75-.75s.3359-.75.75-.75h5c1.5166 0 2.75 1.2334 2.75 2.75v16c0 1.5166-1.2334 2.75-2.75 2.75z'
      />
      <path
        fill={color}
        d='m13.9307 21.75c-.2593 0-.5112-.1348-.6504-.3755l-6.2803-10.875-5.3203 9.2149c-.207.3589-.667.48-1.0244.2754-.3589-.207-.4819-.6655-.2754-1.0244l5.9707-10.3404c.2676-.4639 1.0312-.4639 1.2988 0l6.9307 12.0005c.2065.3589.0835.8174-.2754 1.0244-.1182.0679-.2466.1001-.374.1001z'
      />
      <path
        fill={color}
        d='m20.9102 20.2695c-.2339 0-.4609-.1104-.6025-.3213l-4.3071-7.4492-3.271 5.666c-.207.3599-.6655.4814-1.0244.2744s-.4814-.6655-.2744-1.0244l3.9199-6.79c.2676-.4639 1.0312-.4639 1.2988 0l4.9102 8.5c.2021.3501.1006.812-.2422 1.0264-.1279.0796-.269.1182-.4072.1182z'
      />
      <circle fill={color} cx='12' cy='6' r='1.75' />
      <path fill={color} d='m27 15.75h-3c-.4141 0-.75-.3359-.75-.75s.3359-.75.75-.75h3c.4141 0 .75.3359.75.75s-.3359.75-.75.75z' />
      <path fill={color} d='m27 19.75h-3c-.4141 0-.75-.3359-.75-.75s.3359-.75.75-.75h3c.4141 0 .75.3359.75.75s-.3359.75-.75.75z' />
      <path fill={color} d='m27 23.75h-4c-.4141 0-.75-.3359-.75-.75s.3359-.75.75-.75h4c.4141 0 .75.3359.75.75s-.3359.75-.75.75z' />
      <path fill={color} d='m27 27.75h-12c-.4141 0-.75-.3359-.75-.75s.3359-.75.75-.75h12c.4141 0 .75.3359.75.75s-.3359.75-.75.75z' />
    </svg>
  );
};

export const IconDocumentLinkSVG = ({ color }) => {
  return (
    <svg width='29' height='30' viewBox='0 0 1080 1080' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M821.56 960H259.437C237.346 960 219.438 942.091 219.438 920V160C219.438 137.909 237.346 120 259.438 120H652.877C663.166 120 673.06 123.965 680.502 131.072L849.186 292.157C857.089 299.705 861.56 310.157 861.56 321.085V920C861.56 942.091 843.652 960 821.56 960Z'
        stroke={color}
        strokeWidth='40'
      />
      <path d='M649.266 113.52V327.374H863.12' stroke={color} strokeWidth='40' strokeLinejoin='round' />
      <path
        d='M365.778 647.103H366.278V646.603V583.828H405.686C419.467 584.317 432.894 579.403 443.103 570.133L443.111 570.126L443.118 570.119C452.372 561.005 457.674 548.621 457.884 535.635C458.093 522.649 453.192 510.1 444.238 500.693L444.236 500.692C435.104 491.155 421.124 486.434 402.401 486.434H337H336.5V486.934V646.603V647.103H337H365.778ZM426.696 534.658L426.696 534.673L426.696 534.689C426.837 537.854 426.298 541.013 425.116 543.953C423.934 546.892 422.137 549.544 419.846 551.731C415.278 555.987 408.631 558.153 399.826 558.153H366.278V511.33H397.25C408.511 511.33 416.145 513.663 420.331 518.177L420.333 518.18C424.52 522.634 426.803 528.546 426.696 534.658Z'
        fill={color}
      />
      <path
        d='M483.844 646.603V647.103H484.344H536.898L536.9 647.103C562.259 647.023 581.823 639.34 595.515 623.997C609.181 608.683 616.005 589.645 616.005 566.918C616.005 544.274 609.383 525.189 596.121 509.696C582.842 494.184 565.23 486.434 543.336 486.434H484.344H483.844V486.934V646.603ZM537.893 622.596H537.886H514.43L514.4 510.162H541.27V510.162L541.279 510.162C547.313 510.052 553.279 511.458 558.63 514.249C563.981 517.041 568.546 521.129 571.908 526.141L571.908 526.141L571.913 526.149C579.934 537.646 584.03 551.424 583.592 565.435L583.592 565.443V565.451C583.592 584.486 579.126 598.726 570.28 608.262L570.28 608.262L570.272 608.271C566.222 612.845 561.233 616.493 555.645 618.965C550.057 621.437 544.002 622.676 537.893 622.596Z'
        fill={color}
      />
      <path
        d='M672.069 647.103H672.569V646.603V579.696H728.217H728.717V579.196V555.239V554.739H728.217H672.569V512.109H743.399H743.899V511.609V486.934V486.434H743.399H642.453H641.953V486.934V646.603V647.103H642.453H672.069Z'
        fill={color}
      />
    </svg>
  );
};

export const IconSquareGallerySVG = ({ isActive = false }) => {
  return (
    <svg width='50' height='120' viewBox='0 0 160 272' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='11' y='11' width='138' height='250' rx='13' fill='#EDF3FD' stroke={isActive ? '#17ce17' : '#A9ACBA'} strokeWidth='2' />
      <rect x='25' y='29' width='110' height='110' rx='5' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
    </svg>
  );
};

export const IconRectangleGallerySVG = ({ isActive = false }) => {
  return (
    <svg width='50' height='120' viewBox='0 0 160 272' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='11' y='11' width='138' height='250' rx='13' fill='#EDF3FD' stroke={isActive ? '#17ce17' : '#A9ACBA'} strokeWidth='2' />
      <rect x='25' y='29' width='110' height='54' rx='5' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
    </svg>
  );
};

export const IconPortraitSVG = ({ isActive = false }) => {
  return (
    <svg width='50' height='120' viewBox='0 0 160 272' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='11' y='11' width='138' height='250' rx='13' fill='#EDF3FD' stroke={isActive ? '#17ce17' : '#A9ACBA'} strokeWidth='2' />
      <rect x='25' y='29' width='110' height='183' rx='5' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
    </svg>
  );
};

export const IconAutoGallerySVG = ({ isActive = false }) => {
  return (
    <svg width='50' height='120' viewBox='0 0 160 272' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='11' y='11' width='138' height='250' rx='13' fill='#EDF3FD' stroke={isActive ? '#17ce17' : '#A9ACBA'} strokeWidth='2' />
      <mask id='path-2-inside-1_1619_554' fill='white'>
        <path d='M24 34C24 30.6863 26.6863 28 30 28H130C133.314 28 136 30.6863 136 34V134C136 137.314 133.314 140 130 140H30C26.6863 140 24 137.314 24 134V34Z' />
      </mask>
      <path
        d='M22 34C22 29.5817 25.5817 26 30 26H130C134.418 26 138 29.5817 138 34H134C134 31.7909 132.209 30 130 30H30C27.7909 30 26 31.7909 26 34H22ZM138 134C138 138.418 134.418 142 130 142H30C25.5817 142 22 138.418 22 134H26C26 136.209 27.7909 138 30 138H130C132.209 138 134 136.209 134 134H138ZM30 142C25.5817 142 22 138.418 22 134V34C22 29.5817 25.5817 26 30 26V30C27.7909 30 26 31.7909 26 34V134C26 136.209 27.7909 138 30 138V142ZM130 26C134.418 26 138 29.5817 138 34V134C138 138.418 134.418 142 130 142V138C132.209 138 134 136.209 134 134V34C134 31.7909 132.209 30 130 30V26Z'
        fill='#A9ACBA'
        fillOpacity='0.7'
        mask='url(#path-2-inside-1_1619_554)'
      />
      <path
        d='M62.4602 91.2202C61.7689 91.2202 61.1463 91.0971 60.5923 90.8509C60.0431 90.5999 59.6075 90.2306 59.2855 89.7429C58.9683 89.2552 58.8097 88.6539 58.8097 87.9389C58.8097 87.3234 58.9233 86.8144 59.1506 86.4119C59.3778 86.0095 59.688 85.6875 60.081 85.446C60.474 85.2045 60.9167 85.0223 61.4091 84.8991C61.9063 84.7713 62.42 84.679 62.9503 84.6222C63.5895 84.5559 64.108 84.4967 64.5057 84.4446C64.9034 84.3878 65.1922 84.3026 65.3722 84.1889C65.5568 84.0705 65.6491 83.8883 65.6491 83.642V83.5994C65.6491 83.0644 65.4905 82.6501 65.1733 82.3565C64.8561 82.063 64.3991 81.9162 63.8026 81.9162C63.1728 81.9162 62.6733 82.0535 62.304 82.3281C61.9394 82.6027 61.6932 82.9271 61.5653 83.3011L59.1648 82.9602C59.3542 82.2973 59.6667 81.7434 60.1023 81.2983C60.5379 80.8485 61.0705 80.5123 61.7003 80.2898C62.33 80.0625 63.026 79.9489 63.7884 79.9489C64.3139 79.9489 64.8371 80.0104 65.358 80.1335C65.8788 80.2566 66.3546 80.4602 66.7855 80.7443C67.2164 81.0237 67.562 81.4048 67.8224 81.8878C68.0876 82.3707 68.2202 82.9744 68.2202 83.6989V91H65.7486V89.5014H65.6634C65.5071 89.8045 65.2869 90.0885 65.0028 90.3537C64.7235 90.6141 64.3707 90.8248 63.9446 90.9858C63.5232 91.142 63.0284 91.2202 62.4602 91.2202ZM63.1278 89.331C63.6439 89.331 64.0914 89.2292 64.4702 89.0256C64.849 88.8172 65.1402 88.5426 65.3438 88.2017C65.5521 87.8608 65.6562 87.4891 65.6562 87.0866V85.8011C65.5758 85.8674 65.4384 85.929 65.2443 85.9858C65.0549 86.0426 64.8419 86.0923 64.6051 86.1349C64.3684 86.1776 64.134 86.2154 63.902 86.2486C63.67 86.2817 63.4688 86.3101 63.2983 86.3338C62.9148 86.3859 62.5715 86.4711 62.2685 86.5895C61.9654 86.7079 61.7263 86.8736 61.5511 87.0866C61.3759 87.295 61.2884 87.5649 61.2884 87.8963C61.2884 88.3698 61.4612 88.7273 61.8068 88.9688C62.1525 89.2102 62.5928 89.331 63.1278 89.331ZM77.7585 86.4119V80.0909H80.3295V91H77.8366V89.0611H77.723C77.4768 89.6719 77.072 90.1714 76.5085 90.5597C75.9498 90.9479 75.2609 91.142 74.4418 91.142C73.7268 91.142 73.0947 90.9834 72.5455 90.6662C72.0009 90.3442 71.5748 89.8778 71.267 89.267C70.9593 88.6515 70.8054 87.9081 70.8054 87.0369V80.0909H73.3764V86.6392C73.3764 87.3305 73.5658 87.8797 73.9446 88.2869C74.3234 88.6941 74.8205 88.8977 75.4361 88.8977C75.8149 88.8977 76.1818 88.8054 76.5369 88.6207C76.892 88.4361 77.1832 88.1615 77.4105 87.7969C77.6425 87.4276 77.7585 86.9659 77.7585 86.4119ZM88.4208 80.0909V82.0795H82.1495V80.0909H88.4208ZM83.6978 77.4773H86.2688V87.7188C86.2688 88.0644 86.3209 88.3295 86.4251 88.5142C86.534 88.6941 86.676 88.8172 86.8512 88.8835C87.0264 88.9498 87.2205 88.983 87.4336 88.983C87.5946 88.983 87.7414 88.9711 87.8739 88.9474C88.0112 88.9238 88.1154 88.9025 88.1864 88.8835L88.6197 90.8935C88.4824 90.9408 88.2859 90.9929 88.0302 91.0497C87.7792 91.1065 87.4715 91.1397 87.1069 91.1491C86.4629 91.1681 85.8829 91.071 85.3668 90.858C84.8507 90.6402 84.4412 90.304 84.1381 89.8494C83.8398 89.3949 83.6931 88.8267 83.6978 88.1449V77.4773ZM95.2124 91.2131C94.147 91.2131 93.2237 90.9787 92.4425 90.5099C91.6612 90.0412 91.0552 89.3854 90.6243 88.5426C90.1982 87.6998 89.9851 86.715 89.9851 85.5881C89.9851 84.4612 90.1982 83.474 90.6243 82.6264C91.0552 81.7789 91.6612 81.1207 92.4425 80.652C93.2237 80.1832 94.147 79.9489 95.2124 79.9489C96.2777 79.9489 97.201 80.1832 97.9822 80.652C98.7635 81.1207 99.3672 81.7789 99.7933 82.6264C100.224 83.474 100.44 84.4612 100.44 85.5881C100.44 86.715 100.224 87.6998 99.7933 88.5426C99.3672 89.3854 98.7635 90.0412 97.9822 90.5099C97.201 90.9787 96.2777 91.2131 95.2124 91.2131ZM95.2266 89.1534C95.8042 89.1534 96.2872 88.9948 96.6754 88.6776C97.0637 88.3556 97.3525 87.9247 97.5419 87.3849C97.736 86.8452 97.8331 86.2438 97.8331 85.581C97.8331 84.9134 97.736 84.3097 97.5419 83.7699C97.3525 83.2254 97.0637 82.7921 96.6754 82.4702C96.2872 82.1482 95.8042 81.9872 95.2266 81.9872C94.6347 81.9872 94.1423 82.1482 93.7493 82.4702C93.361 82.7921 93.0698 83.2254 92.8757 83.7699C92.6863 84.3097 92.5916 84.9134 92.5916 85.581C92.5916 86.2438 92.6863 86.8452 92.8757 87.3849C93.0698 87.9247 93.361 88.3556 93.7493 88.6776C94.1423 88.9948 94.6347 89.1534 95.2266 89.1534Z'
        fill='#A9ACBA'
      />
      <rect x='18' y='44' width='23' height='80' fill='#EDF3FD' />
      <rect x='118' y='44' width='23' height='80' fill='#EDF3FD' />
      <rect x='41' y='44.5' width='22' height='79' transform='rotate(-90 41 44.5)' fill='#EDF3FD' />
      <rect x='41' y='152.5' width='22' height='79' transform='rotate(-90 41 152.5)' fill='#EDF3FD' />
    </svg>
  );
};

export const IconSquareLayoutSVG = ({ isActive = false }) => {
  return (
    <svg width='50' height='120' viewBox='0 0 160 272' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='11' y='11' width='138' height='250' rx='13' fill='#EDF3FD' stroke={isActive ? '#17ce17' : '#A9ACBA'} strokeWidth='2' />
      <rect x='25' y='29' width='110' height='110' rx='5' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
    </svg>
  );
};

export const IconRectangleLayoutSVG = ({ isActive = false }) => {
  return (
    <svg width='50' height='120' viewBox='0 0 160 272' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='11' y='11' width='138' height='250' rx='13' fill='#EDF3FD' stroke={isActive ? '#17ce17' : '#A9ACBA'} strokeWidth='2' />
      <rect x='25' y='29' width='110' height='54' rx='5' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
    </svg>
  );
};

export const IconAutoLayoutSVG = ({ isActive = false }) => {
  return (
    <svg width='50' height='120' viewBox='0 0 160 272' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='11' y='11' width='138' height='250' rx='13' fill='#EDF3FD' stroke={isActive ? '#17ce17' : '#A9ACBA'} strokeWidth='2' />
      <mask id='path-2-inside-1_1410_8' fill='white'>
        <path d='M24 34C24 30.6863 26.6863 28 30 28H130C133.314 28 136 30.6863 136 34V134C136 137.314 133.314 140 130 140H30C26.6863 140 24 137.314 24 134V34Z' />
      </mask>
      <path
        d='M30 30H130V26H30V30ZM134 34V134H138V34H134ZM130 138H30V142H130V138ZM26 134V34H22V134H26ZM30 138C27.7909 138 26 136.209 26 134H22C22 138.418 25.5817 142 30 142V138ZM134 134C134 136.209 132.209 138 130 138V142C134.418 142 138 138.418 138 134H134ZM130 30C132.209 30 134 31.7909 134 34H138C138 29.5817 134.418 26 130 26V30ZM30 26C25.5817 26 22 29.5817 22 34H26C26 31.7909 27.7909 30 30 30V26Z'
        fill='#A9ACBA'
        fillOpacity='0.7'
        mask='url(#path-2-inside-1_1410_8)'
      />
      <path
        d='M62.4602 91.2202C61.7689 91.2202 61.1463 91.0971 60.5923 90.8509C60.0431 90.5999 59.6075 90.2306 59.2855 89.7429C58.9683 89.2552 58.8097 88.6539 58.8097 87.9389C58.8097 87.3234 58.9233 86.8144 59.1506 86.4119C59.3778 86.0095 59.688 85.6875 60.081 85.446C60.474 85.2045 60.9167 85.0223 61.4091 84.8991C61.9063 84.7713 62.42 84.679 62.9503 84.6222C63.5895 84.5559 64.108 84.4967 64.5057 84.4446C64.9034 84.3878 65.1922 84.3026 65.3722 84.1889C65.5568 84.0705 65.6491 83.8883 65.6491 83.642V83.5994C65.6491 83.0644 65.4905 82.6501 65.1733 82.3565C64.8561 82.063 64.3991 81.9162 63.8026 81.9162C63.1728 81.9162 62.6733 82.0535 62.304 82.3281C61.9394 82.6027 61.6932 82.9271 61.5653 83.3011L59.1648 82.9602C59.3542 82.2973 59.6667 81.7434 60.1023 81.2983C60.5379 80.8485 61.0705 80.5123 61.7003 80.2898C62.33 80.0625 63.026 79.9489 63.7884 79.9489C64.3139 79.9489 64.8371 80.0104 65.358 80.1335C65.8788 80.2566 66.3546 80.4602 66.7855 80.7443C67.2164 81.0237 67.562 81.4048 67.8224 81.8878C68.0876 82.3707 68.2202 82.9744 68.2202 83.6989V91H65.7486V89.5014H65.6634C65.5071 89.8045 65.2869 90.0885 65.0028 90.3537C64.7235 90.6141 64.3707 90.8248 63.9446 90.9858C63.5232 91.142 63.0284 91.2202 62.4602 91.2202ZM63.1278 89.331C63.6439 89.331 64.0914 89.2292 64.4702 89.0256C64.849 88.8172 65.1402 88.5426 65.3438 88.2017C65.5521 87.8608 65.6562 87.4891 65.6562 87.0866V85.8011C65.5758 85.8674 65.4384 85.929 65.2443 85.9858C65.0549 86.0426 64.8419 86.0923 64.6051 86.1349C64.3684 86.1776 64.134 86.2154 63.902 86.2486C63.67 86.2817 63.4688 86.3101 63.2983 86.3338C62.9148 86.3859 62.5715 86.4711 62.2685 86.5895C61.9654 86.7079 61.7263 86.8736 61.5511 87.0866C61.3759 87.295 61.2884 87.5649 61.2884 87.8963C61.2884 88.3698 61.4612 88.7273 61.8068 88.9688C62.1525 89.2102 62.5928 89.331 63.1278 89.331ZM77.7585 86.4119V80.0909H80.3295V91H77.8366V89.0611H77.723C77.4768 89.6719 77.072 90.1714 76.5085 90.5597C75.9498 90.9479 75.2609 91.142 74.4418 91.142C73.7268 91.142 73.0947 90.9834 72.5455 90.6662C72.0009 90.3442 71.5748 89.8778 71.267 89.267C70.9593 88.6515 70.8054 87.9081 70.8054 87.0369V80.0909H73.3764V86.6392C73.3764 87.3305 73.5658 87.8797 73.9446 88.2869C74.3234 88.6941 74.8205 88.8977 75.4361 88.8977C75.8149 88.8977 76.1818 88.8054 76.5369 88.6207C76.892 88.4361 77.1832 88.1615 77.4105 87.7969C77.6425 87.4276 77.7585 86.9659 77.7585 86.4119ZM88.4208 80.0909V82.0795H82.1495V80.0909H88.4208ZM83.6978 77.4773H86.2688V87.7188C86.2688 88.0644 86.3209 88.3295 86.4251 88.5142C86.534 88.6941 86.676 88.8172 86.8512 88.8835C87.0264 88.9498 87.2205 88.983 87.4336 88.983C87.5946 88.983 87.7414 88.9711 87.8739 88.9474C88.0112 88.9238 88.1154 88.9025 88.1864 88.8835L88.6197 90.8935C88.4824 90.9408 88.2859 90.9929 88.0302 91.0497C87.7792 91.1065 87.4715 91.1397 87.1069 91.1491C86.4629 91.1681 85.8829 91.071 85.3668 90.858C84.8507 90.6402 84.4412 90.304 84.1381 89.8494C83.8398 89.3949 83.6931 88.8267 83.6978 88.1449V77.4773ZM95.2124 91.2131C94.147 91.2131 93.2237 90.9787 92.4425 90.5099C91.6612 90.0412 91.0552 89.3854 90.6243 88.5426C90.1982 87.6998 89.9851 86.715 89.9851 85.5881C89.9851 84.4612 90.1982 83.474 90.6243 82.6264C91.0552 81.7789 91.6612 81.1207 92.4425 80.652C93.2237 80.1832 94.147 79.9489 95.2124 79.9489C96.2777 79.9489 97.201 80.1832 97.9822 80.652C98.7635 81.1207 99.3672 81.7789 99.7933 82.6264C100.224 83.474 100.44 84.4612 100.44 85.5881C100.44 86.715 100.224 87.6998 99.7933 88.5426C99.3672 89.3854 98.7635 90.0412 97.9822 90.5099C97.201 90.9787 96.2777 91.2131 95.2124 91.2131ZM95.2266 89.1534C95.8042 89.1534 96.2872 88.9948 96.6754 88.6776C97.0637 88.3556 97.3525 87.9247 97.5419 87.3849C97.736 86.8452 97.8331 86.2438 97.8331 85.581C97.8331 84.9134 97.736 84.3097 97.5419 83.7699C97.3525 83.2254 97.0637 82.7921 96.6754 82.4702C96.2872 82.1482 95.8042 81.9872 95.2266 81.9872C94.6347 81.9872 94.1423 82.1482 93.7493 82.4702C93.361 82.7921 93.0698 83.2254 92.8757 83.7699C92.6863 84.3097 92.5916 84.9134 92.5916 85.581C92.5916 86.2438 92.6863 86.8452 92.8757 87.3849C93.0698 87.9247 93.361 88.3556 93.7493 88.6776C94.1423 88.9948 94.6347 89.1534 95.2266 89.1534Z'
        fill='#A9ACBA'
      />
      <rect x='18' y='44' width='23' height='80' fill='#EDF3FD' />
      <rect x='118' y='44' width='23' height='80' fill='#EDF3FD' />
      <rect x='41' y='44.5' width='22' height='79' transform='rotate(-90 41 44.5)' fill='#EDF3FD' />
      <rect x='41' y='152.5' width='22' height='79' transform='rotate(-90 41 152.5)' fill='#EDF3FD' />
    </svg>
  );
};

export const IconCustomLayoutSVG = ({ isActive = false }) => {
  return (
    <svg width='50' height='120' viewBox='0 0 160 272' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='11' y='11' width='138' height='250' rx='13' fill='#EDF3FD' stroke='#A9ACBA' strokeWidth='2' />
      <rect x='11' y='11' width='138' height='250' rx='13' fill='#EDF3FD' stroke={isActive ? '#17ce17' : '#A9ACBA'} strokeWidth='2' />
      <rect x='25' y='29' width='110' height='110' rx='5' stroke='#A9ACBA' strokeOpacity='0.7' strokeWidth='2' strokeDasharray='14 14' />
      <path
        d='M81.0607 40.9393C80.4749 40.3536 79.5251 40.3536 78.9393 40.9393L69.3934 50.4853C68.8076 51.0711 68.8076 52.0208 69.3934 52.6066C69.9792 53.1924 70.9289 53.1924 71.5147 52.6066L80 44.1213L88.4853 52.6066C89.0711 53.1924 90.0208 53.1924 90.6066 52.6066C91.1924 52.0208 91.1924 51.0711 90.6066 50.4853L81.0607 40.9393ZM78.9393 127.061C79.5251 127.646 80.4749 127.646 81.0607 127.061L90.6066 117.515C91.1924 116.929 91.1924 115.979 90.6066 115.393C90.0208 114.808 89.0711 114.808 88.4853 115.393L80 123.879L71.5147 115.393C70.9289 114.808 69.9792 114.808 69.3934 115.393C68.8076 115.979 68.8076 116.929 69.3934 117.515L78.9393 127.061ZM78.5 42V126H81.5V42H78.5Z'
        fill='#A9ACBA'
      />
    </svg>
  );
};

export const IconSlideOneGallerySVG = ({ isActive = false }) => {
  return (
    <svg width='50' height='120' viewBox='0 0 160 272' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='11' y='11' width='138' height='250' rx='13' fill='#F6F9FE' stroke={isActive ? '#17ce17' : '#A9ACBA'} strokeWidth='2' />
      <rect x='23' y='64' width='114' height='114' rx='3' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
      <circle cx='65' cy='190' r='4' fill='#A9ACBA' />
      <circle cx='80' cy='190' r='4' fill='#A9ACBA' />
      <circle cx='95' cy='190' r='4' fill='#A9ACBA' />
    </svg>
  );
};

export const IconSliderLayoutCoverSVG = ({ isActive = false }) => {
  return (
    <svg width='50' height='120' viewBox='0 0 160 272' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='11' y='11' width='138' height='250' rx='13' fill='#EDF3FD' stroke={isActive ? '#17ce17' : '#A9ACBA'} strokeWidth='2' />
      <rect x='25' y='65' width='110' height='110' rx='5' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
    </svg>
  );
};

export const IconSliderLayoutCardSVG = ({ isActive = false }) => {
  return (
    <svg width='50' height='120' viewBox='0 0 160 272' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='11' y='11' width='138' height='250' rx='13' fill='#EDF3FD' stroke={isActive ? '#17ce17' : '#A9ACBA'} strokeWidth='2' />
      <rect x='23' y='98' width='114.339' height='108' rx='7' fill='#F6F9FE' stroke='#A9ACBA' strokeWidth='2' />
      <path d='M30 65H130.339C134.205 65 137.339 68.134 137.339 72V151H23V72C23 68.134 26.134 65 30 65Z' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
      <path d='M39.4512 187.201H120.889' stroke='#A9ACBA' strokeWidth='5' strokeLinecap='round' />
      <path d='M39.4512 167.398H120.889' stroke='#A9ACBA' strokeWidth='5' strokeLinecap='round' />
      <path d='M39.4512 167.398H120.889' stroke='#A9ACBA' strokeWidth='5' strokeLinecap='round' />
    </svg>
  );
};

export const IconSlideTwoGallerySVG = ({ isActive = false }) => {
  return (
    <svg width='50' height='120' viewBox='0 0 160 272' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='11' y='11' width='138' height='250' rx='13' fill='#F6F9FE' stroke={isActive ? '#17ce17' : '#A9ACBA'} strokeWidth='2' />
      <rect x='21' y='74' width='94' height='118' rx='3' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
      <path d='M127 189L127 77C127 75.3431 128.343 74 130 74L149 74L149 192L130 192C128.343 192 127 190.657 127 189Z' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
    </svg>
  );
};

export const IconLeftFeaturesSVG = ({ isActive = false }) => {
  return (
    <svg width='50' height='120' viewBox='0 0 160 272' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='11' y='11' width='138' height='250' rx='13' fill='#EDF3FD' stroke={isActive ? '#17ce17' : '#A9ACBA'} strokeWidth='2' />
      <rect x='62' y='59' width='44' height='11' rx='5.5' fill='#A9ACBA' />
      <rect x='62' y='120' width='44' height='11' rx='5.5' fill='#A9ACBA' />
      <rect x='62' y='181' width='44' height='11' rx='5.5' fill='#A9ACBA' />
      <rect x='62' y='77' width='77' height='5' rx='2.5' fill='#A9ACBA' />
      <rect x='62' y='138' width='77' height='5' rx='2.5' fill='#A9ACBA' />
      <rect x='62' y='199' width='77' height='5' rx='2.5' fill='#A9ACBA' />
      <rect x='62' y='85' width='63' height='5' rx='2.5' fill='#A9ACBA' />
      <rect x='62' y='146' width='63' height='5' rx='2.5' fill='#A9ACBA' />
      <rect x='62' y='207' width='63' height='5' rx='2.5' fill='#A9ACBA' />
      <rect x='21' y='59' width='33' height='33' rx='5' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
      <rect x='21' y='120' width='33' height='33' rx='5' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
      <rect x='21' y='181' width='33' height='33' rx='5' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
    </svg>
  );
};

export const IconRightFeaturesSVG = ({ isActive = false }) => {
  return (
    <svg width='50' height='120' viewBox='0 0 160 272' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='11' y='11' width='138' height='250' rx='13' fill='#EDF3FD' stroke={isActive ? '#17ce17' : '#A9ACBA'} strokeWidth='2' />
      <rect x='20' y='59' width='41' height='11' rx='5.5' fill='#A9ACBA' />
      <rect x='20' y='77' width='74' height='5' rx='2.5' fill='#A9ACBA' />
      <rect x='20' y='85' width='61' height='5' rx='2.5' fill='#A9ACBA' />
      <rect x='20' y='120' width='41' height='11' rx='5.5' fill='#A9ACBA' />
      <rect x='20' y='138' width='74' height='5' rx='2.5' fill='#A9ACBA' />
      <rect x='20' y='146' width='61' height='5' rx='2.5' fill='#A9ACBA' />
      <rect x='20' y='181' width='41' height='11' rx='5.5' fill='#A9ACBA' />
      <rect x='20' y='199' width='74' height='5' rx='2.5' fill='#A9ACBA' />
      <rect x='20' y='207' width='61' height='5' rx='2.5' fill='#A9ACBA' />
      <rect x='106' y='59' width='33' height='33' rx='5' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
      <rect x='106' y='120' width='33' height='33' rx='5' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
      <rect x='106' y='181' width='33' height='33' rx='5' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
    </svg>
  );
};

export const IconJustifyFeaturesSVG = ({ isActive = false }) => {
  return (
    <svg width='50' height='120' viewBox='0 0 160 272' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='11' y='11' width='138' height='250' rx='13' fill='#EDF3FD' stroke={isActive ? '#17ce17' : '#A9ACBA'} strokeWidth='2' />
      <rect x='20' y='59' width='41' height='11' rx='5.5' fill='#A9ACBA' />
      <rect x='20' y='77' width='74' height='5' rx='2.5' fill='#A9ACBA' />
      <rect x='20' y='85' width='61' height='5' rx='2.5' fill='#A9ACBA' />
      <rect x='63' y='120' width='41' height='11' rx='5.5' fill='#A9ACBA' />
      <rect x='63' y='138' width='74' height='5' rx='2.5' fill='#A9ACBA' />
      <rect x='63' y='146' width='61' height='5' rx='2.5' fill='#A9ACBA' />
      <rect x='20' y='181' width='41' height='11' rx='5.5' fill='#A9ACBA' />
      <rect x='20' y='199' width='74' height='5' rx='2.5' fill='#A9ACBA' />
      <rect x='20' y='207' width='61' height='5' rx='2.5' fill='#A9ACBA' />
      <rect x='106' y='59' width='33' height='33' rx='5' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
      <rect x='21' y='120' width='33' height='33' rx='5' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
      <rect x='106' y='181' width='33' height='33' rx='5' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
    </svg>
  );
};

export const IconCenterFeaturesSVG = ({ isActive = false }) => {
  return (
    <svg width='50' height='120' viewBox='0 0 160 272' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='11' y='11' width='138' height='250' rx='13' fill='#EDF3FD' stroke={isActive ? '#17ce17' : '#A9ACBA'} strokeWidth='2' />
      <rect x='27' y='228' width='94' height='5' rx='2.5' fill='#A9ACBA' />
      <rect x='27' y='220' width='105' height='5' rx='2.5' fill='#A9ACBA' />
      <rect x='42' y='202' width='73' height='11' rx='5.5' fill='#A9ACBA' />
      <rect x='60' y='151' width='40' height='40' rx='5' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
      <rect x='27' y='115' width='94' height='5' rx='2.5' fill='#A9ACBA' />
      <rect x='27' y='107' width='105' height='5' rx='2.5' fill='#A9ACBA' />
      <rect x='42' y='89' width='73' height='11' rx='5.5' fill='#A9ACBA' />
      <rect x='60' y='40' width='40' height='39' rx='5' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
    </svg>
  );
};

export const IconDeleteItemSVG = () => {
  return (
    <svg aria-hidden='true' focusable='false' data-prefix='fas' className='ButtonLinkMenuItemIcon' data-icon='trash' role='img' width='20px' height='20px' viewBox='0 0 448 512'>
      <path
        className='ButtonLinkMenuItemIcon'
        fill='#adc6ff'
        d='M432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32z'
      />
    </svg>
  );
};
export const IconDeletePageSVG = ({ color = '#adc6ff', size = '20px' }) => {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.3094 2.25002H13.6908C13.9072 2.24988 14.0957 2.24976 14.2737 2.27819C14.977 2.39049 15.5856 2.82915 15.9146 3.46084C15.9978 3.62073 16.0573 3.79961 16.1256 4.00494L16.2373 4.33984C16.2562 4.39653 16.2616 4.41258 16.2661 4.42522C16.4413 4.90933 16.8953 5.23659 17.4099 5.24964C17.4235 5.24998 17.44 5.25004 17.5001 5.25004H20.5001C20.9143 5.25004 21.2501 5.58582 21.2501 6.00004C21.2501 6.41425 20.9143 6.75004 20.5001 6.75004H3.5C3.08579 6.75004 2.75 6.41425 2.75 6.00004C2.75 5.58582 3.08579 5.25004 3.5 5.25004H6.50008C6.56013 5.25004 6.5767 5.24998 6.59023 5.24964C7.10488 5.23659 7.55891 4.90936 7.73402 4.42524C7.73863 4.41251 7.74392 4.39681 7.76291 4.33984L7.87452 4.00496C7.94281 3.79964 8.00233 3.62073 8.08559 3.46084C8.41453 2.82915 9.02313 2.39049 9.72643 2.27819C9.90445 2.24976 10.093 2.24988 10.3094 2.25002ZM9.00815 5.25004C9.05966 5.14902 9.10531 5.04404 9.14458 4.93548C9.1565 4.90251 9.1682 4.86742 9.18322 4.82234L9.28302 4.52292C9.37419 4.24941 9.39519 4.19363 9.41601 4.15364C9.52566 3.94307 9.72853 3.79686 9.96296 3.75942C10.0075 3.75231 10.067 3.75004 10.3553 3.75004H13.6448C13.9331 3.75004 13.9927 3.75231 14.0372 3.75942C14.2716 3.79686 14.4745 3.94307 14.5842 4.15364C14.605 4.19363 14.626 4.2494 14.7171 4.52292L14.8169 4.82216L14.8556 4.9355C14.8949 5.04405 14.9405 5.14902 14.992 5.25004H9.00815Z'
        fill={color}
      />
      <path
        d='M5.91509 8.45015C5.88754 8.03685 5.53016 7.72415 5.11686 7.7517C4.70357 7.77925 4.39086 8.13663 4.41841 8.54993L4.88186 15.5017C4.96736 16.7844 5.03642 17.8205 5.19839 18.6336C5.36679 19.4789 5.65321 20.185 6.2448 20.7385C6.8364 21.2919 7.55995 21.5308 8.4146 21.6425C9.23662 21.7501 10.275 21.7501 11.5606 21.75H12.4395C13.7251 21.7501 14.7635 21.7501 15.5856 21.6425C16.4402 21.5308 17.1638 21.2919 17.7554 20.7385C18.347 20.185 18.6334 19.4789 18.8018 18.6336C18.9638 17.8206 19.0328 16.7844 19.1183 15.5017L19.5818 8.54993C19.6093 8.13663 19.2966 7.77925 18.8833 7.7517C18.47 7.72415 18.1126 8.03685 18.0851 8.45015L17.6251 15.3493C17.5353 16.6971 17.4713 17.6349 17.3307 18.3406C17.1943 19.025 17.004 19.3873 16.7306 19.6431C16.4572 19.8989 16.083 20.0647 15.391 20.1552C14.6776 20.2485 13.7376 20.25 12.3868 20.25H11.6134C10.2626 20.25 9.32255 20.2485 8.60915 20.1552C7.91715 20.0647 7.54299 19.8989 7.26958 19.6431C6.99617 19.3873 6.80583 19.025 6.66948 18.3406C6.52892 17.6349 6.46489 16.6971 6.37503 15.3493L5.91509 8.45015Z'
        fill={color}
      />
      <path
        d='M9.42546 10.2538C9.83762 10.2125 10.2052 10.5133 10.2464 10.9254L10.7464 15.9254C10.7876 16.3376 10.4869 16.7051 10.0747 16.7463C9.66256 16.7875 9.29503 16.4868 9.25381 16.0747L8.75381 11.0747C8.7126 10.6625 9.01331 10.295 9.42546 10.2538Z'
        fill={color}
      />
      <path
        d='M14.5747 10.2538C14.9869 10.295 15.2876 10.6625 15.2464 11.0747L14.7464 16.0747C14.7052 16.4868 14.3376 16.7875 13.9255 16.7463C13.5133 16.7051 13.2126 16.3376 13.2538 15.9254L13.7538 10.9254C13.795 10.5133 14.1626 10.2125 14.5747 10.2538Z'
        fill={color}
      />
    </svg>
  );
};
export const IconTicketDate = ({ color = '#ffffff' }) => {
  return (
    <svg width='128' height='116' viewBox='0 0 128 116' fill='none' xmlns='http://www.w3.org/2000/svg' stroke={color} strokeOpacity='0'>
      <path
        d='M1 8C1 4.134 4.13401 1 8 1H105.31C108.432 1 111.176 3.06684 112.038 6.06698L126.404 56.067C126.767 57.3301 126.767 58.6699 126.404 59.933L112.038 109.933C111.176 112.933 108.432 115 105.31 115H8.00001C4.13401 115 1 111.866 1 108V8Z'
        stroke='white'
        strokeOpacity='1'
        strokeWidth='2'
      ></path>
    </svg>
  );
};
export const IconEventsClandarAddSVG = ({ color = '#ffffff' }) => {
  return (
    <svg width='18' height='18' viewBox='0 0 1080 1080' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M926 695V297.75C926 272.157 915.833 247.611 897.736 229.514C879.639 211.417 855.093 201.25 829.5 201.25H250.5C224.907 201.25 200.361 211.417 182.264 229.514C164.167 247.611 154 272.157 154 297.75V876.75C154 902.343 164.167 926.889 182.264 944.986C200.361 963.083 224.907 973.25 250.5 973.25H645'
        stroke={color}
        strokeWidth='40'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M733 104.75V297.75' stroke={color} strokeWidth='40' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M347 104.75V297.75' stroke={color} strokeWidth='40' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M154 408.189H926' stroke={color} strokeWidth='40' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M281.594 587.25H357.234' stroke={color} strokeWidth='64' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M281.594 752.372H357.234' stroke={color} strokeWidth='64' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M501.984 587.25H577.624' stroke={color} strokeWidth='64' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M501.984 752.372H577.624' stroke={color} strokeWidth='64' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M722.367 587.25H798.007' stroke={color} strokeWidth='64' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M722 905H986' stroke={color} strokeWidth='40' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M854 1037V773' stroke={color} strokeWidth='40' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
};
export const IconEventsLocationSVG = ({ color = '#ffffff' }) => {
  return (
    <svg width='18' height='18' viewBox='0 0 1080 1080' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M473.473 904.609L473.121 903.853L472.708 903.129L269.542 547.275C168.771 347.773 314.281 109 540 109C765.61 109 911.156 347.576 810.546 547.097L598.09 902.789L597.562 903.675L597.127 904.61C585.65 929.281 573.901 946.401 562.812 957.093C551.827 967.685 542.595 970.995 535.313 971C528.034 971.005 518.807 967.71 507.82 957.128C496.728 946.444 484.967 929.318 473.473 904.609ZM660.916 411.334C660.916 344.686 606.669 290.539 540 290.539C473.33 290.539 419.083 344.688 419.083 411.334C419.083 477.98 473.331 532.127 540 532.127C606.669 532.127 660.916 477.98 660.916 411.334Z'
        stroke={color}
        strokeWidth='40'
      />
    </svg>
  );
};
export const IconEventsWalletSVG = ({ color = '#ffffff' }) => {
  return (
    <svg width='32' height='32' viewBox='0 0 1080 1080' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M941 563.5V408C941 374.863 914.137 348 881 348H167C133.863 348 107 374.863 107 408V933C107 966.137 133.863 993 167 993H881C914.137 993 941 966.137 941 933V778.5'
        stroke={color}
        strokeWidth='40'
      />
      <path
        d='M245.998 347.5L348.069 287.688L657.545 108.108C686.206 91.4769 722.923 101.229 739.554 129.89L754.124 155M866 348.617L840.683 304.168L787.906 213.967M754.124 155L411.498 347.5M754.124 155L787.906 213.967M787.906 213.967L559 347.5'
        stroke={color}
        strokeWidth='40'
      />
      <path
        d='M771.046 573C796 573 889.258 573 943.056 573C964.595 573 982 590.461 982 612V737C982 758.539 964.584 776 943.045 776C890.182 776 799.097 776 771.046 776C730.717 776 690 739 690 670.5C690 602 735.371 573 771.046 573Z'
        stroke={color}
        strokeWidth='40'
      />
      <circle cx='792' cy='675' r='38' fill={color} />
    </svg>
  );
};
export const IconEventsCalendarSVG = ({ color = '#ffffff' }) => {
  return (
    <svg width='18' height='18' viewBox='0 0 1080 1080' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M154 297.75C154 272.157 164.167 247.611 182.264 229.514C200.361 211.417 224.907 201.25 250.5 201.25H829.5C855.093 201.25 879.639 211.417 897.736 229.514C915.833 247.611 926 272.157 926 297.75V876.75C926 902.343 915.833 926.889 897.736 944.986C879.639 963.083 855.093 973.25 829.5 973.25H250.5C224.907 973.25 200.361 963.083 182.264 944.986C164.167 926.889 154 902.343 154 876.75V297.75Z'
        stroke={color}
        strokeWidth='40'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M733 104.75V297.75' stroke={color} strokeWidth='40' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M347 104.75V297.75' stroke={color} strokeWidth='40' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M154 408.189H926' stroke={color} strokeWidth='40' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M281.594 587.25H357.234' stroke={color} strokeWidth='64' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M281.594 752.372H357.234' stroke={color} strokeWidth='64' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M501.984 587.25H577.624' stroke={color} strokeWidth='64' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M501.984 752.372H577.624' stroke={color} strokeWidth='64' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M722.367 587.25H798.007' stroke={color} strokeWidth='64' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M722.367 752.372H798.007' stroke={color} strokeWidth='64' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
};
export const IconSendPulseSVG = ({ isActive = false }) => {
  return (
    <svg width='20' height='20' viewBox='0 0 58 55' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M53.804 36.7292C54.44 36.4092 55.077 36.0253 55.587 35.4494C56.096 34.9375 56.478 34.2976 56.733 33.5938C56.988 32.8899 57.051 32.122 57.051 31.4182C56.988 30.6503 56.797 29.9464 56.478 29.3065C56.16 28.6667 55.714 28.0908 55.141 27.5789C54.568 27.131 53.931 26.747 53.23 26.5551C52.53 26.3631 51.829 26.2991 51.065 26.3631C51.002 26.3631 50.938 26.3631 50.874 26.3631C50.683 26.3631 50.492 26.4271 50.301 26.4911H50.237C50.046 26.5551 49.7917 26.619 49.6006 26.747C49.5369 26.747 49.537 26.811 49.4733 26.811C49.2823 26.875 49.0912 27.003 48.9638 27.1309C48.9638 27.1309 48.9002 27.131 48.9002 27.1949C48.5181 27.4509 48.136 27.7708 47.8176 28.1548C47.4992 28.5387 47.2445 28.9226 46.9897 29.3705H37.0556L33.4895 0H28.3951L16.9326 44.4077L13.2391 28.5387H0.120895V33.3378H9.4819L14.3854 54.1979H19.3524L30.0507 13.3735L32.789 34.1696H46.9261C47.1171 34.6176 47.4356 35.0015 47.754 35.3854C48.0724 35.7693 48.4544 36.0253 48.8365 36.3452C48.8365 36.3452 48.9002 36.3452 48.9002 36.4092C49.0912 36.5372 49.2823 36.6012 49.4096 36.7292C49.4733 36.7292 49.4733 36.7932 49.537 36.7932C49.728 36.8571 49.9827 36.9851 50.174 37.0491H50.237C50.428 37.1131 50.62 37.1131 50.811 37.1771C50.874 37.1771 50.938 37.1771 51.002 37.1771C51.256 37.2411 51.447 37.2411 51.702 37.2411C52.403 37.1771 53.167 36.9851 53.804 36.7292Z'
        fill={isActive ? '#009FC1' : '#fff'}
      />
    </svg>
  );
};

export const IconEditSent = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' id='Layer_1' enableBackground='new 0 0 512 512' height='15' viewBox='0 0 512 512' width='15'>
      <path clipRule='evenodd' d='m256 0c-141.2 0-256 114.8-256 256s114.8 256 256 256 256-114.8 256-256-114.8-256-256-256z' fill='#4bae4f' fillRule='evenodd' />
      <path
        d='m206.7 373.1c-32.7-32.7-65.2-65.7-98-98.4-3.6-3.6-3.6-9.6 0-13.2l37.7-37.7c3.6-3.6 9.6-3.6 13.2 0l53.9 53.9 138.6-138.7c3.7-3.6 9.6-3.6 13.3 0l37.8 37.8c3.7 3.7 3.7 9.6 0 13.2l-183.3 183.1c-3.6 3.7-9.5 3.7-13.2 0z'
        fill='#fff'
      />
    </svg>
  );
};

export const IconEditSheduled = () => {
  return (
    <svg
      width={15}
      height={15}
      fill='#757575'
      className='MuiSvgIcon-root MuiSvgIcon-fontSizeMedium w-5 h-5 mr-1 css-vubbuv'
      focusable='false'
      aria-hidden='true'
      viewBox='0 0 24 24'
      data-testid='ModeIcon'
    >
      <path d='M3 17.25V21h3.75L17.81 9.94l-3.75-3.75zM20.71 5.63l-2.34-2.34a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83c.39-.39.39-1.02 0-1.41z'></path>
    </svg>
  );
};

export const IconEditDraft = () => {
  return (
    <svg
      width={15}
      height={15}
      fill='#757575'
      className='MuiSvgIcon-root MuiSvgIcon-fontSizeMedium w-5 h-5 mr-1 css-vubbuv'
      focusable='false'
      aria-hidden='true'
      viewBox='0 0 24 24'
      data-testid='ModeIcon'
    >
      <path d='M3 17.25V21h3.75L17.81 9.94l-3.75-3.75zM20.71 5.63l-2.34-2.34a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83c.39-.39.39-1.02 0-1.41z'></path>
    </svg>
  );
};

export const IconEditFailed = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' id='Icons' height='15' viewBox='0 0 60 60' width='15'>
      <circle cx='30' cy='30' fill='#f74850' r='29' />
      <path
        d='m34.218 30 7.373 7.373a1.4 1.4 0 0 1 0 1.976l-2.242 2.242a1.4 1.4 0 0 1 -1.976 0l-7.373-7.373-7.373 7.373a1.4 1.4 0 0 1 -1.976 0l-2.242-2.242a1.4 1.4 0 0 1 0-1.976l7.373-7.373-7.373-7.373a1.4 1.4 0 0 1 0-1.976l2.242-2.242a1.4 1.4 0 0 1 1.976 0l7.373 7.373 7.373-7.373a1.4 1.4 0 0 1 1.976 0l2.242 2.242a1.4 1.4 0 0 1 0 1.976z'
        fill='#fff'
      />
    </svg>
  );
};

export const IconAvaliableSVG = () => {
  return (
    <svg width='24px' height='24px' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M16 3.93552C14.795 3.33671 13.4368 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 11.662 20.9814 11.3283 20.9451 11M21 5L12 14L9 11'
        stroke='#50ad75'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};
export const IconSoldoutSVG = () => {
  return (
    <svg width='24px' height='24px' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g>
        <path
          d='M5.75 5.75L18.25 18.25M12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21Z'
          stroke='#eb3032'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
    </svg>
  );
};

export const IconOpenMenu = () => {
  return (
    <svg width='24px' height='24px' fill='#9e9e9e' focusable='false' aria-hidden='true' viewBox='0 0 24 24' data-testid='MenuOpenIcon'>
      <path d='M3 18h13v-2H3zm0-5h10v-2H3zm0-7v2h13V6zm18 9.59L17.42 12 21 8.41 19.59 7l-5 5 5 5z'></path>
    </svg>
  );
};

export const IconCloseMenu = () => {
  return (
    <svg width='24px' height='24px' fill='#9e9e9e' focusable='false' aria-hidden='true' viewBox='0 0 24 24' data-testid='MenuOpenIcon' style={{ transform: 'scaleX(-1)' }}>
      <path d='M3 18h13v-2H3zm0-5h10v-2H3zm0-7v2h13V6zm18 9.59L17.42 12 21 8.41 19.59 7l-5 5 5 5z'></path>
    </svg>
  );
};

export const IconClose = ({ color }) => {
  return (
    <svg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M11.8499 10.44C11.9445 10.5339 11.9978 10.6617 11.9978 10.795C11.9978 10.9283 11.9445 11.0561 11.8499 11.15L11.1499 11.85C11.056 11.9446 10.9282 11.9979 10.7949 11.9979C10.6615 11.9979 10.5337 11.9446 10.4399 11.85L5.99985 7.40997L1.55985 11.85C1.46597 11.9446 1.33817 11.9979 1.20485 11.9979C1.07153 11.9979 0.943736 11.9446 0.849852 11.85L0.149852 11.15C0.055196 11.0561 0.00195312 10.9283 0.00195312 10.795C0.00195312 10.6617 0.055196 10.5339 0.149852 10.44L4.58985 5.99997L0.149852 1.55997C0.055196 1.46609 0.00195313 1.33829 0.00195313 1.20497C0.00195313 1.07166 0.055196 0.943858 0.149852 0.849974L0.849852 0.149974C0.943736 0.055318 1.07153 0.0020752 1.20485 0.0020752C1.33817 0.0020752 1.46597 0.055318 1.55985 0.149974L5.99985 4.58997L10.4399 0.149974C10.5337 0.055318 10.6615 0.0020752 10.7949 0.0020752C10.9282 0.0020752 11.056 0.055318 11.1499 0.149974L11.8499 0.849974C11.9445 0.943858 11.9978 1.07166 11.9978 1.20497C11.9978 1.33829 11.9445 1.46609 11.8499 1.55997L7.40985 5.99997L11.8499 10.44Z'
        fill={color}
      />
    </svg>
  );
};

export const IconPreviewSVG = () => {
  return (
    <svg width='30' height='30' viewBox='0 0 512 512' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M213.334 256C213.334 267.316 217.829 278.168 225.831 286.17C233.832 294.171 244.685 298.666 256.001 298.666C267.317 298.666 278.169 294.171 286.171 286.17C294.172 278.168 298.667 267.316 298.667 256C298.667 244.684 294.172 233.831 286.171 225.83C278.169 217.828 267.317 213.333 256.001 213.333C244.685 213.333 233.832 217.828 225.831 225.83C217.829 233.831 213.334 244.684 213.334 256Z'
        stroke='white'
        strokeWidth='25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M448 256C396.8 341.333 332.8 384 256 384C179.2 384 115.2 341.333 64 256C115.2 170.667 179.2 128 256 128C332.8 128 396.8 170.667 448 256Z'
        stroke='white'
        strokeWidth='25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export const IconTabPlain = () => {
  return (
    <svg width='45' height='45' viewBox='0 0 180 152' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M21 92H160' stroke='#A9ACBA' strokeWidth='3' strokeLinecap='round' />
      <rect x='20' y='61' width='59' height='24' rx='5' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
    </svg>
  );
};

export const IconTabRound = () => {
  return (
    <svg width='45' height='45' viewBox='0 0 180 152' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='16' y='52' width='148' height='48' rx='24' fill='#F6F9FE' stroke='#A9ACBA' strokeWidth='2' />
      <rect x='20' y='56' width='57' height='40' rx='20' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
    </svg>
  );
};
export const IconImageSquare = ({ isActive = false }) => {
  return (
    <svg width='60' height='54' viewBox='0 0 120 114' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_1259_5649)'>
        <rect x='1' y='1' width='118' height='112' rx='13' fill='#F6F9FE' stroke='#A9ACBA' strokeWidth='2' />
        <rect x='1' y='1' width='118' height='112' rx='13' fill='#F6F9FE' stroke={isActive ? '#17ce17' : '#A9ACBA'} strokeWidth='2' />
        <path
          d='M24 9H96C103.18 9 109 14.8203 109 22V66C109 73.1797 103.18 79 96 79H24C16.8203 79 11 73.1797 11 66V22C11 14.8203 16.8203 9 24 9Z'
          fill='#B1D0FE'
          stroke='#A9ACBA'
          strokeWidth='2'
        />
      </g>
      <defs>
        <clipPath id='clip0_1259_5649'>
          <rect width='120' height='114' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export const IconImageShowcase = ({ isActive = false }) => {
  return (
    <svg width='60' height='54' viewBox='0 0 120 114' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_2499_5190)'>
        <rect x='1' y='1' width='118' height='112' rx='13' fill='#F6F9FE' stroke='#A9ACBA' strokeWidth='2' />
        <rect x='1' y='1' width='118' height='112' rx='13' fill='#F6F9FE' stroke={isActive ? '#17ce17' : '#A9ACBA'} strokeWidth='2' />
        <path
          d='M38 9H82C89.1797 9 95 14.8203 95 22V66C95 73.1797 89.1797 79 82 79H38C30.8203 79 25 73.1797 25 66V22C25 14.8203 30.8203 9 38 9Z'
          fill='#B1D0FE'
          stroke='#A9ACBA'
          strokeWidth='2'
        />
      </g>
      <defs>
        <clipPath id='clip0_2499_5190'>
          <rect width='120' height='114' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export const IconLinkImageSquare = ({ isActive = false }) => {
  return (
    <svg width='60' height='54' viewBox='0 0 160 160' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='11' y='11' width='138' height='138' rx='13' fill='#EDF3FD' stroke={isActive ? '#17ce17' : '#A9ACBA'} strokeWidth='2' />
      <path
        d='M45 32H115C122.18 32 128 37.8203 128 45V116C128 123.18 122.18 129 115 129H45C37.8203 129 32 123.18 32 116V45C32 37.8203 37.8203 32 45 32Z'
        fill='#B1D0FE'
        stroke='#A9ACBA'
        strokeWidth='2'
      />
    </svg>
  );
};

export const IconLinkImageRound = ({ isActive = false }) => {
  return (
    <svg width='60' height='54' viewBox='0 0 160 160' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='11' y='11' width='138' height='138' rx='13' fill='#EDF3FD' stroke={isActive ? '#17ce17' : '#A9ACBA'} strokeWidth='2' />
      <path
        d='M80 32C106.51 32 128 53.4903 128 80V81C128 107.51 106.51 129 80 129C53.4903 129 32 107.51 32 81V80C32 53.4903 53.4903 32 80 32Z'
        fill='#B1D0FE'
        stroke='#A9ACBA'
        strokeWidth='2'
      />
    </svg>
  );
};

export const IconImageFull = ({ isActive = false }) => {
  return (
    <svg width='60' height='54' viewBox='0 0 120 114' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_1259_5660)'>
        <rect x='1' y='1' width='118' height='112' rx='13' fill='#F6F9FE' stroke='#A9ACBA' strokeWidth='2' />
        <rect x='1' y='1' width='118' height='112' rx='13' fill='#F6F9FE' stroke={isActive ? '#17ce17' : '#A9ACBA'} strokeWidth='4' />
        <path d='M14 1H106C113.18 1 119 6.8203 119 14V79H1V14C1 6.8203 6.8203 1 14 1Z' fill='#B1D0FE' stroke={isActive ? '#17ce17' : '#A9ACBA'} strokeWidth='4' />
      </g>
      <defs>
        <clipPath id='clip0_1259_5660'>
          <rect width='120' height='114' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export const IconItemAlignLeft = ({ isActive = false }) => {
  return (
    <svg width='60' height='54' viewBox='0 0 120 114' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_1261_593)'>
        <rect x='1' y='1' width='118' height='112' rx='13' fill='#F6F9FE' stroke='#A9ACBA' strokeWidth='2' />
        <rect x='1' y='1' width='118' height='112' rx='13' fill='#F6F9FE' stroke={isActive ? '#17ce17' : '#A9ACBA'} strokeWidth='4' />
        <path
          d='M22 81H49C55.0751 81 60 85.9249 60 92C60 98.0751 55.0751 103 49 103H22C15.9249 103 11 98.0751 11 92C11 85.9249 15.9249 81 22 81Z'
          fill='#B1D0FE'
          stroke={isActive ? '#17ce17' : '#A9ACBA'}
          strokeWidth='4'
        />
      </g>
      <defs>
        <clipPath id='clip0_1261_593'>
          <rect width='120' height='114' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export const IconItemAlignCenter = ({ isActive = false }) => {
  return (
    <svg width='60' height='54' viewBox='0 0 120 114' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_1261_589)'>
        <rect x='1' y='1' width='118' height='112' rx='13' fill='#F6F9FE' stroke='#A9ACBA' strokeWidth='2' />
        <rect x='1' y='1' width='118' height='112' rx='13' fill='#F6F9FE' stroke={isActive ? '#17ce17' : '#A9ACBA'} strokeWidth='4' />
        <path
          d='M46 80H73C79.0751 80 84 84.9249 84 91C84 97.0751 79.0751 102 73 102H46C39.9249 102 35 97.0751 35 91C35 84.9249 39.9249 80 46 80Z'
          fill='#B1D0FE'
          stroke={isActive ? '#17ce17' : '#A9ACBA'}
          strokeWidth='4'
        />
      </g>
      <defs>
        <clipPath id='clip0_1261_589'>
          <rect width='120' height='114' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export const IconItemAlignRight = ({ isActive = false }) => {
  return (
    <svg width='60' height='54' viewBox='0 0 120 114' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_1261_597)'>
        <rect x='1' y='1' width='118' height='112' rx='13' fill='#F6F9FE' stroke='#A9ACBA' strokeWidth='2' />
        <rect x='1' y='1' width='118' height='112' rx='13' fill='#F6F9FE' stroke={isActive ? '#17ce17' : '#A9ACBA'} strokeWidth='4' />
        <path
          d='M70 81H97C103.075 81 108 85.9249 108 92C108 98.0751 103.075 103 97 103H70C63.9249 103 59 98.0751 59 92C59 85.9249 63.9249 81 70 81Z'
          fill='#B1D0FE'
          stroke={isActive ? '#17ce17' : '#A9ACBA'}
          strokeWidth='4'
        />
      </g>
      <defs>
        <clipPath id='clip0_1261_597'>
          <rect width='120' height='114' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export const IconItemAlignFull = ({ isActive = false }) => {
  return (
    <svg width='60' height='54' viewBox='0 0 120 114' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_1637_5041)'>
        <rect x='1' y='1' width='118' height='112' rx='13' fill='#F6F9FE' stroke='#A9ACBA' strokeWidth='2' />
        <rect x='1' y='1' width='118' height='112' rx='13' fill='#F6F9FE' stroke={isActive ? '#17ce17' : '#A9ACBA'} strokeWidth='2' />
        <path
          d='M23 81H97C103.075 81 108 85.9249 108 92C108 98.0751 103.075 103 97 103H23C16.9249 103 12 98.0751 12 92C12 85.9249 16.9249 81 23 81Z'
          fill='#B1D0FE'
          stroke={isActive ? '#17ce17' : '#A9ACBA'}
          strokeWidth='2'
        />
      </g>
      <defs>
        <clipPath id='clip0_1637_5041'>
          <rect width='120' height='114' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export const IconLabelAlignNewCenter = ({ isActive = false }) => {
  return (
    <svg width='60' height='54' viewBox='0 0 120 114' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_1291_5688)'>
        <rect x='1' y='1' width='118' height='112' rx='13' fill='#F6F9FE' stroke='#A9ACBA' strokeWidth='2' />
        <rect x='1' y='1' width='118' height='112' rx='13' fill='#F6F9FE' stroke={isActive ? '#17ce17' : '#A9ACBA'} strokeWidth='4' />
        <path
          d='M69 20.5V94.5C69 99.7467 64.7467 104 59.5 104C54.2533 104 50 99.7467 50 94.5V20.5C50 15.2533 54.2533 11 59.5 11C64.7467 11 69 15.2533 69 20.5Z'
          fill='#B1D0FE'
          stroke='#A9ACBA'
          strokeWidth='2'
        />
        <path
          d='M74.9393 55.9393C74.3536 56.5251 74.3536 57.4749 74.9393 58.0607L84.4853 67.6066C85.0711 68.1924 86.0208 68.1924 86.6066 67.6066C87.1924 67.0208 87.1924 66.0711 86.6066 65.4853L78.1213 57L86.6066 48.5147C87.1924 47.9289 87.1924 46.9792 86.6066 46.3934C86.0208 45.8076 85.0711 45.8076 84.4853 46.3934L74.9393 55.9393ZM112 58.5C112.828 58.5 113.5 57.8284 113.5 57C113.5 56.1716 112.828 55.5 112 55.5V58.5ZM76 58.5H112V55.5H76V58.5Z'
          fill='#A9ACBA'
        />
        <path
          d='M8 55.5C7.17157 55.5 6.5 56.1716 6.5 57C6.5 57.8284 7.17157 58.5 8 58.5V55.5ZM45.0607 58.0607C45.6464 57.4749 45.6464 56.5251 45.0607 55.9393L35.5147 46.3934C34.9289 45.8076 33.9792 45.8076 33.3934 46.3934C32.8076 46.9792 32.8076 47.9289 33.3934 48.5147L41.8787 57L33.3934 65.4853C32.8076 66.0711 32.8076 67.0208 33.3934 67.6066C33.9792 68.1924 34.9289 68.1924 35.5147 67.6066L45.0607 58.0607ZM8 58.5H44V55.5H8V58.5Z'
          fill='#A9ACBA'
        />
      </g>
      <defs>
        <clipPath id='clip0_1291_5688'>
          <rect width='120' height='114' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export const IconLabelAlignNewLeft = ({ isActive = false }) => {
  return (
    <svg width='60' height='54' viewBox='0 0 120 114' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_1291_5692)'>
        <rect x='1' y='1' width='118' height='112' rx='13' fill='#F6F9FE' stroke='#A9ACBA' strokeWidth='2' />
        <rect x='1' y='1' width='118' height='112' rx='13' fill='#F6F9FE' stroke={isActive ? '#17ce17' : '#A9ACBA'} strokeWidth='4' />
        <path
          d='M34.9393 55.9393C34.3536 56.5251 34.3536 57.4749 34.9393 58.0607L44.4853 67.6066C45.0711 68.1924 46.0208 68.1924 46.6066 67.6066C47.1924 67.0208 47.1924 66.0711 46.6066 65.4853L38.1213 57L46.6066 48.5147C47.1924 47.9289 47.1924 46.9792 46.6066 46.3934C46.0208 45.8076 45.0711 45.8076 44.4853 46.3934L34.9393 55.9393ZM72 58.5C72.8284 58.5 73.5 57.8284 73.5 57C73.5 56.1716 72.8284 55.5 72 55.5V58.5ZM36 58.5H72V55.5H36V58.5Z'
          fill='#A9ACBA'
        />
        <path
          d='M29 20.5V94.5C29 99.7467 24.7467 104 19.5 104C14.2533 104 10 99.7467 10 94.5V20.5C10 15.2533 14.2533 11 19.5 11C24.7467 11 29 15.2533 29 20.5Z'
          fill='#B1D0FE'
          stroke='#A9ACBA'
          strokeWidth='2'
        />
      </g>
      <defs>
        <clipPath id='clip0_1291_5692'>
          <rect width='120' height='114' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export const IconLabelAlignNewRight = ({ isActive = false }) => {
  return (
    <svg width='60' height='54' viewBox='0 0 120 114' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_1291_5696)'>
        <rect x='1' y='1' width='118' height='112' rx='13' fill='#F6F9FE' stroke='#A9ACBA' strokeWidth='2' />
        <rect x='1' y='1' width='118' height='112' rx='13' fill='#F6F9FE' stroke={isActive ? '#17ce17' : '#A9ACBA'} strokeWidth='4' />
        <path
          d='M47 55.5C46.1716 55.5 45.5 56.1716 45.5 57C45.5 57.8284 46.1716 58.5 47 58.5V55.5ZM84.0607 58.0607C84.6464 57.4749 84.6464 56.5251 84.0607 55.9393L74.5147 46.3934C73.9289 45.8076 72.9792 45.8076 72.3934 46.3934C71.8076 46.9792 71.8076 47.9289 72.3934 48.5147L80.8787 57L72.3934 65.4853C71.8076 66.0711 71.8076 67.0208 72.3934 67.6066C72.9792 68.1924 73.9289 68.1924 74.5147 67.6066L84.0607 58.0607ZM47 58.5H83V55.5H47V58.5Z'
          fill='#A9ACBA'
        />
        <path
          d='M109 20.5V94.5C109 99.7467 104.747 104 99.5 104C94.2533 104 90 99.7467 90 94.5V20.5C90 15.2533 94.2533 11 99.5 11C104.747 11 109 15.2533 109 20.5Z'
          fill='#B1D0FE'
          stroke='#A9ACBA'
          strokeWidth='2'
        />
      </g>
      <defs>
        <clipPath id='clip0_1291_5696'>
          <rect width='120' height='114' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export const IconLabelPositionTop = ({ isActive = false }) => {
  return (
    <svg width='60' height='54' viewBox='0 0 120 114' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_1295_2)'>
        <rect x='1' y='1' width='118' height='112' rx='13' fill='#F6F9FE' stroke='#A9ACBA' strokeWidth='2' />
        <rect x='1' y='1' width='118' height='112' rx='13' fill='#F6F9FE' stroke={isActive ? '#17ce17' : '#A9ACBA'} strokeWidth='4' />
        <path
          d='M11 23C11 16.9249 15.9249 12 22 12H98C104.075 12 109 16.9249 109 23C109 29.0751 104.075 34 98 34H22C15.9249 34 11 29.0751 11 23Z'
          fill='#B1D0FE'
          stroke='#A9ACBA'
          strokeWidth='2'
        />
      </g>
      <defs>
        <clipPath id='clip0_1295_2'>
          <rect width='120' height='114' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export const IconLabelPositionCenter = ({ isActive = false }) => {
  return (
    <svg width='60' height='54' viewBox='0 0 120 114' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_1335_650)'>
        <rect x='1' y='1' width='118' height='112' rx='13' fill='#F6F9FE' stroke='#A9ACBA' strokeWidth='2' />
        <rect x='1' y='1' width='118' height='112' rx='13' fill='#F6F9FE' stroke={isActive ? '#17ce17' : '#A9ACBA'} strokeWidth='4' />
        <path
          d='M22 46H98C104.075 46 109 50.9249 109 57C109 63.0751 104.075 68 98 68H22C15.9249 68 11 63.0751 11 57C11 50.9249 15.9249 46 22 46Z'
          fill='#B1D0FE'
          stroke='#A9ACBA'
          strokeWidth='2'
        />
      </g>
      <defs>
        <clipPath id='clip0_1335_650'>
          <rect width='120' height='114' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export const IconLabelPositionBottom = ({ isActive = false }) => {
  return (
    <svg width='60' height='54' viewBox='0 0 120 114' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_1261_601)'>
        <rect x='1' y='1' width='118' height='112' rx='13' fill='#F6F9FE' stroke='#A9ACBA' strokeWidth='2' />
        <rect x='1' y='1' width='118' height='112' rx='13' fill='#F6F9FE' stroke={isActive ? '#17ce17' : '#A9ACBA'} strokeWidth='4' />
        <path
          d='M11 92C11 85.9249 15.9249 81 22 81H98C104.075 81 109 85.9249 109 92C109 98.0751 104.075 103 98 103H22C15.9249 103 11 98.0751 11 92Z'
          fill='#B1D0FE'
          stroke='#A9ACBA'
          strokeWidth='2'
        />
      </g>
      <defs>
        <clipPath id='clip0_1261_601'>
          <rect width='120' height='114' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export const IconLabelAlignRight = ({ isActive = false }) => {
  return (
    <svg width='60' height='54' viewBox='0 0 120 114' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_1291_5708)'>
        <rect x='1' y='1' width='118' height='112' rx='13' fill='#F6F9FE' stroke='#A9ACBA' strokeWidth='2' />
        <rect x='1' y='1' width='118' height='112' rx='13' fill='#F6F9FE' stroke={isActive ? '#17ce17' : '#A9ACBA'} strokeWidth='4' />
        <path
          d='M72 14H99C105.075 14 110 18.9249 110 25C110 31.0751 105.075 36 99 36H72C65.9249 36 61 31.0751 61 25C61 18.9249 65.9249 14 72 14Z'
          fill='#B1D0FE'
          stroke={isActive ? '#17ce17' : '#A9ACBA'}
          strokeWidth='4'
        />
      </g>
      <defs>
        <clipPath id='clip0_1291_5708'>
          <rect width='120' height='114' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export const IconLabelAlignCenter = ({ isActive = false }) => {
  return (
    <svg width='60' height='54' viewBox='0 0 120 114' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_1291_5700)'>
        <rect x='1' y='1' width='118' height='112' rx='13' fill='#F6F9FE' stroke='#A9ACBA' strokeWidth='2' />
        <rect x='1' y='1' width='118' height='112' rx='13' fill='#F6F9FE' stroke={isActive ? '#17ce17' : '#A9ACBA'} strokeWidth='4' />
        <path
          d='M46 14H73C79.0751 14 84 18.9249 84 25C84 31.0751 79.0751 36 73 36H46C39.9249 36 35 31.0751 35 25C35 18.9249 39.9249 14 46 14Z'
          fill='#B1D0FE'
          stroke={isActive ? '#17ce17' : '#A9ACBA'}
          strokeWidth='4'
        />
      </g>
      <defs>
        <clipPath id='clip0_1291_5700'>
          <rect width='120' height='114' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export const IconLabelAlignLeft = ({ isActive = false }) => {
  return (
    <svg width='60' height='54' viewBox='0 0 120 114' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_1291_5704)'>
        <rect x='1' y='1' width='118' height='112' rx='13' fill='#F6F9FE' stroke='#A9ACBA' strokeWidth='2' />
        <rect x='1' y='1' width='118' height='112' rx='13' fill='#F6F9FE' stroke={isActive ? '#17ce17' : '#A9ACBA'} strokeWidth='4' />
        <path
          d='M21 14H48C54.0751 14 59 18.9249 59 25C59 31.0751 54.0751 36 48 36H21C14.9249 36 10 31.0751 10 25C10 18.9249 14.9249 14 21 14Z'
          fill='#B1D0FE'
          stroke={isActive ? '#17ce17' : '#A9ACBA'}
          strokeWidth='4'
        />
      </g>
      <defs>
        <clipPath id='clip0_1291_5704'>
          <rect width='120' height='114' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export const IconLayoutFeed = ({ isActive = false }) => {
  return (
    <svg width='70' height='86' viewBox='0 0 140 252' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='1' y='1' width='138' height='250' rx='13' fill='#EDF3FD' stroke={isActive ? '#17ce17' : '#A9ACBA'} strokeWidth='4' />
      <rect x='13' y='85' width='114' height='40' rx='5' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
      <rect x='13' y='33' width='114' height='40' rx='5' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
      <rect x='13' y='137' width='114' height='40' rx='5' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
      <rect x='13' y='189' width='114' height='40' rx='5' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
    </svg>
  );
};

export const IconLayoutCarousel = ({ isActive = false }) => {
  return (
    <svg width='70' height='86' viewBox='0 0 140 252' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='1' y='1' width='138' height='250' rx='13' fill='#EDF3FD' stroke={isActive ? '#17ce17' : '#A9ACBA'} strokeWidth='4' />
      <rect x='13' y='68' width='80' height='109' rx='13' fill='#F6F9FE' stroke='#A9ACBA' strokeWidth='2' />
      <path d='M26 68H80C87.1797 68 93 73.8203 93 81V121H13V81C13 73.8203 18.8203 68 26 68Z' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
      <path d='M117 67H139V176H117C109.82 176 104 170.18 104 163V80C104 72.8203 109.82 67 117 67Z' fill='#F6F9FE' stroke='#A9ACBA' strokeWidth='2' />
      <path d='M117 67H139V120H104V80C104 72.8203 109.82 67 117 67Z' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
    </svg>
  );
};

export const IconButtonPositionTop = ({ isActive = false }) => {
  return (
    <svg width='60' height='54' viewBox='0 0 120 114' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_1295_2)'>
        <rect x='1' y='1' width='118' height='112' rx='13' fill='#F6F9FE' stroke='#A9ACBA' strokeWidth='2' />
        <rect x='1' y='1' width='118' height='112' rx='13' fill='#F6F9FE' stroke={isActive ? '#17ce17' : '#A9ACBA'} strokeWidth='4' />
        <path
          d='M22 12H98C104.075 12 109 16.9249 109 23C109 29.0751 104.075 34 98 34H22C15.9249 34 11 29.0751 11 23C11 16.9249 15.9249 12 22 12Z'
          fill='#B1D0FE'
          stroke='#A9ACBA'
          strokeWidth='2'
        />
      </g>
      <defs>
        <clipPath id='clip0_1295_2'>
          <rect width='120' height='114' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export const IconButtonPositionBottom = ({ isActive = false }) => {
  return (
    <svg width='60' height='54' viewBox='0 0 120 114' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_1261_601)'>
        <rect x='1' y='1' width='118' height='112' rx='13' fill='#F6F9FE' stroke='#A9ACBA' strokeWidth='2' />
        <rect x='1' y='1' width='118' height='112' rx='13' fill='#F6F9FE' stroke={isActive ? '#17ce17' : '#A9ACBA'} strokeWidth='4' />
        <path
          d='M11 92C11 85.9249 15.9249 81 22 81H98C104.075 81 109 85.9249 109 92C109 98.0751 104.075 103 98 103H22C15.9249 103 11 98.0751 11 92Z'
          fill='#B1D0FE'
          stroke='#A9ACBA'
          strokeWidth='2'
        />
      </g>
      <defs>
        <clipPath id='clip0_1261_601'>
          <rect width='120' height='114' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export const IconVideoIndividual = () => {
  return (
    <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg' name='youtube-individual'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5 7.33333C5 7.30694 5.01027 7.24087 5.10881 7.15875C5.2095 7.07484 5.37992 7 5.6 7H26.4C26.6201 7 26.7905 7.07484 26.8912 7.15875C26.9897 7.24087 27 7.30694 27 7.33333V24.6667C27 24.6931 26.9897 24.7591 26.8912 24.8413C26.7905 24.9252 26.6201 25 26.4 25H5.6C5.37992 25 5.2095 24.9252 5.10881 24.8413C5.01027 24.7591 5 24.6931 5 24.6667V7.33333ZM5.6 5C4.34252 5 3 5.8817 3 7.33333V24.6667C3 26.1183 4.34252 27 5.6 27H26.4C27.6575 27 29 26.1183 29 24.6667V7.33333C29 5.8817 27.6575 5 26.4 5H5.6ZM19.2632 17.3073C20.2456 16.7263 20.2456 15.2737 19.2632 14.6927L14.2105 11.7045C13.2281 11.1235 12 11.8498 12 13.0118V18.9882C12 20.1502 13.2281 20.8765 14.2105 20.2955L19.2632 17.3073ZM14.1053 14.1324L17.2632 16L14.1053 17.8676V14.1324Z'
        fill='#121212'
      ></path>
    </svg>
  );
};

export const IconVideoCollection = () => {
  return (
    <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg' name='youtube-collection'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M29.2632 22.526C30.2456 23.1071 30.2456 24.5597 29.2632 25.1407L24.2105 28.1289C23.2281 28.7099 22 27.9836 22 26.8216L22 20.8452C22 19.6831 23.2281 18.9568 24.2105 19.5379L29.2632 22.526ZM27.2632 23.8334L24.1053 21.9658L24.1053 25.701L27.2632 23.8334Z'
        fill='#121212'
      ></path>
      <rect x='4' y='4' width='24' height='2' rx='1' fill='#121212'></rect>
      <rect x='4' y='12' width='24' height='2' rx='1' fill='#121212'></rect>
      <rect x='4' y='20' width='14' height='2' rx='1' fill='#121212'></rect>
    </svg>
  );
};

export const IconRefreshPaymentSVG = ({ size = 30, color = '#1C274C' }) => {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M3.67981 11.3333H2.92981H3.67981ZM3.67981 13L3.15157 13.5324C3.44398 13.8225 3.91565 13.8225 4.20805 13.5324L3.67981 13ZM5.88787 11.8657C6.18191 11.574 6.18377 11.0991 5.89203 10.8051C5.60029 10.511 5.12542 10.5092 4.83138 10.8009L5.88787 11.8657ZM2.52824 10.8009C2.2342 10.5092 1.75933 10.511 1.46759 10.8051C1.17585 11.0991 1.17772 11.574 1.47176 11.8657L2.52824 10.8009ZM18.6156 7.39279C18.8325 7.74565 19.2944 7.85585 19.6473 7.63892C20.0001 7.42199 20.1103 6.96007 19.8934 6.60721L18.6156 7.39279ZM12.0789 2.25C7.03155 2.25 2.92981 6.3112 2.92981 11.3333H4.42981C4.42981 7.15072 7.84884 3.75 12.0789 3.75V2.25ZM2.92981 11.3333L2.92981 13H4.42981L4.42981 11.3333H2.92981ZM4.20805 13.5324L5.88787 11.8657L4.83138 10.8009L3.15157 12.4676L4.20805 13.5324ZM4.20805 12.4676L2.52824 10.8009L1.47176 11.8657L3.15157 13.5324L4.20805 12.4676ZM19.8934 6.60721C18.287 3.99427 15.3873 2.25 12.0789 2.25V3.75C14.8484 3.75 17.2727 5.20845 18.6156 7.39279L19.8934 6.60721Z'
        fill={color}
      />
      <path
        d='M20.3139 11L20.8411 10.4666C20.549 10.1778 20.0788 10.1778 19.7867 10.4666L20.3139 11ZM18.1004 12.1333C17.8058 12.4244 17.8031 12.8993 18.0942 13.1939C18.3854 13.4885 18.8603 13.4913 19.1549 13.2001L18.1004 12.1333ZM21.4729 13.2001C21.7675 13.4913 22.2424 13.4885 22.5335 13.1939C22.8247 12.8993 22.822 12.4244 22.5274 12.1332L21.4729 13.2001ZM5.31794 16.6061C5.1004 16.2536 4.6383 16.1442 4.28581 16.3618C3.93331 16.5793 3.82391 17.0414 4.04144 17.3939L5.31794 16.6061ZM11.8827 21.75C16.9451 21.75 21.0639 17.6915 21.0639 12.6667H19.5639C19.5639 16.8466 16.1332 20.25 11.8827 20.25V21.75ZM21.0639 12.6667V11H19.5639V12.6667H21.0639ZM19.7867 10.4666L18.1004 12.1333L19.1549 13.2001L20.8411 11.5334L19.7867 10.4666ZM19.7867 11.5334L21.4729 13.2001L22.5274 12.1332L20.8411 10.4666L19.7867 11.5334ZM4.04144 17.3939C5.65405 20.007 8.56403 21.75 11.8827 21.75V20.25C9.10023 20.25 6.66584 18.7903 5.31794 16.6061L4.04144 17.3939Z'
        fill={color}
      />
    </svg>
  );
};

export const IconStatFeedView1 = ({ isActive = false }) => {
  return (
    <svg width='160' height='272' viewBox='0 0 160 272' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='11' y='11' width='138' height='250' rx='13' fill='#F6F9FE' stroke={isActive ? '#17ce17' : '#A9ACBA'} strokeWidth='2' />
      <rect x='23' y='49' width='114' height='114' rx='5' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
      <path d='M28 175H132C134.761 175 137 177.239 137 180V261H23V180C23 177.239 25.2386 175 28 175Z' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
    </svg>
  );
};
export const IconStatFeedView2 = ({ isActive = false }) => {
  return (
    <svg width='160' height='272' viewBox='0 0 160 272' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='11' y='11' width='138' height='250' rx='13' fill='#EDF3FD' stroke={isActive ? '#17ce17' : '#A9ACBA'} strokeWidth='2' />
      <rect x='23' y='50' width='51' height='51' rx='5' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
      <rect x='23' y='111' width='51' height='51' rx='5' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
      <rect x='86' y='50' width='51' height='51' rx='5' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
      <rect x='86' y='111' width='51' height='51' rx='5' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
      <rect x='23' y='172' width='51' height='51' rx='5' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
      <rect x='86' y='172' width='51' height='51' rx='5' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
    </svg>
  );
};
export const IconStatSliderView1 = ({ isActive = false }) => {
  return (
    <svg width='160' height='272' viewBox='0 0 160 272' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='11' y='11' width='138' height='250' rx='13' fill='#F6F9FE' stroke={isActive ? '#17ce17' : '#A9ACBA'} strokeWidth='2' />
      <rect x='21' y='90' width='94' height='93' rx='3' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
      <path d='M127 180L127 93C127 91.3431 128.343 90 130 90L149 90L149 183L130 183C128.343 183 127 181.657 127 180Z' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
    </svg>
  );
};
export const IconStatSliderView2 = ({ isActive = false }) => {
  return (
    <svg width='160' height='272' viewBox='0 0 160 272' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='11' y='11' width='138' height='250' rx='13' fill='#F6F9FE' stroke={isActive ? '#17ce17' : '#A9ACBA'} strokeWidth='2' />
      <rect x='21' y='112' width='46' height='46' rx='3' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
      <rect x='77' y='112' width='46' height='46' rx='3' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
      <path d='M136 112H149V158H136C134.343 158 133 156.657 133 155V115C133 113.343 134.343 112 136 112Z' fill='#B1D0FE' stroke='#A9ACBA' strokeWidth='2' />
    </svg>
  );
};

export const IconLinkChannelTypeSVG = ({ size = 15, color = '#1C274C' }) => {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M12 1.25H11.9426C9.63423 1.24999 7.82519 1.24998 6.41371 1.43975C4.96897 1.63399 3.82895 2.03933 2.93414 2.93414C2.03933 3.82895 1.63399 4.96897 1.43975 6.41371C1.24998 7.82519 1.24999 9.63423 1.25 11.9426V12.0574C1.24999 14.3658 1.24998 16.1748 1.43975 17.5863C1.63399 19.031 2.03933 20.1711 2.93414 21.0659C3.82895 21.9607 4.96897 22.366 6.41371 22.5603C7.82519 22.75 9.63423 22.75 11.9426 22.75H12.0574C14.3658 22.75 16.1748 22.75 17.5863 22.5603C19.031 22.366 20.1711 21.9607 21.0659 21.0659C21.9607 20.1711 22.366 19.031 22.5603 17.5863C22.75 16.1748 22.75 14.3658 22.75 12.0574V12C22.75 11.5858 22.4142 11.25 22 11.25C21.5858 11.25 21.25 11.5858 21.25 12C21.25 14.3782 21.2484 16.0864 21.0736 17.3864C20.9018 18.6648 20.5749 19.4355 20.0052 20.0052C19.4355 20.5749 18.6648 20.9018 17.3864 21.0736C16.0864 21.2484 14.3782 21.25 12 21.25C9.62178 21.25 7.91356 21.2484 6.61358 21.0736C5.33517 20.9018 4.56445 20.5749 3.9948 20.0052C3.42514 19.4355 3.09825 18.6648 2.92637 17.3864C2.75159 16.0864 2.75 14.3782 2.75 12C2.75 9.62178 2.75159 7.91356 2.92637 6.61358C3.09825 5.33517 3.42514 4.56445 3.9948 3.9948C4.56445 3.42514 5.33517 3.09825 6.61358 2.92637C7.91356 2.75159 9.62178 2.75 12 2.75C12.4142 2.75 12.75 2.41421 12.75 2C12.75 1.58579 12.4142 1.25 12 1.25Z'
        fill={color}
      />
      <path
        d='M12.4697 10.4697C12.1768 10.7626 12.1768 11.2374 12.4697 11.5303C12.7626 11.8232 13.2374 11.8232 13.5303 11.5303L21.25 3.81066V7.34375C21.25 7.75796 21.5858 8.09375 22 8.09375C22.4142 8.09375 22.75 7.75796 22.75 7.34375V2C22.75 1.58579 22.4142 1.25 22 1.25H16.6562C16.242 1.25 15.9062 1.58579 15.9062 2C15.9062 2.41421 16.242 2.75 16.6562 2.75H20.1893L12.4697 10.4697Z'
        fill={color}
      />
    </svg>
  );
};

export const IconMenuAgentsSVG = ({ size = 24, isActive = false }) => {
  const color = isActive ? '#000' : '#9EA1A8';
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M16 10.5C16 11.3284 15.5523 12 15 12C14.4477 12 14 11.3284 14 10.5C14 9.67157 14.4477 9 15 9C15.5523 9 16 9.67157 16 10.5Z' fill={color} />
      <path d='M10 10.5C10 11.3284 9.55229 12 9 12C8.44772 12 8 11.3284 8 10.5C8 9.67157 8.44772 9 9 9C9.55229 9 10 9.67157 10 10.5Z' fill={color} />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.9426 1.25H12.0574C14.3658 1.24999 16.1748 1.24998 17.5863 1.43975C19.031 1.63399 20.1711 2.03933 21.0659 2.93414C21.9607 3.82895 22.366 4.96897 22.5603 6.41371C22.75 7.82519 22.75 9.63423 22.75 11.9426V12.0574C22.75 14.3658 22.75 16.1748 22.5603 17.5863C22.366 19.031 21.9607 20.1711 21.0659 21.0659C20.1711 21.9607 19.031 22.366 17.5863 22.5603C16.1748 22.75 14.3658 22.75 12.0574 22.75H11.9426C9.63423 22.75 7.82519 22.75 6.41371 22.5603C4.96897 22.366 3.82895 21.9607 2.93414 21.0659C2.03933 20.1711 1.63399 19.031 1.43975 17.5863C1.24998 16.1748 1.24999 14.3658 1.25 12.0574V11.9426C1.24999 9.63423 1.24998 7.82519 1.43975 6.41371C1.63399 4.96897 2.03933 3.82895 2.93414 2.93414C3.82895 2.03933 4.96897 1.63399 6.41371 1.43975C7.82519 1.24998 9.63423 1.24999 11.9426 1.25ZM6.61358 2.92637C5.33517 3.09825 4.56445 3.42514 3.9948 3.9948C3.42514 4.56445 3.09825 5.33517 2.92637 6.61358C2.75159 7.91356 2.75 9.62177 2.75 12C2.75 14.3782 2.75159 16.0864 2.92637 17.3864C3.09825 18.6648 3.42514 19.4355 3.9948 20.0052C4.56445 20.5749 5.33517 20.9018 6.61358 21.0736C7.91356 21.2484 9.62177 21.25 12 21.25C14.3782 21.25 16.0864 21.2484 17.3864 21.0736C18.6648 20.9018 19.4355 20.5749 20.0052 20.0052C20.5749 19.4355 20.9018 18.6648 21.0736 17.3864C21.2484 16.0864 21.25 14.3782 21.25 12C21.25 9.62177 21.2484 7.91356 21.0736 6.61358C20.9018 5.33517 20.5749 4.56445 20.0052 3.9948C19.4355 3.42514 18.6648 3.09825 17.3864 2.92637C16.0864 2.75159 14.3782 2.75 12 2.75C9.62177 2.75 7.91356 2.75159 6.61358 2.92637ZM8.39747 15.5534C8.64413 15.2206 9.11385 15.1508 9.44661 15.3975C10.175 15.9373 11.0541 16.25 12 16.25C12.9459 16.25 13.825 15.9373 14.5534 15.3975C14.8862 15.1508 15.3559 15.2206 15.6025 15.5534C15.8492 15.8862 15.7794 16.3559 15.4466 16.6025C14.4742 17.3233 13.285 17.75 12 17.75C10.715 17.75 9.5258 17.3233 8.55339 16.6025C8.22062 16.3559 8.15082 15.8862 8.39747 15.5534Z'
        fill={color}
      />
    </svg>
  );
};
